// 字段中文标签 + 枚举值映射（由 SQL 注释自动生成）
export const FIELD_LABELS = {
  "BMS": {
    "reportId": "关联 t_period_report.id",
    "online": "在线",
    "Online": "在线",
    "SOC": "电池soc(%)",
    "SOH": "电池soh(%)",
    "rackVoltage": "总电压(V)",
    "RackVoltage": "总电压(V)",
    "rackCurrent": "总电流(A)",
    "RackCurrent": "总电流(A)",
    "rackMaxVoltage": "单体最高电压(mV)",
    "RackMaxVoltage": "单体最高电压(mV)",
    "rackMaxVolCellId": "预留",
    "RackMaxVolCellId": "预留",
    "rackMinVoltage": "单体最低电压(mV)",
    "RackMinVoltage": "单体最低电压(mV)",
    "rackMinVolCellId": "预留",
    "RackMinVolCellId": "预留",
    "rackMaxTemp": "最高单体温度(℃)",
    "RackMaxTemp": "最高单体温度(℃)",
    "rackMaxTempCellId": "预留",
    "RackMaxTempCellId": "预留",
    "rackMinTemp": "最低单体温度(℃)",
    "RackMinTemp": "最低单体温度(℃)",
    "rackMinTempCellId": "预留",
    "RackMinTempCellId": "预留",
    "rackRunState": "预留",
    "RackRunState": "预留",
    "rackInsulatValue": "预留",
    "RackInsulatValue": "预留",
    "rackPosInsulatVal": "预留",
    "RackPosInsulatVal": "预留",
    "rackNegInsulatVal": "预留",
    "RackNegInsulatVal": "预留",
    "rackChgCap": "预留",
    "RackChgCap": "预留",
    "rackDsgCap": "预留",
    "RackDsgCap": "预留",
    "rackOneChgCap": "预留",
    "RackOneChgCap": "预留",
    "rackOneDisCap": "预留",
    "RackOneDisCap": "预留",
    "allChargeVol": "预留",
    "AllChargeVol": "预留",
    "allDisChargeVol": "预留",
    "AllDisChargeVol": "预留",
    "read_15": "主正继电器状态",
    "Read_15": "主正继电器状态",
    "read_16": "主负继电器状态",
    "Read_16": "主负继电器状态",
    "read_17": "主回路预充继电器状态",
    "Read_17": "主回路预充继电器状态",
    "rackState": "电池状态",
    "RackState": "电池状态",
    "READ12": "故障数",
    "rackAverageVolt": "单体平均电压(mV)",
    "RackAverageVolt": "单体平均电压(mV)",
    "READ1": "最高单体电压位置",
    "READ2": "最低单体电压位置",
    "rackAverageTemp": "平均单体温度(℃)",
    "RackAverageTemp": "平均单体温度(℃)",
    "READ3": "最高温度探头位置",
    "READ4": "最低温度探头位置",
    "READ5": "最大脉冲放电电流(A)",
    "READ6": "最大脉冲充电电流(A)",
    "READ7": "最大持续放电电流(A)",
    "READ8": "最大持续充电电流(A)",
    "READ9": "绝缘阻值(预留)",
    "READ10": "故障状态字1",
    "read_1": "电芯温差异常报警",
    "Read_1": "电芯温差异常报警",
    "read_2": "电池温度过高报警",
    "Read_2": "电池温度过高报警",
    "read_3": "电池温度过低报警",
    "Read_3": "电池温度过低报警",
    "read_4": "Pack过压报警",
    "Read_4": "Pack过压报警",
    "read_5": "Pack欠压报警",
    "Read_5": "Pack欠压报警",
    "read_6": "SOC过低报警",
    "Read_6": "SOC过低报警",
    "read_7": "单体电压过高报警",
    "Read_7": "单体电压过高报警",
    "read_8": "单体电压欠压报警",
    "Read_8": "单体电压欠压报警",
    "read_9": "绝缘故障报警",
    "Read_9": "绝缘故障报警",
    "read_10": "电池一致性差报警",
    "Read_10": "电池一致性差报警",
    "read_11": "充电过流报警",
    "Read_11": "充电过流报警",
    "read_12": "放电过流报警",
    "Read_12": "放电过流报警",
    "read_13": "继电器粘连报警",
    "Read_13": "继电器粘连报警",
    "read_14": "预充失败报警",
    "Read_14": "预充失败报警",
    "READ11": "故障状态字2",
    "READ13": "DIO状态字",
    "isPeriod": "是否周期数据"
  },
  "CELL": {
    "reportId": "关联 t_period_report.id",
    "online": "在线",
    "voltageMv": "单体电压(mV)，逗号分隔，按电芯序号排列",
    "temperature": "单体温度(℃)，逗号分隔，按电芯序号排列"
  },
  "PCS": {
    "reportId": "关联 t_period_report.id",
    "online": "在线",
    "Online": "在线",
    "aphaseVoltage": "输出A相电压(V)",
    "AphaseVoltage": "输出A相电压(V)",
    "bphaseVoltage": "输出B相电压(V)",
    "BphaseVoltage": "输出B相电压(V)",
    "cphaseVoltage": "输出C相电压(V)",
    "CphaseVoltage": "输出C相电压(V)",
    "aphaseCurrent": "输出A相电流(A)",
    "AphaseCurrent": "输出A相电流(A)",
    "bphaseCurrent": "输出B相电流(A)",
    "BphaseCurrent": "输出B相电流(A)",
    "cphaseCurrent": "输出C相电流(A)",
    "CphaseCurrent": "输出C相电流(A)",
    "activePower": "交流输出总有功功率(kW)",
    "ActivePower": "交流输出总有功功率(kW)",
    "aphaseActPower": "交流A相有功功率(kW)",
    "AphaseActPower": "交流A相有功功率(kW)",
    "bphaseActPower": "交流B相有功功率(kW)",
    "BphaseActPower": "交流B相有功功率(kW)",
    "cphaseActPower": "交流C相有功功率(kW)",
    "CphaseActPower": "交流C相有功功率(kW)",
    "reactivePower": "交流输出总无功功率(kVar)",
    "ReactivePower": "交流输出总无功功率(kVar)",
    "aphaseReactivePower": "预留",
    "AphaseReactivePower": "预留",
    "bphaseReactivePower": "预留",
    "BphaseReactivePower": "预留",
    "cphaseReactivePower": "预留",
    "CphaseReactivePower": "预留",
    "apparentPower": "交流输出总视在功率(kVA)",
    "ApparentPower": "交流输出总视在功率(kVA)",
    "aphaseApparentPower": "交流A相视在功率(kVA)",
    "AphaseApparentPower": "交流A相视在功率(kVA)",
    "bphaseApparentPower": "交流B相视在功率(kVA)",
    "BphaseApparentPower": "交流B相视在功率(kVA)",
    "cphaseApparentPower": "交流C相视在功率(kVA)",
    "CphaseApparentPower": "交流C相视在功率(kVA)",
    "factor": "预留",
    "Factor": "预留",
    "aphaseFactor": "A相功率因数",
    "AphaseFactor": "A相功率因数",
    "bphaseFactor": "B相功率因数",
    "BphaseFactor": "B相功率因数",
    "cphaseFactor": "C相功率因数",
    "CphaseFactor": "C相功率因数",
    "frequency": "电网频率(Hz)",
    "Frequency": "电网频率(Hz)",
    "runStatu": "工作状态",
    "RunStatu": "工作状态",
    "sysGridstatus": "预留",
    "SysGridstatus": "预留",
    "sysOffGridstatus": "预留",
    "SysOffGridstatus": "预留",
    "controlMode": "预留",
    "ControlMode": "预留",
    "heatSinkTemp": "预留",
    "HeatSinkTemp": "预留",
    "ABphaseVoltage": "输出AB线电压(V)",
    "BCphaseVoltage": "输出BC线电压(V)",
    "CAphaseVoltage": "输出CA线电压(V)",
    "aphaseCurrentdg": "电感A相电流(A)",
    "AphaseCurrentdg": "电感A相电流(A)",
    "bphaseCurrentdg": "电感B相电流(A)",
    "BphaseCurrentdg": "电感B相电流(A)",
    "cphaseCurrentdg": "电感C相电流(A)",
    "CphaseCurrentdg": "电感C相电流(A)",
    "read_1": "当前电网相序",
    "Read_1": "当前电网相序",
    "aphaseReactPower": "交流A相无功功率(kVar)",
    "AphaseReactPower": "交流A相无功功率(kVar)",
    "bphaseReactPower": "交流B相无功功率(kVar)",
    "BphaseReactPower": "交流B相无功功率(kVar)",
    "cphaseReactPower": "交流C相无功功率(kVar)",
    "CphaseReactPower": "交流C相无功功率(kVar)",
    "ACFactor": "交流功率因数",
    "batVolt": "电池电压(V)",
    "BatVolt": "电池电压(V)",
    "batCurr": "电池电流(A)",
    "BatCurr": "电池电流(A)",
    "charDisChar": "充放电状态",
    "CharDisChar": "充放电状态",
    "batPower": "直流功率(kW)",
    "BatPower": "直流功率(kW)",
    "batTCurr": "直流总电流(A)",
    "BatTCurr": "直流总电流(A)",
    "TVolt": "总母线电压(V)",
    "PVolt": "正母线电压(V)",
    "MVolt": "负母线电压(V)",
    "devFault": "系统故障",
    "DevFault": "系统故障",
    "IGBTTemp": "IGBT温度(℃)",
    "ENVemp": "环境温度(℃)",
    "INDemp": "电感温度(℃)",
    "work_pattern": "当前实际充放电工作模式",
    "Work_pattern": "当前实际充放电工作模式",
    "gridOnOff": "并离网状态",
    "GridOnOff": "并离网状态",
    "DSP_V": "DSP版本软件V信息",
    "DSP_B": "DSP版本软件B信息",
    "DSP_D": "DSP版本软件D信息",
    "CPLD_V": "CPLD版本软件V信息",
    "CPLD_B": "CPLD版本软件B信息",
    "CPLD_D": "CPLD版本软件D信息",
    "read_2": "直流历史充电量(kWh)",
    "Read_2": "直流历史充电量(kWh)",
    "read_3": "直流日充电量(kWh)",
    "Read_3": "直流日充电量(kWh)",
    "read_4": "直流历史放电量(kWh)",
    "Read_4": "直流历史放电量(kWh)",
    "read_5": "直流日放电量(kWh)",
    "Read_5": "直流日放电量(kWh)",
    "read_6": "交流历史充电量(kWh)",
    "Read_6": "交流历史充电量(kWh)",
    "read_7": "交流日充电量(kWh)",
    "Read_7": "交流日充电量(kWh)",
    "read_8": "交流历史放电量(kWh)",
    "Read_8": "交流历史放电量(kWh)",
    "read_9": "交流日放电量(kWh)",
    "Read_9": "交流日放电量(kWh)",
    "insulationdetectionvalue_rx": "绝缘检测值Rx(kΩ)",
    "Insulationdetectionvalue_rx": "绝缘检测值Rx(kΩ)",
    "insulationdetectionvalue_ry": "绝缘检测值Ry(kΩ)",
    "Insulationdetectionvalue_ry": "绝缘检测值Ry(kΩ)",
    "hardwareFaultWord1": "硬件故障字1",
    "HardwareFaultWord1": "硬件故障字1",
    "EPOFault": "EPO故障",
    "IGBTHardwareOver": "IGBTOCP故障",
    "busHardwareOver": "母线硬件过压故障",
    "BusHardwareOver": "母线硬件过压故障",
    "waveThrottling": "功率模块逐波限流故障",
    "WaveThrottling": "功率模块逐波限流故障",
    "balanceHardwareOver": "平衡模块硬件过流故障",
    "BalanceHardwareOver": "平衡模块硬件过流故障",
    "hardwareFaultWord2": "硬件故障字2",
    "HardwareFaultWord2": "硬件故障字2",
    "_24VPowerFault": "24V电源故障",
    "24VPowerFault": "24V电源故障",
    "fanFault": "风扇故障",
    "FanFault": "风扇故障",
    "linkFault": "连接故障",
    "LinkFault": "连接故障",
    "outIO3Fault": "外部输入干接点3故障",
    "OutIO3Fault": "外部输入干接点3故障",
    "surgeProtectFault": "电感过温故障标志",
    "SurgeProtectFault": "电感过温故障标志",
    "powerOverHeated": "功率模块过温故障",
    "PowerOverHeated": "功率模块过温故障",
    "balanceOverHeated": "平衡模块过温故障",
    "BalanceOverHeated": "平衡模块过温故障",
    "_15VPowerFault": "15V电源故障",
    "15VPowerFault": "15V电源故障",
    "fireAlarmFault": "系统火警故障",
    "FireAlarmFault": "系统火警故障",
    "outIO1Fault": "外部输入干接点1故障",
    "OutIO1Fault": "外部输入干接点1故障",
    "outIO2Fault": "外部输入干接点2故障",
    "OutIO2Fault": "外部输入干接点2故障",
    "environmentTempHighFault": "环境温度过温故障",
    "EnvironmentTempHighFault": "环境温度过温故障",
    "IOTempHighFault": "干接点过温故障",
    "gridFaultWord": "电网故障字",
    "GridFaultWord": "电网故障字",
    "aphaseOverVoltage": "电网A相过压故障",
    "AphaseOverVoltage": "电网A相过压故障",
    "bphaseOverVoltage": "电网B相过压故障",
    "BphaseOverVoltage": "电网B相过压故障",
    "cphaseOverVoltage": "电网C相过压故障",
    "CphaseOverVoltage": "电网C相过压故障",
    "aphaseUnderVoltage": "电网A相欠压故障",
    "AphaseUnderVoltage": "电网A相欠压故障",
    "bphaseUnderVoltage": "电网B相欠压故障",
    "BphaseUnderVoltage": "电网B相欠压故障",
    "cphaseUnderVoltage": "电网C相欠压故障",
    "CphaseUnderVoltage": "电网C相欠压故障",
    "gridOverFrequency": "电网过频故障",
    "GridOverFrequency": "电网过频故障",
    "gridUnderFrequency": "电网欠频故障",
    "GridUnderFrequency": "电网欠频故障",
    "gridPhaseError": "电网相序错误故障",
    "GridPhaseError": "电网相序错误故障",
    "aphaseSoftOver": "A相软件过流故障",
    "AphaseSoftOver": "A相软件过流故障",
    "bphaseSoftOver": "B相软件过流故障",
    "BphaseSoftOver": "B相软件过流故障",
    "cphaseSoftOver": "C相软件过流故障",
    "CphaseSoftOver": "C相软件过流故障",
    "gridVoltageImbalance": "电网电压不平衡故障",
    "GridVoltageImbalance": "电网电压不平衡故障",
    "gridCurrentImbalance": "电网电流不平衡故障",
    "GridCurrentImbalance": "电网电流不平衡故障",
    "gridPhaseLack": "电网缺相故障",
    "GridPhaseLack": "电网缺相故障",
    "NLineOver": "N线过流故障",
    "busFaultWord": "母线故障字",
    "BusFaultWord": "母线故障字",
    "preBusOvervoltage": "预充母线过压故障",
    "PreBusOvervoltage": "预充母线过压故障",
    "preBusUndervoltage": "预充母线欠压故障",
    "PreBusUndervoltage": "预充母线欠压故障",
    "runBusOvervoltage": "运行母线过压故障",
    "RunBusOvervoltage": "运行母线过压故障",
    "runBusUndervoltage": "运行母线欠压故障",
    "RunBusUndervoltage": "运行母线欠压故障",
    "PNBusImbalance": "正负母线不平衡故障",
    "rackUndervoltage": "电池欠压故障",
    "RackUndervoltage": "电池欠压故障",
    "rackOvervoltage": "电池过压故障",
    "RackOvervoltage": "电池过压故障",
    "DCPreOvercurrent": "直流预充电过流故障",
    "DCOvercurrent": "直流过流故障",
    "balanceSoftOver": "平衡模块软件过流故障",
    "BalanceSoftOver": "平衡模块软件过流故障",
    "rackReverse": "电池反接故障",
    "RackReverse": "电池反接故障",
    "ACCapacitorFaultWord": "交流电容故障字",
    "prechargeTimeOut": "预充电超时故障",
    "PrechargeTimeOut": "预充电超时故障",
    "aphasePrechargeTimeOut": "预充电A相过流故障",
    "AphasePrechargeTimeOut": "预充电A相过流故障",
    "bphasePrechargeTimeOut": "预充电B相过流故障",
    "BphasePrechargeTimeOut": "预充电B相过流故障",
    "cphasePrechargeTimeOut": "预充电C相过流故障",
    "CphasePrechargeTimeOut": "预充电C相过流故障",
    "leakageCurrentPrecharge": "漏电流过流故障",
    "LeakageCurrentPrecharge": "漏电流过流故障",
    "systemFaultWord": "系统故障字",
    "SystemFaultWord": "系统故障字",
    "RAMFault": "控制板RAM故障",
    "EEPROMFault": "控制板EEPROM故障",
    "ADSampleZeroDrift": "AD采样零漂故障",
    "backTelecomFault": "后台通信协议故障",
    "BackTelecomFault": "后台通信协议故障",
    "CANFault": "CAN通信协议故障",
    "CPLDTelecomFault": "CPLD通信协议故障",
    "datalogFault": "DataLog数据故障",
    "DatalogFault": "DataLog数据故障",
    "insulationDetectionFault": "绝缘检测故障",
    "InsulationDetectionFault": "绝缘检测故障",
    "softwareMismatchFault": "软件固件不匹配故障",
    "SoftwareMismatchFault": "软件固件不匹配故障",
    "BMSRackSystemFault": "BMS电池系统故障",
    "STSTelecomFault": "STS通信故障",
    "BMSTelecomFault": "BMS通讯故障",
    "CANTelecomFault": "并机系统从机CAN通信故障",
    "EMSTelecomFault": "EMS通信故障",
    "switchFaultWord": "开关故障字",
    "SwitchFaultWord": "开关故障字",
    "preRelayCloseFail": "预充电继电器闭合故障",
    "PreRelayCloseFail": "预充电继电器闭合故障",
    "preRelayBreakFail": "预充电继电器断开故障",
    "PreRelayBreakFail": "预充电继电器断开故障",
    "preRelayCloseStateErr": "预充电继电器闭合状态故障",
    "PreRelayCloseStateErr": "预充电继电器闭合状态故障",
    "preRelayBreakStateErr": "预充电继电器断开状态故障",
    "PreRelayBreakStateErr": "预充电继电器断开状态故障",
    "mainRelayCloseFail": "主继电器闭合故障",
    "MainRelayCloseFail": "主继电器闭合故障",
    "mainRelayBreakFail": "主继电器断开故障",
    "MainRelayBreakFail": "主继电器断开故障",
    "mainRelayCloseStateErr": "主继电器闭合状态故障",
    "MainRelayCloseStateErr": "主继电器闭合状态故障",
    "mainRelayBreakStateErr": "主继电器断开状态故障",
    "MainRelayBreakStateErr": "主继电器断开状态故障",
    "ACMainRelayStickeFault": "交流主继电器粘连故障",
    "DCRelayOpenCircuitFault": "直流继电器开路故障",
    "ACRelayOpenCircuitFault": "交流主继电器开路故障",
    "otherFaultWord": "其他故障字",
    "OtherFaultWord": "其他故障字",
    "PCSAphaseOvervoltage": "逆变电压A相过压故障",
    "PCSBphaseOvervoltage": "逆变电压B相过压故障",
    "PCSCphaseOvervoltage": "逆变电压C相过压故障",
    "gridIslandFault": "电网孤岛故障",
    "GridIslandFault": "电网孤岛故障",
    "systemResonanceFault": "系统谐振故障",
    "SystemResonanceFault": "系统谐振故障",
    "softwareover": "软件过压过流故障",
    "Softwareover": "软件过压过流故障",
    "highVoltageThroughTimeOut": "高电压穿越超时故障",
    "HighVoltageThroughTimeOut": "高电压穿越超时故障",
    "PCSAphaseUndervoltage": "逆变电压A相欠压故障",
    "PCSBphaseUndervoltage": "逆变电压B相欠压故障",
    "PCSCphaseUndervoltage": "逆变电压C相欠压故障",
    "noSynchronousSignalOffGrid": "离网无同步信号故障",
    "NoSynchronousSignalOffGrid": "离网无同步信号故障",
    "offGridShortCircuit": "离网输出短路故障",
    "OffGridShortCircuit": "离网输出短路故障",
    "lowVoltageThroughTimeOut": "低电压穿越超时故障",
    "LowVoltageThroughTimeOut": "低电压穿越超时故障",
    "modeRunmodesetting": "模式运行模式设置",
    "ModeRunmodesetting": "模式运行模式设置",
    "single_phasepowersetting": "并网单相功率独立控制设置",
    "Single_phasepowersetting": "并网单相功率独立控制设置",
    "currentsourcesetting": "模块电流源并联使能设置",
    "Currentsourcesetting": "模块电流源并联使能设置",
    "settingofparallelmodules": "模块并联台数设置",
    "Settingofparallelmodules": "模块并联台数设置",
    "off_gridvoltagesetting": "离网电压设置",
    "Off_gridvoltagesetting": "离网电压设置",
    "off_gridfrequencysetting": "离网频率设置（Hz）",
    "Off_gridfrequencysetting": "离网频率设置（Hz）",
    "modeHostSetting": "模式主机设置",
    "ModeHostSetting": "模式主机设置",
    "actPowSet": "下设有功充电/放电功率(kW)",
    "ActPowSet": "下设有功充电/放电功率(kW)",
    "reactPowSet": "无功功率补偿功率设置(kVar)",
    "ReactPowSet": "无功功率补偿功率设置(kVar)",
    "ASplitPhaseActPowSet": "A相有功功率给定(kW)",
    "ASplitPhaseReactPowSet": "A相无功功率给定(kVar)",
    "BSplitPhaseActPowSet": "B相有功功率给定(kW)",
    "BSplitPhaseReactPowSet": "B相无功功率给定(kVar)",
    "CSplitPhaseActPowSet": "C相有功功率给定(kW)",
    "CSplitPhaseReactPowSet": "C相无功功率给定(kVar)",
    "startStopCtr": "启停机控制",
    "StartStopCtr": "启停机控制",
    "faultRst": "故障复位指令",
    "FaultRst": "故障复位指令",
    "insulationdetectionenabling": "绝缘检测使能",
    "Insulationdetectionenabling": "绝缘检测使能",
    "DCsourcebusbarvoltagesetting": "DC源母线电压设置(V)",
    "gridoverfrequencyprotection": "电网过频保护(Hz)",
    "Gridoverfrequencyprotection": "电网过频保护(Hz)",
    "gridunderfrequencyprotection": "电网欠频保护(Hz)",
    "Gridunderfrequencyprotection": "电网欠频保护(Hz)",
    "islandoverfrequencyprotect": "孤岛过频保护(Hz)",
    "Islandoverfrequencyprotect": "孤岛过频保护(Hz)",
    "islandunderfrequencyprotect": "孤岛欠频保护(Hz)",
    "Islandunderfrequencyprotect": "孤岛欠频保护(Hz)",
    "batteryovervolprotectpoint": "电池过压保护点(V)",
    "Batteryovervolprotectpoint": "电池过压保护点(V)",
    "batteryundervolprotectpoint": "电池欠压保护点(V)",
    "Batteryundervolprotectpoint": "电池欠压保护点(V)",
    "gridoperationformaxmchar": "并网运行最大充电电流(A)",
    "Gridoperationformaxmchar": "并网运行最大充电电流(A)",
    "busovervoltageprotectionpoint": "母线过压保护点(V)",
    "Busovervoltageprotectionpoint": "母线过压保护点(V)",
    "busundervoltageprotectionpoint": "母线欠压保护点(V)",
    "Busundervoltageprotectionpoint": "母线欠压保护点(V)",
    "DCoverflowprotectionpoint": "直流过流保护点(A)",
    "AClinevolovervoleprotectpoint": "交流线电压过压保护点(V)",
    "AClinevolundervolprotectpoint": "交流线电压欠压保护点(V)",
    "ACovercurprotectpoint": "交流过流保护点(A)",
    "moduleovertempprotectnpoint": "模块过温保护点(℃)",
    "Moduleovertempprotectnpoint": "模块过温保护点(℃)",
    "CC_CVhargingbatteryvolpoint": "恒流转恒压充电电池电压点(V)",
    "batteryconstantvolchargingvol": "电池恒压充电电压(V)",
    "Batteryconstantvolchargingvol": "电池恒压充电电压(V)",
    "maximumtimelimitofCVcharging": "恒压充电最大时间限制(min)",
    "MaximumtimelimitofCVcharging": "恒压充电最大时间限制(min)",
    "CVtofloatingchargingflowpointset": "恒压转浮充电流点设置(A)",
    "batteryfloatingCVpointsetting": "电池浮充电压点设置(V)",
    "BatteryfloatingCVpointsetting": "电池浮充电压点设置(V)",
    "floatingchargetoconstantcurpoint": "浮充转恒流电流点设置(A)",
    "Floatingchargetoconstantcurpoint": "浮充转恒流电流点设置(A)",
    "confirmingparameterinstructions": "固化参数指令",
    "Confirmingparameterinstructions": "固化参数指令",
    "reModbusAddress": "ReModbus地址",
    "ReModbusAddress": "ReModbus地址",
    "reModbusPaudrate": "ReModbus波特率(bps)",
    "ReModbusPaudrate": "ReModbus波特率(bps)",
    "HMIModbusAddress": "HMI Modbus 地址",
    "HMIModbusPaudrate": "HMI Modbus 波特率(bps)",
    "EMScomtimefaultthreshold": "EMS通讯时间故障阈值(s)",
    "batteryResetCommand": "电量清零指令",
    "BatteryResetCommand": "电量清零指令",
    "setInterfaceForSafetyRegulations": "安规一键设置接口",
    "SetInterfaceForSafetyRegulations": "安规一键设置接口",
    "heartbeatSingle": "心跳信号",
    "HeartbeatSingle": "心跳信号"
  },
  "EMS": {
    "reportId": "关联 t_period_report.id",
    "controlMode": "设置工作模式",
    "ControlMode": "设置工作模式",
    "stratagyType": "设置策略模式",
    "StratagyType": "设置策略模式",
    "onOff": "开关机",
    "OnOff": "开关机",
    "iec104Heartbeat": "Iec104 心跳位",
    "Iec104Heartbeat": "Iec104 心跳位",
    "modbusTcpHeartbeat": "ModbusTcp 心跳位",
    "ModbusTcpHeartbeat": "ModbusTcp 心跳位",
    "setPower": "设置有功功率(kW)",
    "SetPower": "设置有功功率(kW)",
    "setRePower": "设置无功功率(kVar)",
    "SetRePower": "设置无功功率(kVar)",
    "s1StHour": "第1段策略开始小时",
    "S1StHour": "第1段策略开始小时",
    "s1StMin": "第1段策略开始分钟",
    "S1StMin": "第1段策略开始分钟",
    "s1EnHour": "第1段策略结束小时",
    "S1EnHour": "第1段策略结束小时",
    "s1EnMin": "第1段策略结束分钟",
    "S1EnMin": "第1段策略结束分钟",
    "s1Power": "第1段执行功率(-充 +放)",
    "S1Power": "第1段执行功率(-充 +放)",
    "s1RePower": "第1段执行无功功率",
    "S1RePower": "第1段执行无功功率",
    "s1SOCUpperLimit": "第1段策略SOC上限",
    "S1SOCUpperLimit": "第1段策略SOC上限",
    "s1SOCLowerLimit": "第1段策略SOC下限",
    "S1SOCLowerLimit": "第1段策略SOC下限",
    "s2StHour": "第2段策略开始小时",
    "S2StHour": "第2段策略开始小时",
    "s2StMin": "第2段策略开始分钟",
    "S2StMin": "第2段策略开始分钟",
    "s2EnHour": "第2段策略结束小时",
    "S2EnHour": "第2段策略结束小时",
    "s2EnMin": "第2段策略结束分钟",
    "S2EnMin": "第2段策略结束分钟",
    "s2Power": "第2段执行功率(-充 +放)",
    "S2Power": "第2段执行功率(-充 +放)",
    "s2RePower": "第2段执行无功功率",
    "S2RePower": "第2段执行无功功率",
    "s2SOCUpperLimit": "第2段策略SOC上限",
    "S2SOCUpperLimit": "第2段策略SOC上限",
    "s2SOCLowerLimit": "第2段策略SOC下限",
    "S2SOCLowerLimit": "第2段策略SOC下限",
    "s3StHour": "第3段策略开始小时",
    "S3StHour": "第3段策略开始小时",
    "s3StMin": "第3段策略开始分钟",
    "S3StMin": "第3段策略开始分钟",
    "s3EnHour": "第3段策略结束小时",
    "S3EnHour": "第3段策略结束小时",
    "s3EnMin": "第3段策略结束分钟",
    "S3EnMin": "第3段策略结束分钟",
    "s3Power": "第3段执行功率(-充 +放)",
    "S3Power": "第3段执行功率(-充 +放)",
    "s3RePower": "第3段执行无功功率",
    "S3RePower": "第3段执行无功功率",
    "s3SOCUpperLimit": "第3段策略SOC上限",
    "S3SOCUpperLimit": "第3段策略SOC上限",
    "s3SOCLowerLimit": "第3段策略SOC下限",
    "S3SOCLowerLimit": "第3段策略SOC下限",
    "s4StHour": "第4段策略开始小时",
    "S4StHour": "第4段策略开始小时",
    "s4StMin": "第4段策略开始分钟",
    "S4StMin": "第4段策略开始分钟",
    "s4EnHour": "第4段策略结束小时",
    "S4EnHour": "第4段策略结束小时",
    "s4EnMin": "第4段策略结束分钟",
    "S4EnMin": "第4段策略结束分钟",
    "s4Power": "第4段执行功率(-充 +放)",
    "S4Power": "第4段执行功率(-充 +放)",
    "s4RePower": "第4段执行无功功率",
    "S4RePower": "第4段执行无功功率",
    "s4SOCUpperLimit": "第4段策略SOC上限",
    "S4SOCUpperLimit": "第4段策略SOC上限",
    "s4SOCLowerLimit": "第4段策略SOC下限",
    "S4SOCLowerLimit": "第4段策略SOC下限",
    "s5StHour": "第5段策略开始小时",
    "S5StHour": "第5段策略开始小时",
    "s5StMin": "第5段策略开始分钟",
    "S5StMin": "第5段策略开始分钟",
    "s5EnHour": "第5段策略结束小时",
    "S5EnHour": "第5段策略结束小时",
    "s5EnMin": "第5段策略结束分钟",
    "S5EnMin": "第5段策略结束分钟",
    "s5Power": "第5段执行功率(-充 +放)",
    "S5Power": "第5段执行功率(-充 +放)",
    "s5RePower": "第5段执行无功功率",
    "S5RePower": "第5段执行无功功率",
    "s5SOCUpperLimit": "第5段策略SOC上限",
    "S5SOCUpperLimit": "第5段策略SOC上限",
    "s5SOCLowerLimit": "第5段策略SOC下限",
    "S5SOCLowerLimit": "第5段策略SOC下限",
    "s6StHour": "第6段策略开始小时",
    "S6StHour": "第6段策略开始小时",
    "s6StMin": "第6段策略开始分钟",
    "S6StMin": "第6段策略开始分钟",
    "s6EnHour": "第6段策略结束小时",
    "S6EnHour": "第6段策略结束小时",
    "s6EnMin": "第6段策略结束分钟",
    "S6EnMin": "第6段策略结束分钟",
    "s6Power": "第6段执行功率(-充 +放)",
    "S6Power": "第6段执行功率(-充 +放)",
    "s6RePower": "第6段执行无功功率",
    "S6RePower": "第6段执行无功功率",
    "s6SOCUpperLimit": "第6段策略SOC上限",
    "S6SOCUpperLimit": "第6段策略SOC上限",
    "s6SOCLowerLimit": "第6段策略SOC下限",
    "S6SOCLowerLimit": "第6段策略SOC下限",
    "s7StHour": "第7段策略开始小时",
    "S7StHour": "第7段策略开始小时",
    "s7StMin": "第7段策略开始分钟",
    "S7StMin": "第7段策略开始分钟",
    "s7EnHour": "第7段策略结束小时",
    "S7EnHour": "第7段策略结束小时",
    "s7EnMin": "第7段策略结束分钟",
    "S7EnMin": "第7段策略结束分钟",
    "s7Power": "第7段执行功率(-充 +放)",
    "S7Power": "第7段执行功率(-充 +放)",
    "s7RePower": "第7段执行无功功率",
    "S7RePower": "第7段执行无功功率",
    "s7SOCUpperLimit": "第7段策略SOC上限",
    "S7SOCUpperLimit": "第7段策略SOC上限",
    "s7SOCLowerLimit": "第7段策略SOC下限",
    "S7SOCLowerLimit": "第7段策略SOC下限",
    "s8StHour": "第8段策略开始小时",
    "S8StHour": "第8段策略开始小时",
    "s8StMin": "第8段策略开始分钟",
    "S8StMin": "第8段策略开始分钟",
    "s8EnHour": "第8段策略结束小时",
    "S8EnHour": "第8段策略结束小时",
    "s8EnMin": "第8段策略结束分钟",
    "S8EnMin": "第8段策略结束分钟",
    "s8Power": "第8段执行功率(-充 +放)",
    "S8Power": "第8段执行功率(-充 +放)",
    "s8RePower": "第8段执行无功功率",
    "S8RePower": "第8段执行无功功率",
    "s8SOCUpperLimit": "第8段策略SOC上限",
    "S8SOCUpperLimit": "第8段策略SOC上限",
    "s8SOCLowerLimit": "第8段策略SOC下限",
    "S8SOCLowerLimit": "第8段策略SOC下限",
    "s9StHour": "第9段策略开始小时",
    "S9StHour": "第9段策略开始小时",
    "s9StMin": "第9段策略开始分钟",
    "S9StMin": "第9段策略开始分钟",
    "s9EnHour": "第9段策略结束小时",
    "S9EnHour": "第9段策略结束小时",
    "s9EnMin": "第9段策略结束分钟",
    "S9EnMin": "第9段策略结束分钟",
    "s9Power": "第9段执行功率(-充 +放)",
    "S9Power": "第9段执行功率(-充 +放)",
    "s9RePower": "第9段执行无功功率",
    "S9RePower": "第9段执行无功功率",
    "s9SOCUpperLimit": "第9段策略SOC上限",
    "S9SOCUpperLimit": "第9段策略SOC上限",
    "s9SOCLowerLimit": "第9段策略SOC下限",
    "S9SOCLowerLimit": "第9段策略SOC下限",
    "s10StHour": "第10段策略开始小时",
    "S10StHour": "第10段策略开始小时",
    "s10StMin": "第10段策略开始分钟",
    "S10StMin": "第10段策略开始分钟",
    "s10EnHour": "第10段策略结束小时",
    "S10EnHour": "第10段策略结束小时",
    "s10EnMin": "第10段策略结束分钟",
    "S10EnMin": "第10段策略结束分钟",
    "s10Power": "第10段执行功率(-充 +放)",
    "S10Power": "第10段执行功率(-充 +放)",
    "s10RePower": "第10段执行无功功率",
    "S10RePower": "第10段执行无功功率",
    "s10SOCUpperLimit": "第10段策略SOC上限",
    "S10SOCUpperLimit": "第10段策略SOC上限",
    "s10SOCLowerLimit": "第10段策略SOC下限",
    "S10SOCLowerLimit": "第10段策略SOC下限",
    "s11StHour": "第11段策略开始小时",
    "S11StHour": "第11段策略开始小时",
    "s11StMin": "第11段策略开始分钟",
    "S11StMin": "第11段策略开始分钟",
    "s11EnHour": "第11段策略结束小时",
    "S11EnHour": "第11段策略结束小时",
    "s11EnMin": "第11段策略结束分钟",
    "S11EnMin": "第11段策略结束分钟",
    "s11Power": "第11段执行功率(-充 +放)",
    "S11Power": "第11段执行功率(-充 +放)",
    "s11RePower": "第11段执行无功功率",
    "S11RePower": "第11段执行无功功率",
    "s11SOCUpperLimit": "第11段策略SOC上限",
    "S11SOCUpperLimit": "第11段策略SOC上限",
    "s11SOCLowerLimit": "第11段策略SOC下限",
    "S11SOCLowerLimit": "第11段策略SOC下限",
    "s12StHour": "第12段策略开始小时",
    "S12StHour": "第12段策略开始小时",
    "s12StMin": "第12段策略开始分钟",
    "S12StMin": "第12段策略开始分钟",
    "s12EnHour": "第12段策略结束小时",
    "S12EnHour": "第12段策略结束小时",
    "s12EnMin": "第12段策略结束分钟",
    "S12EnMin": "第12段策略结束分钟",
    "s12Power": "第12段执行功率(-充 +放)",
    "S12Power": "第12段执行功率(-充 +放)",
    "s12RePower": "第12段执行无功功率",
    "S12RePower": "第12段执行无功功率",
    "s12SOCUpperLimit": "第12段策略SOC上限",
    "S12SOCUpperLimit": "第12段策略SOC上限",
    "s12SOCLowerLimit": "第12段策略SOC下限",
    "S12SOCLowerLimit": "第12段策略SOC下限",
    "s13StHour": "第13段策略开始小时",
    "S13StHour": "第13段策略开始小时",
    "s13StMin": "第13段策略开始分钟",
    "S13StMin": "第13段策略开始分钟",
    "s13EnHour": "第13段策略结束小时",
    "S13EnHour": "第13段策略结束小时",
    "s13EnMin": "第13段策略结束分钟",
    "S13EnMin": "第13段策略结束分钟",
    "s13Power": "第13段执行功率(-充 +放)",
    "S13Power": "第13段执行功率(-充 +放)",
    "s13RePower": "第13段执行无功功率",
    "S13RePower": "第13段执行无功功率",
    "s13SOCUpperLimit": "第13段策略SOC上限",
    "S13SOCUpperLimit": "第13段策略SOC上限",
    "s13SOCLowerLimit": "第13段策略SOC下限",
    "S13SOCLowerLimit": "第13段策略SOC下限",
    "s14StHour": "第14段策略开始小时",
    "S14StHour": "第14段策略开始小时",
    "s14StMin": "第14段策略开始分钟",
    "S14StMin": "第14段策略开始分钟",
    "s14EnHour": "第14段策略结束小时",
    "S14EnHour": "第14段策略结束小时",
    "s14EnMin": "第14段策略结束分钟",
    "S14EnMin": "第14段策略结束分钟",
    "s14Power": "第14段执行功率(-充 +放)",
    "S14Power": "第14段执行功率(-充 +放)",
    "s14RePower": "第14段执行无功功率",
    "S14RePower": "第14段执行无功功率",
    "s14SOCUpperLimit": "第14段策略SOC上限",
    "S14SOCUpperLimit": "第14段策略SOC上限",
    "s14SOCLowerLimit": "第14段策略SOC下限",
    "S14SOCLowerLimit": "第14段策略SOC下限",
    "s15StHour": "第15段策略开始小时",
    "S15StHour": "第15段策略开始小时",
    "s15StMin": "第15段策略开始分钟",
    "S15StMin": "第15段策略开始分钟",
    "s15EnHour": "第15段策略结束小时",
    "S15EnHour": "第15段策略结束小时",
    "s15EnMin": "第15段策略结束分钟",
    "S15EnMin": "第15段策略结束分钟",
    "s15Power": "第15段执行功率(-充 +放)",
    "S15Power": "第15段执行功率(-充 +放)",
    "s15RePower": "第15段执行无功功率",
    "S15RePower": "第15段执行无功功率",
    "s15SOCUpperLimit": "第15段策略SOC上限",
    "S15SOCUpperLimit": "第15段策略SOC上限",
    "s15SOCLowerLimit": "第15段策略SOC下限",
    "S15SOCLowerLimit": "第15段策略SOC下限",
    "s16StHour": "第16段策略开始小时",
    "S16StHour": "第16段策略开始小时",
    "s16StMin": "第16段策略开始分钟",
    "S16StMin": "第16段策略开始分钟",
    "s16EnHour": "第16段策略结束小时",
    "S16EnHour": "第16段策略结束小时",
    "s16EnMin": "第16段策略结束分钟",
    "S16EnMin": "第16段策略结束分钟",
    "s16Power": "第16段执行功率(-充 +放)",
    "S16Power": "第16段执行功率(-充 +放)",
    "s16RePower": "第16段执行无功功率",
    "S16RePower": "第16段执行无功功率",
    "s16SOCUpperLimit": "第16段策略SOC上限",
    "S16SOCUpperLimit": "第16段策略SOC上限",
    "s16SOCLowerLimit": "第16段策略SOC下限",
    "S16SOCLowerLimit": "第16段策略SOC下限",
    "s17StHour": "第17段策略开始小时",
    "S17StHour": "第17段策略开始小时",
    "s17StMin": "第17段策略开始分钟",
    "S17StMin": "第17段策略开始分钟",
    "s17EnHour": "第17段策略结束小时",
    "S17EnHour": "第17段策略结束小时",
    "s17EnMin": "第17段策略结束分钟",
    "S17EnMin": "第17段策略结束分钟",
    "s17Power": "第17段执行功率(-充 +放)",
    "S17Power": "第17段执行功率(-充 +放)",
    "s17RePower": "第17段执行无功功率",
    "S17RePower": "第17段执行无功功率",
    "s17SOCUpperLimit": "第17段策略SOC上限",
    "S17SOCUpperLimit": "第17段策略SOC上限",
    "s17SOCLowerLimit": "第17段策略SOC下限",
    "S17SOCLowerLimit": "第17段策略SOC下限",
    "s18StHour": "第18段策略开始小时",
    "S18StHour": "第18段策略开始小时",
    "s18StMin": "第18段策略开始分钟",
    "S18StMin": "第18段策略开始分钟",
    "s18EnHour": "第18段策略结束小时",
    "S18EnHour": "第18段策略结束小时",
    "s18EnMin": "第18段策略结束分钟",
    "S18EnMin": "第18段策略结束分钟",
    "s18Power": "第18段执行功率(-充 +放)",
    "S18Power": "第18段执行功率(-充 +放)",
    "s18RePower": "第18段执行无功功率",
    "S18RePower": "第18段执行无功功率",
    "s18SOCUpperLimit": "第18段策略SOC上限",
    "S18SOCUpperLimit": "第18段策略SOC上限",
    "s18SOCLowerLimit": "第18段策略SOC下限",
    "S18SOCLowerLimit": "第18段策略SOC下限",
    "s19StHour": "第19段策略开始小时",
    "S19StHour": "第19段策略开始小时",
    "s19StMin": "第19段策略开始分钟",
    "S19StMin": "第19段策略开始分钟",
    "s19EnHour": "第19段策略结束小时",
    "S19EnHour": "第19段策略结束小时",
    "s19EnMin": "第19段策略结束分钟",
    "S19EnMin": "第19段策略结束分钟",
    "s19Power": "第19段执行功率(-充 +放)",
    "S19Power": "第19段执行功率(-充 +放)",
    "s19RePower": "第19段执行无功功率",
    "S19RePower": "第19段执行无功功率",
    "s19SOCUpperLimit": "第19段策略SOC上限",
    "S19SOCUpperLimit": "第19段策略SOC上限",
    "s19SOCLowerLimit": "第19段策略SOC下限",
    "S19SOCLowerLimit": "第19段策略SOC下限",
    "s20StHour": "第20段策略开始小时",
    "S20StHour": "第20段策略开始小时",
    "s20StMin": "第20段策略开始分钟",
    "S20StMin": "第20段策略开始分钟",
    "s20EnHour": "第20段策略结束小时",
    "S20EnHour": "第20段策略结束小时",
    "s20EnMin": "第20段策略结束分钟",
    "S20EnMin": "第20段策略结束分钟",
    "s20Power": "第20段执行功率(-充 +放)",
    "S20Power": "第20段执行功率(-充 +放)",
    "s20RePower": "第20段执行无功功率",
    "S20RePower": "第20段执行无功功率",
    "s20SOCUpperLimit": "第20段策略SOC上限",
    "S20SOCUpperLimit": "第20段策略SOC上限",
    "s20SOCLowerLimit": "第20段策略SOC下限",
    "S20SOCLowerLimit": "第20段策略SOC下限",
    "s21StHour": "第21段策略开始小时",
    "S21StHour": "第21段策略开始小时",
    "s21StMin": "第21段策略开始分钟",
    "S21StMin": "第21段策略开始分钟",
    "s21EnHour": "第21段策略结束小时",
    "S21EnHour": "第21段策略结束小时",
    "s21EnMin": "第21段策略结束分钟",
    "S21EnMin": "第21段策略结束分钟",
    "s21Power": "第21段执行功率(-充 +放)",
    "S21Power": "第21段执行功率(-充 +放)",
    "s21RePower": "第21段执行无功功率",
    "S21RePower": "第21段执行无功功率",
    "s21SOCUpperLimit": "第21段策略SOC上限",
    "S21SOCUpperLimit": "第21段策略SOC上限",
    "s21SOCLowerLimit": "第21段策略SOC下限",
    "S21SOCLowerLimit": "第21段策略SOC下限",
    "s22StHour": "第22段策略开始小时",
    "S22StHour": "第22段策略开始小时",
    "s22StMin": "第22段策略开始分钟",
    "S22StMin": "第22段策略开始分钟",
    "s22EnHour": "第22段策略结束小时",
    "S22EnHour": "第22段策略结束小时",
    "s22EnMin": "第22段策略结束分钟",
    "S22EnMin": "第22段策略结束分钟",
    "s22Power": "第22段执行功率(-充 +放)",
    "S22Power": "第22段执行功率(-充 +放)",
    "s22RePower": "第22段执行无功功率",
    "S22RePower": "第22段执行无功功率",
    "s22SOCUpperLimit": "第22段策略SOC上限",
    "S22SOCUpperLimit": "第22段策略SOC上限",
    "s22SOCLowerLimit": "第22段策略SOC下限",
    "S22SOCLowerLimit": "第22段策略SOC下限",
    "s23StHour": "第23段策略开始小时",
    "S23StHour": "第23段策略开始小时",
    "s23StMin": "第23段策略开始分钟",
    "S23StMin": "第23段策略开始分钟",
    "s23EnHour": "第23段策略结束小时",
    "S23EnHour": "第23段策略结束小时",
    "s23EnMin": "第23段策略结束分钟",
    "S23EnMin": "第23段策略结束分钟",
    "s23Power": "第23段执行功率(-充 +放)",
    "S23Power": "第23段执行功率(-充 +放)",
    "s23RePower": "第23段执行无功功率",
    "S23RePower": "第23段执行无功功率",
    "s23SOCUpperLimit": "第23段策略SOC上限",
    "S23SOCUpperLimit": "第23段策略SOC上限",
    "s23SOCLowerLimit": "第23段策略SOC下限",
    "S23SOCLowerLimit": "第23段策略SOC下限",
    "s24StHour": "第24段策略开始小时",
    "S24StHour": "第24段策略开始小时",
    "s24StMin": "第24段策略开始分钟",
    "S24StMin": "第24段策略开始分钟",
    "s24EnHour": "第24段策略结束小时",
    "S24EnHour": "第24段策略结束小时",
    "s24EnMin": "第24段策略结束分钟",
    "S24EnMin": "第24段策略结束分钟",
    "s24Power": "第24段执行功率(-充 +放)",
    "S24Power": "第24段执行功率(-充 +放)",
    "s24RePower": "第24段执行无功功率",
    "S24RePower": "第24段执行无功功率",
    "s24SOCUpperLimit": "第24段策略SOC上限",
    "S24SOCUpperLimit": "第24段策略SOC上限",
    "s24SOCLowerLimit": "第24段策略SOC下限",
    "S24SOCLowerLimit": "第24段策略SOC下限",
    "s25StHour": "第25段策略开始小时",
    "S25StHour": "第25段策略开始小时",
    "s25StMin": "第25段策略开始分钟",
    "S25StMin": "第25段策略开始分钟",
    "s25EnHour": "第25段策略结束小时",
    "S25EnHour": "第25段策略结束小时",
    "s25EnMin": "第25段策略结束分钟",
    "S25EnMin": "第25段策略结束分钟",
    "s25Power": "第25段执行功率(-充 +放)",
    "S25Power": "第25段执行功率(-充 +放)",
    "s25RePower": "第25段执行无功功率",
    "S25RePower": "第25段执行无功功率",
    "s25SOCUpperLimit": "第25段策略SOC上限",
    "S25SOCUpperLimit": "第25段策略SOC上限",
    "s25SOCLowerLimit": "第25段策略SOC下限",
    "S25SOCLowerLimit": "第25段策略SOC下限",
    "s26StHour": "第26段策略开始小时",
    "S26StHour": "第26段策略开始小时",
    "s26StMin": "第26段策略开始分钟",
    "S26StMin": "第26段策略开始分钟",
    "s26EnHour": "第26段策略结束小时",
    "S26EnHour": "第26段策略结束小时",
    "s26EnMin": "第26段策略结束分钟",
    "S26EnMin": "第26段策略结束分钟",
    "s26Power": "第26段执行功率(-充 +放)",
    "S26Power": "第26段执行功率(-充 +放)",
    "s26RePower": "第26段执行无功功率",
    "S26RePower": "第26段执行无功功率",
    "s26SOCUpperLimit": "第26段策略SOC上限",
    "S26SOCUpperLimit": "第26段策略SOC上限",
    "s26SOCLowerLimit": "第26段策略SOC下限",
    "S26SOCLowerLimit": "第26段策略SOC下限",
    "s27StHour": "第27段策略开始小时",
    "S27StHour": "第27段策略开始小时",
    "s27StMin": "第27段策略开始分钟",
    "S27StMin": "第27段策略开始分钟",
    "s27EnHour": "第27段策略结束小时",
    "S27EnHour": "第27段策略结束小时",
    "s27EnMin": "第27段策略结束分钟",
    "S27EnMin": "第27段策略结束分钟",
    "s27Power": "第27段执行功率(-充 +放)",
    "S27Power": "第27段执行功率(-充 +放)",
    "s27RePower": "第27段执行无功功率",
    "S27RePower": "第27段执行无功功率",
    "s27SOCUpperLimit": "第27段策略SOC上限",
    "S27SOCUpperLimit": "第27段策略SOC上限",
    "s27SOCLowerLimit": "第27段策略SOC下限",
    "S27SOCLowerLimit": "第27段策略SOC下限",
    "s28StHour": "第28段策略开始小时",
    "S28StHour": "第28段策略开始小时",
    "s28StMin": "第28段策略开始分钟",
    "S28StMin": "第28段策略开始分钟",
    "s28EnHour": "第28段策略结束小时",
    "S28EnHour": "第28段策略结束小时",
    "s28EnMin": "第28段策略结束分钟",
    "S28EnMin": "第28段策略结束分钟",
    "s28Power": "第28段执行功率(-充 +放)",
    "S28Power": "第28段执行功率(-充 +放)",
    "s28RePower": "第28段执行无功功率",
    "S28RePower": "第28段执行无功功率",
    "s28SOCUpperLimit": "第28段策略SOC上限",
    "S28SOCUpperLimit": "第28段策略SOC上限",
    "s28SOCLowerLimit": "第28段策略SOC下限",
    "S28SOCLowerLimit": "第28段策略SOC下限",
    "s29StHour": "第29段策略开始小时",
    "S29StHour": "第29段策略开始小时",
    "s29StMin": "第29段策略开始分钟",
    "S29StMin": "第29段策略开始分钟",
    "s29EnHour": "第29段策略结束小时",
    "S29EnHour": "第29段策略结束小时",
    "s29EnMin": "第29段策略结束分钟",
    "S29EnMin": "第29段策略结束分钟",
    "s29Power": "第29段执行功率(-充 +放)",
    "S29Power": "第29段执行功率(-充 +放)",
    "s29RePower": "第29段执行无功功率",
    "S29RePower": "第29段执行无功功率",
    "s29SOCUpperLimit": "第29段策略SOC上限",
    "S29SOCUpperLimit": "第29段策略SOC上限",
    "s29SOCLowerLimit": "第29段策略SOC下限",
    "S29SOCLowerLimit": "第29段策略SOC下限",
    "s30StHour": "第30段策略开始小时",
    "S30StHour": "第30段策略开始小时",
    "s30StMin": "第30段策略开始分钟",
    "S30StMin": "第30段策略开始分钟",
    "s30EnHour": "第30段策略结束小时",
    "S30EnHour": "第30段策略结束小时",
    "s30EnMin": "第30段策略结束分钟",
    "S30EnMin": "第30段策略结束分钟",
    "s30Power": "第30段执行功率(-充 +放)",
    "S30Power": "第30段执行功率(-充 +放)",
    "s30RePower": "第30段执行无功功率",
    "S30RePower": "第30段执行无功功率",
    "s30SOCUpperLimit": "第30段策略SOC上限",
    "S30SOCUpperLimit": "第30段策略SOC上限",
    "s30SOCLowerLimit": "第30段策略SOC下限",
    "S30SOCLowerLimit": "第30段策略SOC下限",
    "s31StHour": "第31段策略开始小时",
    "S31StHour": "第31段策略开始小时",
    "s31StMin": "第31段策略开始分钟",
    "S31StMin": "第31段策略开始分钟",
    "s31EnHour": "第31段策略结束小时",
    "S31EnHour": "第31段策略结束小时",
    "s31EnMin": "第31段策略结束分钟",
    "S31EnMin": "第31段策略结束分钟",
    "s31Power": "第31段执行功率(-充 +放)",
    "S31Power": "第31段执行功率(-充 +放)",
    "s31RePower": "第31段执行无功功率",
    "S31RePower": "第31段执行无功功率",
    "s31SOCUpperLimit": "第31段策略SOC上限",
    "S31SOCUpperLimit": "第31段策略SOC上限",
    "s31SOCLowerLimit": "第31段策略SOC下限",
    "S31SOCLowerLimit": "第31段策略SOC下限",
    "s32StHour": "第32段策略开始小时",
    "S32StHour": "第32段策略开始小时",
    "s32StMin": "第32段策略开始分钟",
    "S32StMin": "第32段策略开始分钟",
    "s32EnHour": "第32段策略结束小时",
    "S32EnHour": "第32段策略结束小时",
    "s32EnMin": "第32段策略结束分钟",
    "S32EnMin": "第32段策略结束分钟",
    "s32Power": "第32段执行功率(-充 +放)",
    "S32Power": "第32段执行功率(-充 +放)",
    "s32RePower": "第32段执行无功功率",
    "S32RePower": "第32段执行无功功率",
    "s32SOCUpperLimit": "第32段策略SOC上限",
    "S32SOCUpperLimit": "第32段策略SOC上限",
    "s32SOCLowerLimit": "第32段策略SOC下限",
    "S32SOCLowerLimit": "第32段策略SOC下限",
    "s33StHour": "第33段策略开始小时",
    "S33StHour": "第33段策略开始小时",
    "s33StMin": "第33段策略开始分钟",
    "S33StMin": "第33段策略开始分钟",
    "s33EnHour": "第33段策略结束小时",
    "S33EnHour": "第33段策略结束小时",
    "s33EnMin": "第33段策略结束分钟",
    "S33EnMin": "第33段策略结束分钟",
    "s33Power": "第33段执行功率(-充 +放)",
    "S33Power": "第33段执行功率(-充 +放)",
    "s33RePower": "第33段执行无功功率",
    "S33RePower": "第33段执行无功功率",
    "s33SOCUpperLimit": "第33段策略SOC上限",
    "S33SOCUpperLimit": "第33段策略SOC上限",
    "s33SOCLowerLimit": "第33段策略SOC下限",
    "S33SOCLowerLimit": "第33段策略SOC下限",
    "s34StHour": "第34段策略开始小时",
    "S34StHour": "第34段策略开始小时",
    "s34StMin": "第34段策略开始分钟",
    "S34StMin": "第34段策略开始分钟",
    "s34EnHour": "第34段策略结束小时",
    "S34EnHour": "第34段策略结束小时",
    "s34EnMin": "第34段策略结束分钟",
    "S34EnMin": "第34段策略结束分钟",
    "s34Power": "第34段执行功率(-充 +放)",
    "S34Power": "第34段执行功率(-充 +放)",
    "s34RePower": "第34段执行无功功率",
    "S34RePower": "第34段执行无功功率",
    "s34SOCUpperLimit": "第34段策略SOC上限",
    "S34SOCUpperLimit": "第34段策略SOC上限",
    "s34SOCLowerLimit": "第34段策略SOC下限",
    "S34SOCLowerLimit": "第34段策略SOC下限",
    "s35StHour": "第35段策略开始小时",
    "S35StHour": "第35段策略开始小时",
    "s35StMin": "第35段策略开始分钟",
    "S35StMin": "第35段策略开始分钟",
    "s35EnHour": "第35段策略结束小时",
    "S35EnHour": "第35段策略结束小时",
    "s35EnMin": "第35段策略结束分钟",
    "S35EnMin": "第35段策略结束分钟",
    "s35Power": "第35段执行功率(-充 +放)",
    "S35Power": "第35段执行功率(-充 +放)",
    "s35RePower": "第35段执行无功功率",
    "S35RePower": "第35段执行无功功率",
    "s35SOCUpperLimit": "第35段策略SOC上限",
    "S35SOCUpperLimit": "第35段策略SOC上限",
    "s35SOCLowerLimit": "第35段策略SOC下限",
    "S35SOCLowerLimit": "第35段策略SOC下限",
    "s36StHour": "第36段策略开始小时",
    "S36StHour": "第36段策略开始小时",
    "s36StMin": "第36段策略开始分钟",
    "S36StMin": "第36段策略开始分钟",
    "s36EnHour": "第36段策略结束小时",
    "S36EnHour": "第36段策略结束小时",
    "s36EnMin": "第36段策略结束分钟",
    "S36EnMin": "第36段策略结束分钟",
    "s36Power": "第36段执行功率(-充 +放)",
    "S36Power": "第36段执行功率(-充 +放)",
    "s36RePower": "第36段执行无功功率",
    "S36RePower": "第36段执行无功功率",
    "s36SOCUpperLimit": "第36段策略SOC上限",
    "S36SOCUpperLimit": "第36段策略SOC上限",
    "s36SOCLowerLimit": "第36段策略SOC下限",
    "S36SOCLowerLimit": "第36段策略SOC下限",
    "s37StHour": "第37段策略开始小时",
    "S37StHour": "第37段策略开始小时",
    "s37StMin": "第37段策略开始分钟",
    "S37StMin": "第37段策略开始分钟",
    "s37EnHour": "第37段策略结束小时",
    "S37EnHour": "第37段策略结束小时",
    "s37EnMin": "第37段策略结束分钟",
    "S37EnMin": "第37段策略结束分钟",
    "s37Power": "第37段执行功率(-充 +放)",
    "S37Power": "第37段执行功率(-充 +放)",
    "s37RePower": "第37段执行无功功率",
    "S37RePower": "第37段执行无功功率",
    "s37SOCUpperLimit": "第37段策略SOC上限",
    "S37SOCUpperLimit": "第37段策略SOC上限",
    "s37SOCLowerLimit": "第37段策略SOC下限",
    "S37SOCLowerLimit": "第37段策略SOC下限",
    "s38StHour": "第38段策略开始小时",
    "S38StHour": "第38段策略开始小时",
    "s38StMin": "第38段策略开始分钟",
    "S38StMin": "第38段策略开始分钟",
    "s38EnHour": "第38段策略结束小时",
    "S38EnHour": "第38段策略结束小时",
    "s38EnMin": "第38段策略结束分钟",
    "S38EnMin": "第38段策略结束分钟",
    "s38Power": "第38段执行功率(-充 +放)",
    "S38Power": "第38段执行功率(-充 +放)",
    "s38RePower": "第38段执行无功功率",
    "S38RePower": "第38段执行无功功率",
    "s38SOCUpperLimit": "第38段策略SOC上限",
    "S38SOCUpperLimit": "第38段策略SOC上限",
    "s38SOCLowerLimit": "第38段策略SOC下限",
    "S38SOCLowerLimit": "第38段策略SOC下限",
    "s39StHour": "第39段策略开始小时",
    "S39StHour": "第39段策略开始小时",
    "s39StMin": "第39段策略开始分钟",
    "S39StMin": "第39段策略开始分钟",
    "s39EnHour": "第39段策略结束小时",
    "S39EnHour": "第39段策略结束小时",
    "s39EnMin": "第39段策略结束分钟",
    "S39EnMin": "第39段策略结束分钟",
    "s39Power": "第39段执行功率(-充 +放)",
    "S39Power": "第39段执行功率(-充 +放)",
    "s39RePower": "第39段执行无功功率",
    "S39RePower": "第39段执行无功功率",
    "s39SOCUpperLimit": "第39段策略SOC上限",
    "S39SOCUpperLimit": "第39段策略SOC上限",
    "s39SOCLowerLimit": "第39段策略SOC下限",
    "S39SOCLowerLimit": "第39段策略SOC下限",
    "s40StHour": "第40段策略开始小时",
    "S40StHour": "第40段策略开始小时",
    "s40StMin": "第40段策略开始分钟",
    "S40StMin": "第40段策略开始分钟",
    "s40EnHour": "第40段策略结束小时",
    "S40EnHour": "第40段策略结束小时",
    "s40EnMin": "第40段策略结束分钟",
    "S40EnMin": "第40段策略结束分钟",
    "s40Power": "第40段执行功率(-充 +放)",
    "S40Power": "第40段执行功率(-充 +放)",
    "s40RePower": "第40段执行无功功率",
    "S40RePower": "第40段执行无功功率",
    "s40SOCUpperLimit": "第40段策略SOC上限",
    "S40SOCUpperLimit": "第40段策略SOC上限",
    "s40SOCLowerLimit": "第40段策略SOC下限",
    "S40SOCLowerLimit": "第40段策略SOC下限",
    "s41StHour": "第41段策略开始小时",
    "S41StHour": "第41段策略开始小时",
    "s41StMin": "第41段策略开始分钟",
    "S41StMin": "第41段策略开始分钟",
    "s41EnHour": "第41段策略结束小时",
    "S41EnHour": "第41段策略结束小时",
    "s41EnMin": "第41段策略结束分钟",
    "S41EnMin": "第41段策略结束分钟",
    "s41Power": "第41段执行功率(-充 +放)",
    "S41Power": "第41段执行功率(-充 +放)",
    "s41RePower": "第41段执行无功功率",
    "S41RePower": "第41段执行无功功率",
    "s41SOCUpperLimit": "第41段策略SOC上限",
    "S41SOCUpperLimit": "第41段策略SOC上限",
    "s41SOCLowerLimit": "第41段策略SOC下限",
    "S41SOCLowerLimit": "第41段策略SOC下限",
    "s42StHour": "第42段策略开始小时",
    "S42StHour": "第42段策略开始小时",
    "s42StMin": "第42段策略开始分钟",
    "S42StMin": "第42段策略开始分钟",
    "s42EnHour": "第42段策略结束小时",
    "S42EnHour": "第42段策略结束小时",
    "s42EnMin": "第42段策略结束分钟",
    "S42EnMin": "第42段策略结束分钟",
    "s42Power": "第42段执行功率(-充 +放)",
    "S42Power": "第42段执行功率(-充 +放)",
    "s42RePower": "第42段执行无功功率",
    "S42RePower": "第42段执行无功功率",
    "s42SOCUpperLimit": "第42段策略SOC上限",
    "S42SOCUpperLimit": "第42段策略SOC上限",
    "s42SOCLowerLimit": "第42段策略SOC下限",
    "S42SOCLowerLimit": "第42段策略SOC下限",
    "s43StHour": "第43段策略开始小时",
    "S43StHour": "第43段策略开始小时",
    "s43StMin": "第43段策略开始分钟",
    "S43StMin": "第43段策略开始分钟",
    "s43EnHour": "第43段策略结束小时",
    "S43EnHour": "第43段策略结束小时",
    "s43EnMin": "第43段策略结束分钟",
    "S43EnMin": "第43段策略结束分钟",
    "s43Power": "第43段执行功率(-充 +放)",
    "S43Power": "第43段执行功率(-充 +放)",
    "s43RePower": "第43段执行无功功率",
    "S43RePower": "第43段执行无功功率",
    "s43SOCUpperLimit": "第43段策略SOC上限",
    "S43SOCUpperLimit": "第43段策略SOC上限",
    "s43SOCLowerLimit": "第43段策略SOC下限",
    "S43SOCLowerLimit": "第43段策略SOC下限",
    "s44StHour": "第44段策略开始小时",
    "S44StHour": "第44段策略开始小时",
    "s44StMin": "第44段策略开始分钟",
    "S44StMin": "第44段策略开始分钟",
    "s44EnHour": "第44段策略结束小时",
    "S44EnHour": "第44段策略结束小时",
    "s44EnMin": "第44段策略结束分钟",
    "S44EnMin": "第44段策略结束分钟",
    "s44Power": "第44段执行功率(-充 +放)",
    "S44Power": "第44段执行功率(-充 +放)",
    "s44RePower": "第44段执行无功功率",
    "S44RePower": "第44段执行无功功率",
    "s44SOCUpperLimit": "第44段策略SOC上限",
    "S44SOCUpperLimit": "第44段策略SOC上限",
    "s44SOCLowerLimit": "第44段策略SOC下限",
    "S44SOCLowerLimit": "第44段策略SOC下限",
    "s45StHour": "第45段策略开始小时",
    "S45StHour": "第45段策略开始小时",
    "s45StMin": "第45段策略开始分钟",
    "S45StMin": "第45段策略开始分钟",
    "s45EnHour": "第45段策略结束小时",
    "S45EnHour": "第45段策略结束小时",
    "s45EnMin": "第45段策略结束分钟",
    "S45EnMin": "第45段策略结束分钟",
    "s45Power": "第45段执行功率(-充 +放)",
    "S45Power": "第45段执行功率(-充 +放)",
    "s45RePower": "第45段执行无功功率",
    "S45RePower": "第45段执行无功功率",
    "s45SOCUpperLimit": "第45段策略SOC上限",
    "S45SOCUpperLimit": "第45段策略SOC上限",
    "s45SOCLowerLimit": "第45段策略SOC下限",
    "S45SOCLowerLimit": "第45段策略SOC下限",
    "s46StHour": "第46段策略开始小时",
    "S46StHour": "第46段策略开始小时",
    "s46StMin": "第46段策略开始分钟",
    "S46StMin": "第46段策略开始分钟",
    "s46EnHour": "第46段策略结束小时",
    "S46EnHour": "第46段策略结束小时",
    "s46EnMin": "第46段策略结束分钟",
    "S46EnMin": "第46段策略结束分钟",
    "s46Power": "第46段执行功率(-充 +放)",
    "S46Power": "第46段执行功率(-充 +放)",
    "s46RePower": "第46段执行无功功率",
    "S46RePower": "第46段执行无功功率",
    "s46SOCUpperLimit": "第46段策略SOC上限",
    "S46SOCUpperLimit": "第46段策略SOC上限",
    "s46SOCLowerLimit": "第46段策略SOC下限",
    "S46SOCLowerLimit": "第46段策略SOC下限",
    "s47StHour": "第47段策略开始小时",
    "S47StHour": "第47段策略开始小时",
    "s47StMin": "第47段策略开始分钟",
    "S47StMin": "第47段策略开始分钟",
    "s47EnHour": "第47段策略结束小时",
    "S47EnHour": "第47段策略结束小时",
    "s47EnMin": "第47段策略结束分钟",
    "S47EnMin": "第47段策略结束分钟",
    "s47Power": "第47段执行功率(-充 +放)",
    "S47Power": "第47段执行功率(-充 +放)",
    "s47RePower": "第47段执行无功功率",
    "S47RePower": "第47段执行无功功率",
    "s47SOCUpperLimit": "第47段策略SOC上限",
    "S47SOCUpperLimit": "第47段策略SOC上限",
    "s47SOCLowerLimit": "第47段策略SOC下限",
    "S47SOCLowerLimit": "第47段策略SOC下限",
    "s48StHour": "第48段策略开始小时",
    "S48StHour": "第48段策略开始小时",
    "s48StMin": "第48段策略开始分钟",
    "S48StMin": "第48段策略开始分钟",
    "s48EnHour": "第48段策略结束小时",
    "S48EnHour": "第48段策略结束小时",
    "s48EnMin": "第48段策略结束分钟",
    "S48EnMin": "第48段策略结束分钟",
    "s48Power": "第48段执行功率(-充 +放)",
    "S48Power": "第48段执行功率(-充 +放)",
    "s48RePower": "第48段执行无功功率",
    "S48RePower": "第48段执行无功功率",
    "s48SOCUpperLimit": "第48段策略SOC上限",
    "S48SOCUpperLimit": "第48段策略SOC上限",
    "s48SOCLowerLimit": "第48段策略SOC下限",
    "S48SOCLowerLimit": "第48段策略SOC下限",
    "s49StHour": "第49段策略开始小时",
    "S49StHour": "第49段策略开始小时",
    "s49StMin": "第49段策略开始分钟",
    "S49StMin": "第49段策略开始分钟",
    "s49EnHour": "第49段策略结束小时",
    "S49EnHour": "第49段策略结束小时",
    "s49EnMin": "第49段策略结束分钟",
    "S49EnMin": "第49段策略结束分钟",
    "s49Power": "第49段执行功率(-充 +放)",
    "S49Power": "第49段执行功率(-充 +放)",
    "s49RePower": "第49段执行无功功率",
    "S49RePower": "第49段执行无功功率",
    "s49SOCUpperLimit": "第49段策略SOC上限",
    "S49SOCUpperLimit": "第49段策略SOC上限",
    "s49SOCLowerLimit": "第49段策略SOC下限",
    "S49SOCLowerLimit": "第49段策略SOC下限",
    "s50StHour": "第50段策略开始小时",
    "S50StHour": "第50段策略开始小时",
    "s50StMin": "第50段策略开始分钟",
    "S50StMin": "第50段策略开始分钟",
    "s50EnHour": "第50段策略结束小时",
    "S50EnHour": "第50段策略结束小时",
    "s50EnMin": "第50段策略结束分钟",
    "S50EnMin": "第50段策略结束分钟",
    "s50Power": "第50段执行功率(-充 +放)",
    "S50Power": "第50段执行功率(-充 +放)",
    "s50RePower": "第50段执行无功功率",
    "S50RePower": "第50段执行无功功率",
    "s50SOCUpperLimit": "第50段策略SOC上限",
    "S50SOCUpperLimit": "第50段策略SOC上限",
    "s50SOCLowerLimit": "第50段策略SOC下限",
    "S50SOCLowerLimit": "第50段策略SOC下限",
    "s51StHour": "第51段策略开始小时",
    "S51StHour": "第51段策略开始小时",
    "s51StMin": "第51段策略开始分钟",
    "S51StMin": "第51段策略开始分钟",
    "s51EnHour": "第51段策略结束小时",
    "S51EnHour": "第51段策略结束小时",
    "s51EnMin": "第51段策略结束分钟",
    "S51EnMin": "第51段策略结束分钟",
    "s51Power": "第51段执行功率(-充 +放)",
    "S51Power": "第51段执行功率(-充 +放)",
    "s51RePower": "第51段执行无功功率",
    "S51RePower": "第51段执行无功功率",
    "s51SOCUpperLimit": "第51段策略SOC上限",
    "S51SOCUpperLimit": "第51段策略SOC上限",
    "s51SOCLowerLimit": "第51段策略SOC下限",
    "S51SOCLowerLimit": "第51段策略SOC下限",
    "s52StHour": "第52段策略开始小时",
    "S52StHour": "第52段策略开始小时",
    "s52StMin": "第52段策略开始分钟",
    "S52StMin": "第52段策略开始分钟",
    "s52EnHour": "第52段策略结束小时",
    "S52EnHour": "第52段策略结束小时",
    "s52EnMin": "第52段策略结束分钟",
    "S52EnMin": "第52段策略结束分钟",
    "s52Power": "第52段执行功率(-充 +放)",
    "S52Power": "第52段执行功率(-充 +放)",
    "s52RePower": "第52段执行无功功率",
    "S52RePower": "第52段执行无功功率",
    "s52SOCUpperLimit": "第52段策略SOC上限",
    "S52SOCUpperLimit": "第52段策略SOC上限",
    "s52SOCLowerLimit": "第52段策略SOC下限",
    "S52SOCLowerLimit": "第52段策略SOC下限",
    "s53StHour": "第53段策略开始小时",
    "S53StHour": "第53段策略开始小时",
    "s53StMin": "第53段策略开始分钟",
    "S53StMin": "第53段策略开始分钟",
    "s53EnHour": "第53段策略结束小时",
    "S53EnHour": "第53段策略结束小时",
    "s53EnMin": "第53段策略结束分钟",
    "S53EnMin": "第53段策略结束分钟",
    "s53Power": "第53段执行功率(-充 +放)",
    "S53Power": "第53段执行功率(-充 +放)",
    "s53RePower": "第53段执行无功功率",
    "S53RePower": "第53段执行无功功率",
    "s53SOCUpperLimit": "第53段策略SOC上限",
    "S53SOCUpperLimit": "第53段策略SOC上限",
    "s53SOCLowerLimit": "第53段策略SOC下限",
    "S53SOCLowerLimit": "第53段策略SOC下限",
    "s54StHour": "第54段策略开始小时",
    "S54StHour": "第54段策略开始小时",
    "s54StMin": "第54段策略开始分钟",
    "S54StMin": "第54段策略开始分钟",
    "s54EnHour": "第54段策略结束小时",
    "S54EnHour": "第54段策略结束小时",
    "s54EnMin": "第54段策略结束分钟",
    "S54EnMin": "第54段策略结束分钟",
    "s54Power": "第54段执行功率(-充 +放)",
    "S54Power": "第54段执行功率(-充 +放)",
    "s54RePower": "第54段执行无功功率",
    "S54RePower": "第54段执行无功功率",
    "s54SOCUpperLimit": "第54段策略SOC上限",
    "S54SOCUpperLimit": "第54段策略SOC上限",
    "s54SOCLowerLimit": "第54段策略SOC下限",
    "S54SOCLowerLimit": "第54段策略SOC下限",
    "s55StHour": "第55段策略开始小时",
    "S55StHour": "第55段策略开始小时",
    "s55StMin": "第55段策略开始分钟",
    "S55StMin": "第55段策略开始分钟",
    "s55EnHour": "第55段策略结束小时",
    "S55EnHour": "第55段策略结束小时",
    "s55EnMin": "第55段策略结束分钟",
    "S55EnMin": "第55段策略结束分钟",
    "s55Power": "第55段执行功率(-充 +放)",
    "S55Power": "第55段执行功率(-充 +放)",
    "s55RePower": "第55段执行无功功率",
    "S55RePower": "第55段执行无功功率",
    "s55SOCUpperLimit": "第55段策略SOC上限",
    "S55SOCUpperLimit": "第55段策略SOC上限",
    "s55SOCLowerLimit": "第55段策略SOC下限",
    "S55SOCLowerLimit": "第55段策略SOC下限",
    "s56StHour": "第56段策略开始小时",
    "S56StHour": "第56段策略开始小时",
    "s56StMin": "第56段策略开始分钟",
    "S56StMin": "第56段策略开始分钟",
    "s56EnHour": "第56段策略结束小时",
    "S56EnHour": "第56段策略结束小时",
    "s56EnMin": "第56段策略结束分钟",
    "S56EnMin": "第56段策略结束分钟",
    "s56Power": "第56段执行功率(-充 +放)",
    "S56Power": "第56段执行功率(-充 +放)",
    "s56RePower": "第56段执行无功功率",
    "S56RePower": "第56段执行无功功率",
    "s56SOCUpperLimit": "第56段策略SOC上限",
    "S56SOCUpperLimit": "第56段策略SOC上限",
    "s56SOCLowerLimit": "第56段策略SOC下限",
    "S56SOCLowerLimit": "第56段策略SOC下限",
    "s57StHour": "第57段策略开始小时",
    "S57StHour": "第57段策略开始小时",
    "s57StMin": "第57段策略开始分钟",
    "S57StMin": "第57段策略开始分钟",
    "s57EnHour": "第57段策略结束小时",
    "S57EnHour": "第57段策略结束小时",
    "s57EnMin": "第57段策略结束分钟",
    "S57EnMin": "第57段策略结束分钟",
    "s57Power": "第57段执行功率(-充 +放)",
    "S57Power": "第57段执行功率(-充 +放)",
    "s57RePower": "第57段执行无功功率",
    "S57RePower": "第57段执行无功功率",
    "s57SOCUpperLimit": "第57段策略SOC上限",
    "S57SOCUpperLimit": "第57段策略SOC上限",
    "s57SOCLowerLimit": "第57段策略SOC下限",
    "S57SOCLowerLimit": "第57段策略SOC下限",
    "s58StHour": "第58段策略开始小时",
    "S58StHour": "第58段策略开始小时",
    "s58StMin": "第58段策略开始分钟",
    "S58StMin": "第58段策略开始分钟",
    "s58EnHour": "第58段策略结束小时",
    "S58EnHour": "第58段策略结束小时",
    "s58EnMin": "第58段策略结束分钟",
    "S58EnMin": "第58段策略结束分钟",
    "s58Power": "第58段执行功率(-充 +放)",
    "S58Power": "第58段执行功率(-充 +放)",
    "s58RePower": "第58段执行无功功率",
    "S58RePower": "第58段执行无功功率",
    "s58SOCUpperLimit": "第58段策略SOC上限",
    "S58SOCUpperLimit": "第58段策略SOC上限",
    "s58SOCLowerLimit": "第58段策略SOC下限",
    "S58SOCLowerLimit": "第58段策略SOC下限",
    "s59StHour": "第59段策略开始小时",
    "S59StHour": "第59段策略开始小时",
    "s59StMin": "第59段策略开始分钟",
    "S59StMin": "第59段策略开始分钟",
    "s59EnHour": "第59段策略结束小时",
    "S59EnHour": "第59段策略结束小时",
    "s59EnMin": "第59段策略结束分钟",
    "S59EnMin": "第59段策略结束分钟",
    "s59Power": "第59段执行功率(-充 +放)",
    "S59Power": "第59段执行功率(-充 +放)",
    "s59RePower": "第59段执行无功功率",
    "S59RePower": "第59段执行无功功率",
    "s59SOCUpperLimit": "第59段策略SOC上限",
    "S59SOCUpperLimit": "第59段策略SOC上限",
    "s59SOCLowerLimit": "第59段策略SOC下限",
    "S59SOCLowerLimit": "第59段策略SOC下限",
    "s60StHour": "第60段策略开始小时",
    "S60StHour": "第60段策略开始小时",
    "s60StMin": "第60段策略开始分钟",
    "S60StMin": "第60段策略开始分钟",
    "s60EnHour": "第60段策略结束小时",
    "S60EnHour": "第60段策略结束小时",
    "s60EnMin": "第60段策略结束分钟",
    "S60EnMin": "第60段策略结束分钟",
    "s60Power": "第60段执行功率(-充 +放)",
    "S60Power": "第60段执行功率(-充 +放)",
    "s60RePower": "第60段执行无功功率",
    "S60RePower": "第60段执行无功功率",
    "s60SOCUpperLimit": "第60段策略SOC上限",
    "S60SOCUpperLimit": "第60段策略SOC上限",
    "s60SOCLowerLimit": "第60段策略SOC下限",
    "S60SOCLowerLimit": "第60段策略SOC下限",
    "s61StHour": "第61段策略开始小时",
    "S61StHour": "第61段策略开始小时",
    "s61StMin": "第61段策略开始分钟",
    "S61StMin": "第61段策略开始分钟",
    "s61EnHour": "第61段策略结束小时",
    "S61EnHour": "第61段策略结束小时",
    "s61EnMin": "第61段策略结束分钟",
    "S61EnMin": "第61段策略结束分钟",
    "s61Power": "第61段执行功率(-充 +放)",
    "S61Power": "第61段执行功率(-充 +放)",
    "s61RePower": "第61段执行无功功率",
    "S61RePower": "第61段执行无功功率",
    "s61SOCUpperLimit": "第61段策略SOC上限",
    "S61SOCUpperLimit": "第61段策略SOC上限",
    "s61SOCLowerLimit": "第61段策略SOC下限",
    "S61SOCLowerLimit": "第61段策略SOC下限",
    "s62StHour": "第62段策略开始小时",
    "S62StHour": "第62段策略开始小时",
    "s62StMin": "第62段策略开始分钟",
    "S62StMin": "第62段策略开始分钟",
    "s62EnHour": "第62段策略结束小时",
    "S62EnHour": "第62段策略结束小时",
    "s62EnMin": "第62段策略结束分钟",
    "S62EnMin": "第62段策略结束分钟",
    "s62Power": "第62段执行功率(-充 +放)",
    "S62Power": "第62段执行功率(-充 +放)",
    "s62RePower": "第62段执行无功功率",
    "S62RePower": "第62段执行无功功率",
    "s62SOCUpperLimit": "第62段策略SOC上限",
    "S62SOCUpperLimit": "第62段策略SOC上限",
    "s62SOCLowerLimit": "第62段策略SOC下限",
    "S62SOCLowerLimit": "第62段策略SOC下限",
    "s63StHour": "第63段策略开始小时",
    "S63StHour": "第63段策略开始小时",
    "s63StMin": "第63段策略开始分钟",
    "S63StMin": "第63段策略开始分钟",
    "s63EnHour": "第63段策略结束小时",
    "S63EnHour": "第63段策略结束小时",
    "s63EnMin": "第63段策略结束分钟",
    "S63EnMin": "第63段策略结束分钟",
    "s63Power": "第63段执行功率(-充 +放)",
    "S63Power": "第63段执行功率(-充 +放)",
    "s63RePower": "第63段执行无功功率",
    "S63RePower": "第63段执行无功功率",
    "s63SOCUpperLimit": "第63段策略SOC上限",
    "S63SOCUpperLimit": "第63段策略SOC上限",
    "s63SOCLowerLimit": "第63段策略SOC下限",
    "S63SOCLowerLimit": "第63段策略SOC下限",
    "s64StHour": "第64段策略开始小时",
    "S64StHour": "第64段策略开始小时",
    "s64StMin": "第64段策略开始分钟",
    "S64StMin": "第64段策略开始分钟",
    "s64EnHour": "第64段策略结束小时",
    "S64EnHour": "第64段策略结束小时",
    "s64EnMin": "第64段策略结束分钟",
    "S64EnMin": "第64段策略结束分钟",
    "s64Power": "第64段执行功率(-充 +放)",
    "S64Power": "第64段执行功率(-充 +放)",
    "s64RePower": "第64段执行无功功率",
    "S64RePower": "第64段执行无功功率",
    "s64SOCUpperLimit": "第64段策略SOC上限",
    "S64SOCUpperLimit": "第64段策略SOC上限",
    "s64SOCLowerLimit": "第64段策略SOC下限",
    "S64SOCLowerLimit": "第64段策略SOC下限",
    "s65StHour": "第65段策略开始小时",
    "S65StHour": "第65段策略开始小时",
    "s65StMin": "第65段策略开始分钟",
    "S65StMin": "第65段策略开始分钟",
    "s65EnHour": "第65段策略结束小时",
    "S65EnHour": "第65段策略结束小时",
    "s65EnMin": "第65段策略结束分钟",
    "S65EnMin": "第65段策略结束分钟",
    "s65Power": "第65段执行功率(-充 +放)",
    "S65Power": "第65段执行功率(-充 +放)",
    "s65RePower": "第65段执行无功功率",
    "S65RePower": "第65段执行无功功率",
    "s65SOCUpperLimit": "第65段策略SOC上限",
    "S65SOCUpperLimit": "第65段策略SOC上限",
    "s65SOCLowerLimit": "第65段策略SOC下限",
    "S65SOCLowerLimit": "第65段策略SOC下限",
    "s66StHour": "第66段策略开始小时",
    "S66StHour": "第66段策略开始小时",
    "s66StMin": "第66段策略开始分钟",
    "S66StMin": "第66段策略开始分钟",
    "s66EnHour": "第66段策略结束小时",
    "S66EnHour": "第66段策略结束小时",
    "s66EnMin": "第66段策略结束分钟",
    "S66EnMin": "第66段策略结束分钟",
    "s66Power": "第66段执行功率(-充 +放)",
    "S66Power": "第66段执行功率(-充 +放)",
    "s66RePower": "第66段执行无功功率",
    "S66RePower": "第66段执行无功功率",
    "s66SOCUpperLimit": "第66段策略SOC上限",
    "S66SOCUpperLimit": "第66段策略SOC上限",
    "s66SOCLowerLimit": "第66段策略SOC下限",
    "S66SOCLowerLimit": "第66段策略SOC下限",
    "s67StHour": "第67段策略开始小时",
    "S67StHour": "第67段策略开始小时",
    "s67StMin": "第67段策略开始分钟",
    "S67StMin": "第67段策略开始分钟",
    "s67EnHour": "第67段策略结束小时",
    "S67EnHour": "第67段策略结束小时",
    "s67EnMin": "第67段策略结束分钟",
    "S67EnMin": "第67段策略结束分钟",
    "s67Power": "第67段执行功率(-充 +放)",
    "S67Power": "第67段执行功率(-充 +放)",
    "s67RePower": "第67段执行无功功率",
    "S67RePower": "第67段执行无功功率",
    "s67SOCUpperLimit": "第67段策略SOC上限",
    "S67SOCUpperLimit": "第67段策略SOC上限",
    "s67SOCLowerLimit": "第67段策略SOC下限",
    "S67SOCLowerLimit": "第67段策略SOC下限",
    "s68StHour": "第68段策略开始小时",
    "S68StHour": "第68段策略开始小时",
    "s68StMin": "第68段策略开始分钟",
    "S68StMin": "第68段策略开始分钟",
    "s68EnHour": "第68段策略结束小时",
    "S68EnHour": "第68段策略结束小时",
    "s68EnMin": "第68段策略结束分钟",
    "S68EnMin": "第68段策略结束分钟",
    "s68Power": "第68段执行功率(-充 +放)",
    "S68Power": "第68段执行功率(-充 +放)",
    "s68RePower": "第68段执行无功功率",
    "S68RePower": "第68段执行无功功率",
    "s68SOCUpperLimit": "第68段策略SOC上限",
    "S68SOCUpperLimit": "第68段策略SOC上限",
    "s68SOCLowerLimit": "第68段策略SOC下限",
    "S68SOCLowerLimit": "第68段策略SOC下限",
    "s69StHour": "第69段策略开始小时",
    "S69StHour": "第69段策略开始小时",
    "s69StMin": "第69段策略开始分钟",
    "S69StMin": "第69段策略开始分钟",
    "s69EnHour": "第69段策略结束小时",
    "S69EnHour": "第69段策略结束小时",
    "s69EnMin": "第69段策略结束分钟",
    "S69EnMin": "第69段策略结束分钟",
    "s69Power": "第69段执行功率(-充 +放)",
    "S69Power": "第69段执行功率(-充 +放)",
    "s69RePower": "第69段执行无功功率",
    "S69RePower": "第69段执行无功功率",
    "s69SOCUpperLimit": "第69段策略SOC上限",
    "S69SOCUpperLimit": "第69段策略SOC上限",
    "s69SOCLowerLimit": "第69段策略SOC下限",
    "S69SOCLowerLimit": "第69段策略SOC下限",
    "s70StHour": "第70段策略开始小时",
    "S70StHour": "第70段策略开始小时",
    "s70StMin": "第70段策略开始分钟",
    "S70StMin": "第70段策略开始分钟",
    "s70EnHour": "第70段策略结束小时",
    "S70EnHour": "第70段策略结束小时",
    "s70EnMin": "第70段策略结束分钟",
    "S70EnMin": "第70段策略结束分钟",
    "s70Power": "第70段执行功率(-充 +放)",
    "S70Power": "第70段执行功率(-充 +放)",
    "s70RePower": "第70段执行无功功率",
    "S70RePower": "第70段执行无功功率",
    "s70SOCUpperLimit": "第70段策略SOC上限",
    "S70SOCUpperLimit": "第70段策略SOC上限",
    "s70SOCLowerLimit": "第70段策略SOC下限",
    "S70SOCLowerLimit": "第70段策略SOC下限",
    "s71StHour": "第71段策略开始小时",
    "S71StHour": "第71段策略开始小时",
    "s71StMin": "第71段策略开始分钟",
    "S71StMin": "第71段策略开始分钟",
    "s71EnHour": "第71段策略结束小时",
    "S71EnHour": "第71段策略结束小时",
    "s71EnMin": "第71段策略结束分钟",
    "S71EnMin": "第71段策略结束分钟",
    "s71Power": "第71段执行功率(-充 +放)",
    "S71Power": "第71段执行功率(-充 +放)",
    "s71RePower": "第71段执行无功功率",
    "S71RePower": "第71段执行无功功率",
    "s71SOCUpperLimit": "第71段策略SOC上限",
    "S71SOCUpperLimit": "第71段策略SOC上限",
    "s71SOCLowerLimit": "第71段策略SOC下限",
    "S71SOCLowerLimit": "第71段策略SOC下限",
    "s72StHour": "第72段策略开始小时",
    "S72StHour": "第72段策略开始小时",
    "s72StMin": "第72段策略开始分钟",
    "S72StMin": "第72段策略开始分钟",
    "s72EnHour": "第72段策略结束小时",
    "S72EnHour": "第72段策略结束小时",
    "s72EnMin": "第72段策略结束分钟",
    "S72EnMin": "第72段策略结束分钟",
    "s72Power": "第72段执行功率(-充 +放)",
    "S72Power": "第72段执行功率(-充 +放)",
    "s72RePower": "第72段执行无功功率",
    "S72RePower": "第72段执行无功功率",
    "s72SOCUpperLimit": "第72段策略SOC上限",
    "S72SOCUpperLimit": "第72段策略SOC上限",
    "s72SOCLowerLimit": "第72段策略SOC下限",
    "S72SOCLowerLimit": "第72段策略SOC下限",
    "s73StHour": "第73段策略开始小时",
    "S73StHour": "第73段策略开始小时",
    "s73StMin": "第73段策略开始分钟",
    "S73StMin": "第73段策略开始分钟",
    "s73EnHour": "第73段策略结束小时",
    "S73EnHour": "第73段策略结束小时",
    "s73EnMin": "第73段策略结束分钟",
    "S73EnMin": "第73段策略结束分钟",
    "s73Power": "第73段执行功率(-充 +放)",
    "S73Power": "第73段执行功率(-充 +放)",
    "s73RePower": "第73段执行无功功率",
    "S73RePower": "第73段执行无功功率",
    "s73SOCUpperLimit": "第73段策略SOC上限",
    "S73SOCUpperLimit": "第73段策略SOC上限",
    "s73SOCLowerLimit": "第73段策略SOC下限",
    "S73SOCLowerLimit": "第73段策略SOC下限",
    "s74StHour": "第74段策略开始小时",
    "S74StHour": "第74段策略开始小时",
    "s74StMin": "第74段策略开始分钟",
    "S74StMin": "第74段策略开始分钟",
    "s74EnHour": "第74段策略结束小时",
    "S74EnHour": "第74段策略结束小时",
    "s74EnMin": "第74段策略结束分钟",
    "S74EnMin": "第74段策略结束分钟",
    "s74Power": "第74段执行功率(-充 +放)",
    "S74Power": "第74段执行功率(-充 +放)",
    "s74RePower": "第74段执行无功功率",
    "S74RePower": "第74段执行无功功率",
    "s74SOCUpperLimit": "第74段策略SOC上限",
    "S74SOCUpperLimit": "第74段策略SOC上限",
    "s74SOCLowerLimit": "第74段策略SOC下限",
    "S74SOCLowerLimit": "第74段策略SOC下限",
    "s75StHour": "第75段策略开始小时",
    "S75StHour": "第75段策略开始小时",
    "s75StMin": "第75段策略开始分钟",
    "S75StMin": "第75段策略开始分钟",
    "s75EnHour": "第75段策略结束小时",
    "S75EnHour": "第75段策略结束小时",
    "s75EnMin": "第75段策略结束分钟",
    "S75EnMin": "第75段策略结束分钟",
    "s75Power": "第75段执行功率(-充 +放)",
    "S75Power": "第75段执行功率(-充 +放)",
    "s75RePower": "第75段执行无功功率",
    "S75RePower": "第75段执行无功功率",
    "s75SOCUpperLimit": "第75段策略SOC上限",
    "S75SOCUpperLimit": "第75段策略SOC上限",
    "s75SOCLowerLimit": "第75段策略SOC下限",
    "S75SOCLowerLimit": "第75段策略SOC下限",
    "s76StHour": "第76段策略开始小时",
    "S76StHour": "第76段策略开始小时",
    "s76StMin": "第76段策略开始分钟",
    "S76StMin": "第76段策略开始分钟",
    "s76EnHour": "第76段策略结束小时",
    "S76EnHour": "第76段策略结束小时",
    "s76EnMin": "第76段策略结束分钟",
    "S76EnMin": "第76段策略结束分钟",
    "s76Power": "第76段执行功率(-充 +放)",
    "S76Power": "第76段执行功率(-充 +放)",
    "s76RePower": "第76段执行无功功率",
    "S76RePower": "第76段执行无功功率",
    "s76SOCUpperLimit": "第76段策略SOC上限",
    "S76SOCUpperLimit": "第76段策略SOC上限",
    "s76SOCLowerLimit": "第76段策略SOC下限",
    "S76SOCLowerLimit": "第76段策略SOC下限",
    "s77StHour": "第77段策略开始小时",
    "S77StHour": "第77段策略开始小时",
    "s77StMin": "第77段策略开始分钟",
    "S77StMin": "第77段策略开始分钟",
    "s77EnHour": "第77段策略结束小时",
    "S77EnHour": "第77段策略结束小时",
    "s77EnMin": "第77段策略结束分钟",
    "S77EnMin": "第77段策略结束分钟",
    "s77Power": "第77段执行功率(-充 +放)",
    "S77Power": "第77段执行功率(-充 +放)",
    "s77RePower": "第77段执行无功功率",
    "S77RePower": "第77段执行无功功率",
    "s77SOCUpperLimit": "第77段策略SOC上限",
    "S77SOCUpperLimit": "第77段策略SOC上限",
    "s77SOCLowerLimit": "第77段策略SOC下限",
    "S77SOCLowerLimit": "第77段策略SOC下限",
    "s78StHour": "第78段策略开始小时",
    "S78StHour": "第78段策略开始小时",
    "s78StMin": "第78段策略开始分钟",
    "S78StMin": "第78段策略开始分钟",
    "s78EnHour": "第78段策略结束小时",
    "S78EnHour": "第78段策略结束小时",
    "s78EnMin": "第78段策略结束分钟",
    "S78EnMin": "第78段策略结束分钟",
    "s78Power": "第78段执行功率(-充 +放)",
    "S78Power": "第78段执行功率(-充 +放)",
    "s78RePower": "第78段执行无功功率",
    "S78RePower": "第78段执行无功功率",
    "s78SOCUpperLimit": "第78段策略SOC上限",
    "S78SOCUpperLimit": "第78段策略SOC上限",
    "s78SOCLowerLimit": "第78段策略SOC下限",
    "S78SOCLowerLimit": "第78段策略SOC下限",
    "s79StHour": "第79段策略开始小时",
    "S79StHour": "第79段策略开始小时",
    "s79StMin": "第79段策略开始分钟",
    "S79StMin": "第79段策略开始分钟",
    "s79EnHour": "第79段策略结束小时",
    "S79EnHour": "第79段策略结束小时",
    "s79EnMin": "第79段策略结束分钟",
    "S79EnMin": "第79段策略结束分钟",
    "s79Power": "第79段执行功率(-充 +放)",
    "S79Power": "第79段执行功率(-充 +放)",
    "s79RePower": "第79段执行无功功率",
    "S79RePower": "第79段执行无功功率",
    "s79SOCUpperLimit": "第79段策略SOC上限",
    "S79SOCUpperLimit": "第79段策略SOC上限",
    "s79SOCLowerLimit": "第79段策略SOC下限",
    "S79SOCLowerLimit": "第79段策略SOC下限",
    "s80StHour": "第80段策略开始小时",
    "S80StHour": "第80段策略开始小时",
    "s80StMin": "第80段策略开始分钟",
    "S80StMin": "第80段策略开始分钟",
    "s80EnHour": "第80段策略结束小时",
    "S80EnHour": "第80段策略结束小时",
    "s80EnMin": "第80段策略结束分钟",
    "S80EnMin": "第80段策略结束分钟",
    "s80Power": "第80段执行功率(-充 +放)",
    "S80Power": "第80段执行功率(-充 +放)",
    "s80RePower": "第80段执行无功功率",
    "S80RePower": "第80段执行无功功率",
    "s80SOCUpperLimit": "第80段策略SOC上限",
    "S80SOCUpperLimit": "第80段策略SOC上限",
    "s80SOCLowerLimit": "第80段策略SOC下限",
    "S80SOCLowerLimit": "第80段策略SOC下限",
    "s81StHour": "第81段策略开始小时",
    "S81StHour": "第81段策略开始小时",
    "s81StMin": "第81段策略开始分钟",
    "S81StMin": "第81段策略开始分钟",
    "s81EnHour": "第81段策略结束小时",
    "S81EnHour": "第81段策略结束小时",
    "s81EnMin": "第81段策略结束分钟",
    "S81EnMin": "第81段策略结束分钟",
    "s81Power": "第81段执行功率(-充 +放)",
    "S81Power": "第81段执行功率(-充 +放)",
    "s81RePower": "第81段执行无功功率",
    "S81RePower": "第81段执行无功功率",
    "s81SOCUpperLimit": "第81段策略SOC上限",
    "S81SOCUpperLimit": "第81段策略SOC上限",
    "s81SOCLowerLimit": "第81段策略SOC下限",
    "S81SOCLowerLimit": "第81段策略SOC下限",
    "s82StHour": "第82段策略开始小时",
    "S82StHour": "第82段策略开始小时",
    "s82StMin": "第82段策略开始分钟",
    "S82StMin": "第82段策略开始分钟",
    "s82EnHour": "第82段策略结束小时",
    "S82EnHour": "第82段策略结束小时",
    "s82EnMin": "第82段策略结束分钟",
    "S82EnMin": "第82段策略结束分钟",
    "s82Power": "第82段执行功率(-充 +放)",
    "S82Power": "第82段执行功率(-充 +放)",
    "s82RePower": "第82段执行无功功率",
    "S82RePower": "第82段执行无功功率",
    "s82SOCUpperLimit": "第82段策略SOC上限",
    "S82SOCUpperLimit": "第82段策略SOC上限",
    "s82SOCLowerLimit": "第82段策略SOC下限",
    "S82SOCLowerLimit": "第82段策略SOC下限",
    "s83StHour": "第83段策略开始小时",
    "S83StHour": "第83段策略开始小时",
    "s83StMin": "第83段策略开始分钟",
    "S83StMin": "第83段策略开始分钟",
    "s83EnHour": "第83段策略结束小时",
    "S83EnHour": "第83段策略结束小时",
    "s83EnMin": "第83段策略结束分钟",
    "S83EnMin": "第83段策略结束分钟",
    "s83Power": "第83段执行功率(-充 +放)",
    "S83Power": "第83段执行功率(-充 +放)",
    "s83RePower": "第83段执行无功功率",
    "S83RePower": "第83段执行无功功率",
    "s83SOCUpperLimit": "第83段策略SOC上限",
    "S83SOCUpperLimit": "第83段策略SOC上限",
    "s83SOCLowerLimit": "第83段策略SOC下限",
    "S83SOCLowerLimit": "第83段策略SOC下限",
    "s84StHour": "第84段策略开始小时",
    "S84StHour": "第84段策略开始小时",
    "s84StMin": "第84段策略开始分钟",
    "S84StMin": "第84段策略开始分钟",
    "s84EnHour": "第84段策略结束小时",
    "S84EnHour": "第84段策略结束小时",
    "s84EnMin": "第84段策略结束分钟",
    "S84EnMin": "第84段策略结束分钟",
    "s84Power": "第84段执行功率(-充 +放)",
    "S84Power": "第84段执行功率(-充 +放)",
    "s84RePower": "第84段执行无功功率",
    "S84RePower": "第84段执行无功功率",
    "s84SOCUpperLimit": "第84段策略SOC上限",
    "S84SOCUpperLimit": "第84段策略SOC上限",
    "s84SOCLowerLimit": "第84段策略SOC下限",
    "S84SOCLowerLimit": "第84段策略SOC下限",
    "s85StHour": "第85段策略开始小时",
    "S85StHour": "第85段策略开始小时",
    "s85StMin": "第85段策略开始分钟",
    "S85StMin": "第85段策略开始分钟",
    "s85EnHour": "第85段策略结束小时",
    "S85EnHour": "第85段策略结束小时",
    "s85EnMin": "第85段策略结束分钟",
    "S85EnMin": "第85段策略结束分钟",
    "s85Power": "第85段执行功率(-充 +放)",
    "S85Power": "第85段执行功率(-充 +放)",
    "s85RePower": "第85段执行无功功率",
    "S85RePower": "第85段执行无功功率",
    "s85SOCUpperLimit": "第85段策略SOC上限",
    "S85SOCUpperLimit": "第85段策略SOC上限",
    "s85SOCLowerLimit": "第85段策略SOC下限",
    "S85SOCLowerLimit": "第85段策略SOC下限",
    "s86StHour": "第86段策略开始小时",
    "S86StHour": "第86段策略开始小时",
    "s86StMin": "第86段策略开始分钟",
    "S86StMin": "第86段策略开始分钟",
    "s86EnHour": "第86段策略结束小时",
    "S86EnHour": "第86段策略结束小时",
    "s86EnMin": "第86段策略结束分钟",
    "S86EnMin": "第86段策略结束分钟",
    "s86Power": "第86段执行功率(-充 +放)",
    "S86Power": "第86段执行功率(-充 +放)",
    "s86RePower": "第86段执行无功功率",
    "S86RePower": "第86段执行无功功率",
    "s86SOCUpperLimit": "第86段策略SOC上限",
    "S86SOCUpperLimit": "第86段策略SOC上限",
    "s86SOCLowerLimit": "第86段策略SOC下限",
    "S86SOCLowerLimit": "第86段策略SOC下限",
    "s87StHour": "第87段策略开始小时",
    "S87StHour": "第87段策略开始小时",
    "s87StMin": "第87段策略开始分钟",
    "S87StMin": "第87段策略开始分钟",
    "s87EnHour": "第87段策略结束小时",
    "S87EnHour": "第87段策略结束小时",
    "s87EnMin": "第87段策略结束分钟",
    "S87EnMin": "第87段策略结束分钟",
    "s87Power": "第87段执行功率(-充 +放)",
    "S87Power": "第87段执行功率(-充 +放)",
    "s87RePower": "第87段执行无功功率",
    "S87RePower": "第87段执行无功功率",
    "s87SOCUpperLimit": "第87段策略SOC上限",
    "S87SOCUpperLimit": "第87段策略SOC上限",
    "s87SOCLowerLimit": "第87段策略SOC下限",
    "S87SOCLowerLimit": "第87段策略SOC下限",
    "s88StHour": "第88段策略开始小时",
    "S88StHour": "第88段策略开始小时",
    "s88StMin": "第88段策略开始分钟",
    "S88StMin": "第88段策略开始分钟",
    "s88EnHour": "第88段策略结束小时",
    "S88EnHour": "第88段策略结束小时",
    "s88EnMin": "第88段策略结束分钟",
    "S88EnMin": "第88段策略结束分钟",
    "s88Power": "第88段执行功率(-充 +放)",
    "S88Power": "第88段执行功率(-充 +放)",
    "s88RePower": "第88段执行无功功率",
    "S88RePower": "第88段执行无功功率",
    "s88SOCUpperLimit": "第88段策略SOC上限",
    "S88SOCUpperLimit": "第88段策略SOC上限",
    "s88SOCLowerLimit": "第88段策略SOC下限",
    "S88SOCLowerLimit": "第88段策略SOC下限",
    "s89StHour": "第89段策略开始小时",
    "S89StHour": "第89段策略开始小时",
    "s89StMin": "第89段策略开始分钟",
    "S89StMin": "第89段策略开始分钟",
    "s89EnHour": "第89段策略结束小时",
    "S89EnHour": "第89段策略结束小时",
    "s89EnMin": "第89段策略结束分钟",
    "S89EnMin": "第89段策略结束分钟",
    "s89Power": "第89段执行功率(-充 +放)",
    "S89Power": "第89段执行功率(-充 +放)",
    "s89RePower": "第89段执行无功功率",
    "S89RePower": "第89段执行无功功率",
    "s89SOCUpperLimit": "第89段策略SOC上限",
    "S89SOCUpperLimit": "第89段策略SOC上限",
    "s89SOCLowerLimit": "第89段策略SOC下限",
    "S89SOCLowerLimit": "第89段策略SOC下限",
    "s90StHour": "第90段策略开始小时",
    "S90StHour": "第90段策略开始小时",
    "s90StMin": "第90段策略开始分钟",
    "S90StMin": "第90段策略开始分钟",
    "s90EnHour": "第90段策略结束小时",
    "S90EnHour": "第90段策略结束小时",
    "s90EnMin": "第90段策略结束分钟",
    "S90EnMin": "第90段策略结束分钟",
    "s90Power": "第90段执行功率(-充 +放)",
    "S90Power": "第90段执行功率(-充 +放)",
    "s90RePower": "第90段执行无功功率",
    "S90RePower": "第90段执行无功功率",
    "s90SOCUpperLimit": "第90段策略SOC上限",
    "S90SOCUpperLimit": "第90段策略SOC上限",
    "s90SOCLowerLimit": "第90段策略SOC下限",
    "S90SOCLowerLimit": "第90段策略SOC下限",
    "s91StHour": "第91段策略开始小时",
    "S91StHour": "第91段策略开始小时",
    "s91StMin": "第91段策略开始分钟",
    "S91StMin": "第91段策略开始分钟",
    "s91EnHour": "第91段策略结束小时",
    "S91EnHour": "第91段策略结束小时",
    "s91EnMin": "第91段策略结束分钟",
    "S91EnMin": "第91段策略结束分钟",
    "s91Power": "第91段执行功率(-充 +放)",
    "S91Power": "第91段执行功率(-充 +放)",
    "s91RePower": "第91段执行无功功率",
    "S91RePower": "第91段执行无功功率",
    "s91SOCUpperLimit": "第91段策略SOC上限",
    "S91SOCUpperLimit": "第91段策略SOC上限",
    "s91SOCLowerLimit": "第91段策略SOC下限",
    "S91SOCLowerLimit": "第91段策略SOC下限",
    "s92StHour": "第92段策略开始小时",
    "S92StHour": "第92段策略开始小时",
    "s92StMin": "第92段策略开始分钟",
    "S92StMin": "第92段策略开始分钟",
    "s92EnHour": "第92段策略结束小时",
    "S92EnHour": "第92段策略结束小时",
    "s92EnMin": "第92段策略结束分钟",
    "S92EnMin": "第92段策略结束分钟",
    "s92Power": "第92段执行功率(-充 +放)",
    "S92Power": "第92段执行功率(-充 +放)",
    "s92RePower": "第92段执行无功功率",
    "S92RePower": "第92段执行无功功率",
    "s92SOCUpperLimit": "第92段策略SOC上限",
    "S92SOCUpperLimit": "第92段策略SOC上限",
    "s92SOCLowerLimit": "第92段策略SOC下限",
    "S92SOCLowerLimit": "第92段策略SOC下限",
    "s93StHour": "第93段策略开始小时",
    "S93StHour": "第93段策略开始小时",
    "s93StMin": "第93段策略开始分钟",
    "S93StMin": "第93段策略开始分钟",
    "s93EnHour": "第93段策略结束小时",
    "S93EnHour": "第93段策略结束小时",
    "s93EnMin": "第93段策略结束分钟",
    "S93EnMin": "第93段策略结束分钟",
    "s93Power": "第93段执行功率(-充 +放)",
    "S93Power": "第93段执行功率(-充 +放)",
    "s93RePower": "第93段执行无功功率",
    "S93RePower": "第93段执行无功功率",
    "s93SOCUpperLimit": "第93段策略SOC上限",
    "S93SOCUpperLimit": "第93段策略SOC上限",
    "s93SOCLowerLimit": "第93段策略SOC下限",
    "S93SOCLowerLimit": "第93段策略SOC下限",
    "s94StHour": "第94段策略开始小时",
    "S94StHour": "第94段策略开始小时",
    "s94StMin": "第94段策略开始分钟",
    "S94StMin": "第94段策略开始分钟",
    "s94EnHour": "第94段策略结束小时",
    "S94EnHour": "第94段策略结束小时",
    "s94EnMin": "第94段策略结束分钟",
    "S94EnMin": "第94段策略结束分钟",
    "s94Power": "第94段执行功率(-充 +放)",
    "S94Power": "第94段执行功率(-充 +放)",
    "s94RePower": "第94段执行无功功率",
    "S94RePower": "第94段执行无功功率",
    "s94SOCUpperLimit": "第94段策略SOC上限",
    "S94SOCUpperLimit": "第94段策略SOC上限",
    "s94SOCLowerLimit": "第94段策略SOC下限",
    "S94SOCLowerLimit": "第94段策略SOC下限",
    "s95StHour": "第95段策略开始小时",
    "S95StHour": "第95段策略开始小时",
    "s95StMin": "第95段策略开始分钟",
    "S95StMin": "第95段策略开始分钟",
    "s95EnHour": "第95段策略结束小时",
    "S95EnHour": "第95段策略结束小时",
    "s95EnMin": "第95段策略结束分钟",
    "S95EnMin": "第95段策略结束分钟",
    "s95Power": "第95段执行功率(-充 +放)",
    "S95Power": "第95段执行功率(-充 +放)",
    "s95RePower": "第95段执行无功功率",
    "S95RePower": "第95段执行无功功率",
    "s95SOCUpperLimit": "第95段策略SOC上限",
    "S95SOCUpperLimit": "第95段策略SOC上限",
    "s95SOCLowerLimit": "第95段策略SOC下限",
    "S95SOCLowerLimit": "第95段策略SOC下限",
    "s96StHour": "第96段策略开始小时",
    "S96StHour": "第96段策略开始小时",
    "s96StMin": "第96段策略开始分钟",
    "S96StMin": "第96段策略开始分钟",
    "s96EnHour": "第96段策略结束小时",
    "S96EnHour": "第96段策略结束小时",
    "s96EnMin": "第96段策略结束分钟",
    "S96EnMin": "第96段策略结束分钟",
    "s96Power": "第96段执行功率(-充 +放)",
    "S96Power": "第96段执行功率(-充 +放)",
    "s96RePower": "第96段执行无功功率",
    "S96RePower": "第96段执行无功功率",
    "s96SOCUpperLimit": "第96段策略SOC上限",
    "S96SOCUpperLimit": "第96段策略SOC上限",
    "s96SOCLowerLimit": "第96段策略SOC下限",
    "S96SOCLowerLimit": "第96段策略SOC下限",
    "demandThreshold1": "1月需量控制门限(kW)",
    "DemandThreshold1": "1月需量控制门限(kW)",
    "demandThreshold2": "2月需量控制门限(kW)",
    "DemandThreshold2": "2月需量控制门限(kW)",
    "demandThreshold3": "3月需量控制门限(kW)",
    "DemandThreshold3": "3月需量控制门限(kW)",
    "demandThreshold4": "4月需量控制门限(kW)",
    "DemandThreshold4": "4月需量控制门限(kW)",
    "demandThreshold5": "5月需量控制门限(kW)",
    "DemandThreshold5": "5月需量控制门限(kW)",
    "demandThreshold6": "6月需量控制门限(kW)",
    "DemandThreshold6": "6月需量控制门限(kW)",
    "demandThreshold7": "7月需量控制门限(kW)",
    "DemandThreshold7": "7月需量控制门限(kW)",
    "demandThreshold8": "8月需量控制门限(kW)",
    "DemandThreshold8": "8月需量控制门限(kW)",
    "demandThreshold9": "9月需量控制门限(kW)",
    "DemandThreshold9": "9月需量控制门限(kW)",
    "demandThreshold10": "10月需量控制门限(kW)",
    "DemandThreshold10": "10月需量控制门限(kW)",
    "demandThreshold11": "11月需量控制门限(kW)",
    "DemandThreshold11": "11月需量控制门限(kW)",
    "demandThreshold12": "12月需量控制门限(kW)",
    "DemandThreshold12": "12月需量控制门限(kW)",
    "demandStartHour": "需量充电开始小时",
    "DemandStartHour": "需量充电开始小时",
    "demandStartMin": "需量充电开始分钟",
    "DemandStartMin": "需量充电开始分钟",
    "demandEndHour": "需量充电结束小时",
    "DemandEndHour": "需量充电结束小时",
    "demandEndMin": "需量充电结束分钟",
    "DemandEndMin": "需量充电结束分钟",
    "chargeStartPower": "开始充电功率(kW)",
    "dischargeThreshold": "开始放电功率(kW)",
    "sysStatus": "系统运行状态",
    "SysStatus": "系统运行状态",
    "avgSOC": "预留",
    "AvgSOC": "预留",
    "totalActivePower": "总有功功率(kW)",
    "TotalActivePower": "总有功功率(kW)",
    "totalReactivePower": "总无功功率(kVar)",
    "TotalReactivePower": "总无功功率(kVar)",
    "upAdjustPower": "预留",
    "UpAdjustPower": "预留",
    "downAdjustPower": "预留",
    "DownAdjustPower": "预留",
    "rechargeableEnergy": "预留",
    "RechargeableEnergy": "预留",
    "dischargeableEnergy": "预留",
    "DischargeableEnergy": "预留",
    "meterError": "电表故障",
    "MeterError": "电表故障",
    "ioProtect": "动环保护",
    "IoProtect": "动环保护",
    "allFire": "总消防",
    "AllFire": "总消防",
    "exFire": "外部消防",
    "ExFire": "外部消防",
    "fire": "本机消防",
    "Fire": "本机消防",
    "socParameterAlarm": "策略SOC超过保护参数限制",
    "SocParameterAlarm": "策略SOC超过保护参数限制",
    "chDischStatus": "充电/放电状态",
    "ChDischStatus": "充电/放电状态",
    "lcSysStatus": "LC系统状态",
    "LcSysStatus": "LC系统状态",
    "whitelistAlarm": "白名单告警",
    "WhitelistAlarm": "白名单告警",
    "iec104ConnAlarm": "北向Iec104连接告警",
    "Iec104ConnAlarm": "北向Iec104连接告警",
    "modbusTcpConnAlarm": "北向ModbusTcp连接告警",
    "ModbusTcpConnAlarm": "北向ModbusTcp连接告警",
    "ssdNotExist": "SSD不存在",
    "SsdNotExist": "SSD不存在",
    "maxDemand": "最大需量(kW)",
    "MaxDemand": "最大需量(kW)",
    "cabPower": "额定功率(kW)",
    "CabPower": "额定功率(kW)",
    "cabCapacity": "额定容量(kWh)",
    "CabCapacity": "额定容量(kWh)",
    "alarmHisCnt": "历史告警数量",
    "AlarmHisCnt": "历史告警数量",
    "prohibiteCha": "禁充保护",
    "ProhibiteCha": "禁充保护",
    "prohibiteDisc": "禁放保护",
    "ProhibiteDisc": "禁放保护",
    "bmsLimited": "DOD保护",
    "BmsLimited": "DOD保护",
    "sysStatusWord": "系统运行状态字",
    "SysStatusWord": "系统运行状态字",
    "totalForwardEnergy": "总正向电能(kWh)",
    "TotalForwardEnergy": "总正向电能(kWh)",
    "totalReverseEnergy": "总反向电能(kWh)",
    "TotalReverseEnergy": "总反向电能(kWh)",
    "SOC": "SOC",
    "onOffStatus": "开关机状态",
    "OnOffStatus": "开关机状态",
    "activePower": "有功功率(kW)",
    "ActivePower": "有功功率(kW)",
    "reactivePower": "无功功率(kVar)",
    "ReactivePower": "无功功率(kVar)",
    "bmsLimitedCh": "DOD禁充保护",
    "BmsLimitedCh": "DOD禁充保护",
    "bmsLimitedDc": "DOD禁放保护",
    "BmsLimitedDc": "DOD禁放保护",
    "manualProtect": "手动保护",
    "ManualProtect": "手动保护",
    "g100LockState": "G100 锁定状态",
    "G100LockState": "G100 锁定状态",
    "g100AbnormalState": "G100 异常状态",
    "G100AbnormalState": "G100 异常状态",
    "g100ResetCount": "G100 近30天复位次数",
    "G100ResetCount": "G100 近30天复位次数",
    "g100AbnornalCount10Min": "G100 近10分钟异常状态次数",
    "G100AbnornalCount10Min": "G100 近10分钟异常状态次数",
    "g100AbnornalCountDay": "G100 一天内异常状态次数",
    "G100AbnornalCountDay": "G100 一天内异常状态次数",
    "connectStatus": "并离网状态",
    "ConnectStatus": "并离网状态",
    "airCondStartStopCtrl": "空调控制",
    "AirCondStartStopCtrl": "空调控制",
    "enTraceLoad": "使能负荷跟踪",
    "EnTraceLoad": "使能负荷跟踪",
    "enProtectReverse": "使能逆流防护",
    "EnProtectReverse": "使能逆流防护",
    "enProtectTransf": "需量控制",
    "EnProtectTransf": "需量控制",
    "k1": "需量控制系数(%)",
    "K1": "需量控制系数(%)",
    "k2": "负载跟踪系数(%)",
    "K2": "负载跟踪系数(%)",
    "k3": "多站点分配系数(%)",
    "K3": "多站点分配系数(%)",
    "SOCmax": "最大充电SOC(%)",
    "SOCmin": "最小放电SOC(%)",
    "pset": "防逆流余量(kW)",
    "Pset": "防逆流余量(kW)",
    "adjpreriod": "调整间隔(秒)",
    "Adjpreriod": "调整间隔(秒)",
    "tempThreshold": "温度阈值(℃)",
    "TempThreshold": "温度阈值(℃)",
    "loadTrackingLimit": "使能负荷跟踪限制",
    "LoadTrackingLimit": "使能负荷跟踪限制",
    "enProtectDOD": "使能DOD防护",
    "EnProtectDOD": "使能DOD防护",
    "enDraughtFanPower": "使能风机跟随功率",
    "EnDraughtFanPower": "使能风机跟随功率",
    "DFanPowerThreShold": "风机跟随功率门限(kW)",
    "enDraughtFanTem": "使能风机跟随温度",
    "EnDraughtFanTem": "使能风机跟随温度",
    "DFanTemThreShold": "风机跟随温度门限(℃)",
    "deadTime": "跟随时间死区(s)",
    "DeadTime": "跟随时间死区(s)",
    "pcsAutoTurn": "自动PCS关机",
    "PcsAutoTurn": "自动PCS关机",
    "pcsAutoTurnOffTime": "自动PCS关机时间(s)",
    "PcsAutoTurnOffTime": "自动PCS关机时间(s)",
    "workSamplePeriod": "工作时电芯抽样间隔(s)",
    "WorkSamplePeriod": "工作时电芯抽样间隔(s)",
    "idleSamplePeriod": "空闲时电芯抽样间隔(s)",
    "IdleSamplePeriod": "空闲时电芯抽样间隔(s)",
    "enableAutoCool": "使能液冷机管理",
    "EnableAutoCool": "使能液冷机管理",
    "enSelfLoopDiff": "使能间隙自循环",
    "EnSelfLoopDiff": "使能间隙自循环",
    "WStartHot": "工作段制热启动温度(℃)",
    "WEndHot": "工作段制热停止温度(℃)",
    "WStartCool": "工作段制冷启动温度(℃)",
    "WEndCool": "工作段制冷停止温度(℃)",
    "WDistHot": "工作段制热目标温度(℃)",
    "WDistCool": "工作段制冷目标温度(℃)",
    "enableAirCond": "使能空调控制",
    "EnableAirCond": "使能空调控制",
    "airCondAheadTime": "空调提前启动时间(min)",
    "AirCondAheadTime": "空调提前启动时间(min)",
    "protectReverseWin": "防逆流滑动窗口(s)",
    "ProtectReverseWin": "防逆流滑动窗口(s)",
    "pvMaxPower": "光伏额定功率(kW)",
    "PvMaxPower": "光伏额定功率(kW)",
    "demandWin": "需量滑动窗口(s)",
    "DemandWin": "需量滑动窗口(s)",
    "bmsPowerLimit": "使能BMS功率限制",
    "BmsPowerLimit": "使能BMS功率限制",
    "enProtectTrasLV": "使能低压需量控制",
    "EnProtectTrasLV": "使能低压需量控制",
    "PLVmlmax": "低压变压器容量(kVA)",
    "k4": "低压需量控制系数(%)",
    "K4": "低压需量控制系数(%)",
    "airCondDelayTime": "空调延后关机时间(min)",
    "AirCondDelayTime": "空调延后关机时间(min)",
    "startSelfLoopDiff": "自循环启动温差(℃)",
    "StartSelfLoopDiff": "自循环启动温差(℃)",
    "singleMaxVoltage": "单体过压保护阈值(V)",
    "singleMinVoltage": "单体欠压保护阈值(V)",
    "enSingleVoltage": "使能单体电压保护",
    "singleMaxVoltageErr": "单体过压保护偏差(V)",
    "singleMinVoltageErr": "单体欠压保护偏差(V)",
    "SOCminErr": "禁放SOC回差(%)",
    "SOCmaxErr": "禁充SOC回差(%)",
    "dischargeMaxPower": "系统最大放电功率(kW)",
    "chargeMaxPower": "系统最大充电功率(kW)",
    "demandMargin": "需量余量",
    "DemandMargin": "需量余量",
    "dynamicAugmentation": "动态增容余量",
    "DynamicAugmentation": "动态增容余量",
    "accident_tgi": "事故反演时间颗粒度",
    "Accident_tgi": "事故反演时间颗粒度",
    "accident_en": "事故反演本地使能开关",
    "Accident_en": "事故反演本地使能开关",
    "installedcab_coeff": "装机功率系数",
    "Installedcab_coeff": "装机功率系数",
    "singleVoltageTime": "单体电压保护延时(s)",
    "SingleVoltageTime": "单体电压保护延时(s)",
    "isDisableByMaster": "是否被主机禁用",
    "IsDisableByMaster": "是否被主机禁用",
    "clrAlarm": "清除保护",
    "ClrAlarm": "清除保护",
    "enIoProtect": "使能动环保护",
    "EnIoProtect": "使能动环保护",
    "TMSCtrlState": "液冷机控制",
    "fan": "风机",
    "Fan": "风机",
    "TMSCtrlTempCold": "输出制冷目标温度(℃)",
    "TMSCtrlTempHot": "输出制热目标温度(℃)",
    "bmsUpper": "BMS上下高压",
    "BmsUpper": "BMS上下高压",
    "ENRPComp": "使能无功功率补偿",
    "setPowerFactor": "设置功率因数",
    "SetPowerFactor": "设置功率因数",
    "enDataCollect": "使能数据汇聚",
    "EnDataCollect": "使能数据汇聚",
    "g100Enable": "G100 使能",
    "G100Enable": "G100 使能",
    "g100UnlockTime": "G100 允许解锁时间(min)",
    "G100UnlockTime": "G100 允许解锁时间(min)",
    "g100ResetMaxCount": "G100 30天内最大复位次数",
    "G100ResetMaxCount": "G100 30天内最大复位次数",
    "g100BabnormalCount10Min": "G100 10分钟内最大异常次数",
    "G100BabnormalCount10Min": "G100 10分钟内最大异常次数",
    "g100BabnormalCountDay": "G100 1天内最大异常次数",
    "G100BabnormalCountDay": "G100 1天内最大异常次数",
    "g100BackflowLimit": "G100 逆流限值(kW)",
    "G100BackflowLimit": "G100 逆流限值(kW)",
    "g100BackflowSec": "G100 逆流滤波时间(s)",
    "G100BackflowSec": "G100 逆流滤波时间(s)",
    "g100BackflowLockTime": "G100 逆流锁定时间(s)",
    "G100BackflowLockTime": "G100 逆流锁定时间(s)",
    "g100OverloadLimit": "G100 过载限值(kVA)",
    "G100OverloadLimit": "G100 过载限值(kVA)",
    "g100OverloadSec": "G100 过载滤波时间(s)",
    "G100OverloadSec": "G100 过载滤波时间(s)",
    "g100OverloadLockTime": "G100 过载锁定时间(s)",
    "G100OverloadLockTime": "G100 过载锁定时间(s)",
    "heatCtrCycle": "热管理控制周期(s)",
    "HeatCtrCycle": "热管理控制周期(s)",
    "enSwD2C": "使能逆流转充",
    "EnSwD2C": "使能逆流转充",
    "enSwC2D": "使能超容转放",
    "EnSwC2D": "使能超容转放",
    "powerLimit": "限制功率",
    "PowerLimit": "限制功率",
    "clrManualProtect": "清除手动保护",
    "ClrManualProtect": "清除手动保护",
    "SStartHot": "空闲段制热启动温度(℃)",
    "SEndHot": "空闲段制热停止温度(℃)",
    "SStartCool": "空闲段制冷启动温度(℃)",
    "SEndCool": "空闲段制冷停止温度(℃)",
    "SDistHot": "空闲段制热目标温度(℃)",
    "SDistCool": "空闲段制冷目标温度(℃)",
    "endSelfLoopDiff": "自循环停止温差(℃)",
    "EndSelfLoopDiff": "自循环停止温差(℃)"
  },
  "TMS": {
    "online": "在线",
    "Online": "在线",
    "unitSta": "液冷机组控制模式(读)",
    "UnitSta": "液冷机组控制模式(读)",
    "inflowTemp": "机组回水温度(℃)",
    "InflowTemp": "机组回水温度(℃)",
    "effluentTemp": "机组出水温度(℃)",
    "EffluentTemp": "机组出水温度(℃)",
    "refPreTemp": "预留",
    "RefPreTemp": "预留",
    "refRetDiff": "预留",
    "RefRetDiff": "预留",
    "heatPreTemp": "预留",
    "HeatPreTemp": "预留",
    "heatRetDiff": "预留",
    "HeatRetDiff": "预留",
    "pumpStatue": "水泵运行状态",
    "PumpStatue": "水泵运行状态",
    "compressorStatue1": "压缩机运行状态1",
    "CompressorStatue1": "压缩机运行状态1",
    "compressorStatue2": "压缩机运行状态2",
    "CompressorStatue2": "压缩机运行状态2",
    "heaterState": "电加热运行状态",
    "HeaterState": "电加热运行状态",
    "coolFanState": "冷凝风机运行状态",
    "CoolFanState": "冷凝风机运行状态",
    "outtWaterPre": "机组出水压力(Bar)",
    "OuttWaterPre": "机组出水压力(Bar)",
    "retWaterPre": "机组回水压力(Bar)",
    "RetWaterPre": "机组回水压力(Bar)",
    "envTemp": "机组外环境温度(℃)",
    "EnvTemp": "机组外环境温度(℃)",
    "unrWaterPumpState": "补液水泵状态",
    "UnrWaterPumpState": "补液水泵状态",
    "warnFault": "故障告警",
    "WarnFault": "故障告警",
    "RTargetTemp": "机组设定温度(读)",
    "controlMode": "液冷机组控制模式(写)",
    "ControlMode": "液冷机组控制模式(写)",
    "onOff": "机组开关机使能",
    "OnOff": "机组开关机使能",
    "targetTemp": "机组设定温度",
    "TargetTemp": "机组设定温度"
  },
  "STS": {
    "online": "在线",
    "Online": "在线",
    "read_1": "DSP版本软件V信息",
    "Read_1": "DSP版本软件V信息",
    "read_2": "DSP版本软件B信息",
    "Read_2": "DSP版本软件B信息",
    "read_3": "DSP版本软件D信息",
    "Read_3": "DSP版本软件D信息",
    "read_4": "CPLD版本软件V信息",
    "Read_4": "CPLD版本软件V信息",
    "read_5": "CPLD版本软件B信息",
    "Read_5": "CPLD版本软件B信息",
    "read_6": "CPLD版本软件D信息",
    "Read_6": "CPLD版本软件D信息",
    "read_7": "STS导通状态",
    "Read_7": "STS导通状态",
    "read_8": "晶闸管闭合信号",
    "Read_8": "晶闸管闭合信号",
    "read_9": "STS状态",
    "Read_9": "STS状态",
    "read_10": "STS温度(℃)",
    "Read_10": "STS温度(℃)",
    "read_11": "电网频率(Hz)",
    "Read_11": "电网频率(Hz)",
    "read_12": "电网A相电压有效值(V)",
    "Read_12": "电网A相电压有效值(V)",
    "read_13": "电网B相电压有效值(V)",
    "Read_13": "电网B相电压有效值(V)",
    "read_14": "电网C相电压有效值(V)",
    "Read_14": "电网C相电压有效值(V)",
    "read_15": "电网AB线电压有效值(V)",
    "Read_15": "电网AB线电压有效值(V)",
    "read_16": "电网BC线电压有效值(V)",
    "Read_16": "电网BC线电压有效值(V)",
    "read_17": "电网CA线电压有效值(V)",
    "Read_17": "电网CA线电压有效值(V)",
    "read_18": "电网A相电流有效值(A)",
    "Read_18": "电网A相电流有效值(A)",
    "read_19": "电网B相电流有效值(A)",
    "Read_19": "电网B相电流有效值(A)",
    "read_20": "电网C相电流有效值(A)",
    "Read_20": "电网C相电流有效值(A)",
    "read_21": "电网A相有功功率(kW)",
    "Read_21": "电网A相有功功率(kW)",
    "read_22": "电网B相有功功率(kW)",
    "Read_22": "电网B相有功功率(kW)",
    "read_23": "电网C相有功功率(kW)",
    "Read_23": "电网C相有功功率(kW)",
    "read_24": "电网A相无功功率(kVAr)",
    "Read_24": "电网A相无功功率(kVAr)",
    "read_25": "电网B相无功功率(kVAr)",
    "Read_25": "电网B相无功功率(kVAr)",
    "read_26": "电网C相无功功率(kVAr)",
    "Read_26": "电网C相无功功率(kVAr)",
    "read_27": "电网A相视在功率(kVA)",
    "Read_27": "电网A相视在功率(kVA)",
    "read_28": "电网B相视在功率(kVA)",
    "Read_28": "电网B相视在功率(kVA)",
    "read_29": "电网C相视在功率(kVA)",
    "Read_29": "电网C相视在功率(kVA)",
    "read_30": "电网A相功率因数",
    "Read_30": "电网A相功率因数",
    "read_31": "电网B相功率因数",
    "Read_31": "电网B相功率因数",
    "read_32": "电网C相功率因数",
    "Read_32": "电网C相功率因数",
    "read_33": "总有功功率(kW)",
    "Read_33": "总有功功率(kW)",
    "read_34": "总无功功率(kVAr)",
    "Read_34": "总无功功率(kVAr)",
    "read_35": "总视在功率(kVA)",
    "Read_35": "总视在功率(kVA)",
    "read_36": "硬件故障字1",
    "Read_36": "硬件故障字1",
    "read_37": "硬件故障字2",
    "Read_37": "硬件故障字2",
    "read_38": "电网故障字",
    "Read_38": "电网故障字",
    "read_39": "母线故障字",
    "Read_39": "母线故障字",
    "read_40": "交流电容故障字",
    "Read_40": "交流电容故障字",
    "read_41": "系统故障字",
    "Read_41": "系统故障字",
    "read_42": "开关故障字",
    "Read_42": "开关故障字",
    "read_43": "其他故障字",
    "Read_43": "其他故障字"
  },
  "DIDO": {
    "online": "在线",
    "Online": "在线",
    "di": "DI1~DI16 逗号分隔",
    "doField": "DO1~DO6 逗号分隔",
    "dout": "DO1~DO6 逗号分隔",
    "NC1": "NC1",
    "NC2": "NC2"
  }
};

// 枚举字段的值映射：FIELD_VALUE_MAPS[deviceType][fieldKey] = { 0: "停止", 1: "运行" }
// 字段列只显示 FIELD_LABELS 中的中文名；值列按本表把 0/1 等码值翻译为中文
export const FIELD_VALUE_MAPS = {
  "BMS": {
    "reportId": {},
    "online": {
      "0": "离线",
      "1": "在线"
    },
    "Online": {
      "0": "离线",
      "1": "在线"
    },
    "SOC": {},
    "SOH": {},
    "rackVoltage": {},
    "RackVoltage": {},
    "rackCurrent": {},
    "RackCurrent": {},
    "rackMaxVoltage": {},
    "RackMaxVoltage": {},
    "rackMaxVolCellId": {},
    "RackMaxVolCellId": {},
    "rackMinVoltage": {},
    "RackMinVoltage": {},
    "rackMinVolCellId": {},
    "RackMinVolCellId": {},
    "rackMaxTemp": {},
    "RackMaxTemp": {},
    "rackMaxTempCellId": {},
    "RackMaxTempCellId": {},
    "rackMinTemp": {},
    "RackMinTemp": {},
    "rackMinTempCellId": {},
    "RackMinTempCellId": {},
    "rackRunState": {},
    "RackRunState": {},
    "rackInsulatValue": {},
    "RackInsulatValue": {},
    "rackPosInsulatVal": {},
    "RackPosInsulatVal": {},
    "rackNegInsulatVal": {},
    "RackNegInsulatVal": {},
    "rackChgCap": {},
    "RackChgCap": {},
    "rackDsgCap": {},
    "RackDsgCap": {},
    "rackOneChgCap": {},
    "RackOneChgCap": {},
    "rackOneDisCap": {},
    "RackOneDisCap": {},
    "allChargeVol": {},
    "AllChargeVol": {},
    "allDisChargeVol": {},
    "AllDisChargeVol": {},
    "read_15": {
      "0": "断开",
      "1": "闭合"
    },
    "Read_15": {
      "0": "断开",
      "1": "闭合"
    },
    "read_16": {
      "0": "断开",
      "1": "闭合"
    },
    "Read_16": {
      "0": "断开",
      "1": "闭合"
    },
    "read_17": {
      "0": "断开",
      "1": "闭合"
    },
    "Read_17": {
      "0": "断开",
      "1": "闭合"
    },
    "rackState": {
      "0": "Standby mode",
      "1": "Discharge mode",
      "2": "Charge mode",
      "3": "Shutdown mode"
    },
    "RackState": {
      "0": "Standby mode",
      "1": "Discharge mode",
      "2": "Charge mode",
      "3": "Shutdown mode"
    },
    "READ12": {},
    "rackAverageVolt": {},
    "RackAverageVolt": {},
    "READ1": {},
    "READ2": {},
    "rackAverageTemp": {},
    "RackAverageTemp": {},
    "READ3": {},
    "READ4": {},
    "READ5": {},
    "READ6": {},
    "READ7": {},
    "READ8": {},
    "READ9": {},
    "READ10": {},
    "read_1": {
      "0": "正常",
      "1": "轻微故障",
      "2": "较严重故障",
      "3": "严重故障"
    },
    "Read_1": {
      "0": "正常",
      "1": "轻微故障",
      "2": "较严重故障",
      "3": "严重故障"
    },
    "read_2": {
      "0": "正常",
      "1": "轻微故障",
      "2": "较严重故障",
      "3": "严重故障"
    },
    "Read_2": {
      "0": "正常",
      "1": "轻微故障",
      "2": "较严重故障",
      "3": "严重故障"
    },
    "read_3": {
      "0": "正常",
      "1": "轻微故障",
      "2": "较严重故障",
      "3": "严重故障"
    },
    "Read_3": {
      "0": "正常",
      "1": "轻微故障",
      "2": "较严重故障",
      "3": "严重故障"
    },
    "read_4": {
      "0": "正常",
      "1": "轻微故障",
      "2": "较严重故障",
      "3": "严重故障"
    },
    "Read_4": {
      "0": "正常",
      "1": "轻微故障",
      "2": "较严重故障",
      "3": "严重故障"
    },
    "read_5": {
      "0": "正常",
      "1": "轻微故障",
      "2": "较严重故障",
      "3": "严重故障"
    },
    "Read_5": {
      "0": "正常",
      "1": "轻微故障",
      "2": "较严重故障",
      "3": "严重故障"
    },
    "read_6": {
      "0": "正常",
      "1": "轻微故障",
      "2": "较严重故障",
      "3": "严重故障"
    },
    "Read_6": {
      "0": "正常",
      "1": "轻微故障",
      "2": "较严重故障",
      "3": "严重故障"
    },
    "read_7": {
      "0": "正常",
      "1": "轻微故障",
      "2": "较严重故障",
      "3": "严重故障"
    },
    "Read_7": {
      "0": "正常",
      "1": "轻微故障",
      "2": "较严重故障",
      "3": "严重故障"
    },
    "read_8": {
      "0": "正常",
      "1": "轻微故障",
      "2": "较严重故障",
      "3": "严重故障"
    },
    "Read_8": {
      "0": "正常",
      "1": "轻微故障",
      "2": "较严重故障",
      "3": "严重故障"
    },
    "read_9": {
      "0": "正常",
      "1": "轻微故障",
      "2": "较严重故障",
      "3": "严重故障"
    },
    "Read_9": {
      "0": "正常",
      "1": "轻微故障",
      "2": "较严重故障",
      "3": "严重故障"
    },
    "read_10": {
      "0": "正常",
      "1": "轻微故障",
      "2": "较严重故障",
      "3": "严重故障"
    },
    "Read_10": {
      "0": "正常",
      "1": "轻微故障",
      "2": "较严重故障",
      "3": "严重故障"
    },
    "read_11": {
      "0": "正常",
      "1": "轻微故障",
      "2": "较严重故障",
      "3": "严重故障"
    },
    "Read_11": {
      "0": "正常",
      "1": "轻微故障",
      "2": "较严重故障",
      "3": "严重故障"
    },
    "read_12": {
      "0": "正常",
      "1": "轻微故障",
      "2": "较严重故障",
      "3": "严重故障"
    },
    "Read_12": {
      "0": "正常",
      "1": "轻微故障",
      "2": "较严重故障",
      "3": "严重故障"
    },
    "read_13": {
      "0": "正常",
      "1": "故障"
    },
    "Read_13": {
      "0": "正常",
      "1": "故障"
    },
    "read_14": {
      "0": "正常",
      "1": "故障"
    },
    "Read_14": {
      "0": "正常",
      "1": "故障"
    },
    "READ11": {},
    "READ13": {},
    "isPeriod": {
      "0": "实时数据",
      "1": "周期数据"
    }
  },
  "CELL": {
    "reportId": {},
    "online": {
      "0": "离线",
      "1": "在线"
    },
    "voltageMv": {},
    "temperature": {}
  },
  "PCS": {
    "reportId": {},
    "online": {
      "0": "离线",
      "1": "在线"
    },
    "Online": {
      "0": "离线",
      "1": "在线"
    },
    "aphaseVoltage": {},
    "AphaseVoltage": {},
    "bphaseVoltage": {},
    "BphaseVoltage": {},
    "cphaseVoltage": {},
    "CphaseVoltage": {},
    "aphaseCurrent": {},
    "AphaseCurrent": {},
    "bphaseCurrent": {},
    "BphaseCurrent": {},
    "cphaseCurrent": {},
    "CphaseCurrent": {},
    "activePower": {},
    "ActivePower": {},
    "aphaseActPower": {},
    "AphaseActPower": {},
    "bphaseActPower": {},
    "BphaseActPower": {},
    "cphaseActPower": {},
    "CphaseActPower": {},
    "reactivePower": {},
    "ReactivePower": {},
    "aphaseReactivePower": {},
    "AphaseReactivePower": {},
    "bphaseReactivePower": {},
    "BphaseReactivePower": {},
    "cphaseReactivePower": {},
    "CphaseReactivePower": {},
    "apparentPower": {},
    "ApparentPower": {},
    "aphaseApparentPower": {},
    "AphaseApparentPower": {},
    "bphaseApparentPower": {},
    "BphaseApparentPower": {},
    "cphaseApparentPower": {},
    "CphaseApparentPower": {},
    "factor": {},
    "Factor": {},
    "aphaseFactor": {},
    "AphaseFactor": {},
    "bphaseFactor": {},
    "BphaseFactor": {},
    "cphaseFactor": {},
    "CphaseFactor": {},
    "frequency": {},
    "Frequency": {},
    "runStatu": {
      "0": "停机",
      "1": "开机中",
      "3": "开机中",
      "5": "待机",
      "9": "运行",
      "32": "故障",
      "64": "故障",
      "257": "运行",
      "8256": "故障"
    },
    "RunStatu": {
      "0": "停机",
      "1": "开机中",
      "3": "开机中",
      "5": "待机",
      "9": "运行",
      "32": "故障",
      "64": "故障",
      "257": "运行",
      "8256": "故障"
    },
    "sysGridstatus": {},
    "SysGridstatus": {},
    "sysOffGridstatus": {},
    "SysOffGridstatus": {},
    "controlMode": {},
    "ControlMode": {},
    "heatSinkTemp": {},
    "HeatSinkTemp": {},
    "ABphaseVoltage": {},
    "BCphaseVoltage": {},
    "CAphaseVoltage": {},
    "aphaseCurrentdg": {},
    "AphaseCurrentdg": {},
    "bphaseCurrentdg": {},
    "BphaseCurrentdg": {},
    "cphaseCurrentdg": {},
    "CphaseCurrentdg": {},
    "read_1": {
      "0": "正序",
      "1": "负序"
    },
    "Read_1": {
      "0": "正序",
      "1": "负序"
    },
    "aphaseReactPower": {},
    "AphaseReactPower": {},
    "bphaseReactPower": {},
    "BphaseReactPower": {},
    "cphaseReactPower": {},
    "CphaseReactPower": {},
    "ACFactor": {},
    "batVolt": {},
    "BatVolt": {},
    "batCurr": {},
    "BatCurr": {},
    "charDisChar": {
      "0": "静置",
      "1": "充电",
      "2": "放电"
    },
    "CharDisChar": {
      "0": "静置",
      "1": "充电",
      "2": "放电"
    },
    "batPower": {},
    "BatPower": {},
    "batTCurr": {},
    "BatTCurr": {},
    "TVolt": {},
    "PVolt": {},
    "MVolt": {},
    "devFault": {
      "0": "正常",
      "1": "故障"
    },
    "DevFault": {
      "0": "正常",
      "1": "故障"
    },
    "IGBTTemp": {},
    "ENVemp": {},
    "INDemp": {},
    "work_pattern": {
      "0": "直流电压源模式(ACDC 源使用)",
      "1": "交流电流源模式(恒流、恒功率)"
    },
    "Work_pattern": {
      "0": "直流电压源模式(ACDC 源使用)",
      "1": "交流电流源模式(恒流、恒功率)"
    },
    "gridOnOff": {
      "0": "停机",
      "1": "开机中",
      "2": "待机",
      "3": "离网运行",
      "4": "并网运行",
      "5": "故障",
      "6": "调试中"
    },
    "GridOnOff": {
      "0": "停机",
      "1": "开机中",
      "2": "待机",
      "3": "离网运行",
      "4": "并网运行",
      "5": "故障",
      "6": "调试中"
    },
    "DSP_V": {},
    "DSP_B": {},
    "DSP_D": {},
    "CPLD_V": {},
    "CPLD_B": {},
    "CPLD_D": {},
    "read_2": {},
    "Read_2": {},
    "read_3": {},
    "Read_3": {},
    "read_4": {},
    "Read_4": {},
    "read_5": {},
    "Read_5": {},
    "read_6": {},
    "Read_6": {},
    "read_7": {},
    "Read_7": {},
    "read_8": {},
    "Read_8": {},
    "read_9": {},
    "Read_9": {},
    "insulationdetectionvalue_rx": {},
    "Insulationdetectionvalue_rx": {},
    "insulationdetectionvalue_ry": {},
    "Insulationdetectionvalue_ry": {},
    "hardwareFaultWord1": {
      "0": "正常",
      "1": "故障"
    },
    "HardwareFaultWord1": {
      "0": "正常",
      "1": "故障"
    },
    "EPOFault": {
      "0": "正常",
      "1": "故障"
    },
    "IGBTHardwareOver": {
      "0": "正常",
      "1": "故障"
    },
    "busHardwareOver": {
      "0": "正常",
      "1": "故障"
    },
    "BusHardwareOver": {
      "0": "正常",
      "1": "故障"
    },
    "waveThrottling": {
      "0": "正常",
      "1": "故障"
    },
    "WaveThrottling": {
      "0": "正常",
      "1": "故障"
    },
    "balanceHardwareOver": {
      "0": "正常",
      "1": "故障"
    },
    "BalanceHardwareOver": {
      "0": "正常",
      "1": "故障"
    },
    "hardwareFaultWord2": {
      "0": "正常",
      "1": "故障"
    },
    "HardwareFaultWord2": {
      "0": "正常",
      "1": "故障"
    },
    "_24VPowerFault": {
      "0": "正常",
      "1": "故障"
    },
    "24VPowerFault": {
      "0": "正常",
      "1": "故障"
    },
    "fanFault": {
      "0": "正常",
      "1": "故障"
    },
    "FanFault": {
      "0": "正常",
      "1": "故障"
    },
    "linkFault": {
      "0": "正常",
      "1": "故障"
    },
    "LinkFault": {
      "0": "正常",
      "1": "故障"
    },
    "outIO3Fault": {
      "0": "正常",
      "1": "故障"
    },
    "OutIO3Fault": {
      "0": "正常",
      "1": "故障"
    },
    "surgeProtectFault": {
      "0": "正常",
      "1": "故障"
    },
    "SurgeProtectFault": {
      "0": "正常",
      "1": "故障"
    },
    "powerOverHeated": {
      "0": "正常",
      "1": "故障"
    },
    "PowerOverHeated": {
      "0": "正常",
      "1": "故障"
    },
    "balanceOverHeated": {
      "0": "正常",
      "1": "故障"
    },
    "BalanceOverHeated": {
      "0": "正常",
      "1": "故障"
    },
    "_15VPowerFault": {
      "0": "正常",
      "1": "故障"
    },
    "15VPowerFault": {
      "0": "正常",
      "1": "故障"
    },
    "fireAlarmFault": {
      "0": "正常",
      "1": "故障"
    },
    "FireAlarmFault": {
      "0": "正常",
      "1": "故障"
    },
    "outIO1Fault": {
      "0": "正常",
      "1": "故障"
    },
    "OutIO1Fault": {
      "0": "正常",
      "1": "故障"
    },
    "outIO2Fault": {
      "0": "正常",
      "1": "故障"
    },
    "OutIO2Fault": {
      "0": "正常",
      "1": "故障"
    },
    "environmentTempHighFault": {
      "0": "正常",
      "1": "故障"
    },
    "EnvironmentTempHighFault": {
      "0": "正常",
      "1": "故障"
    },
    "IOTempHighFault": {
      "0": "正常",
      "1": "故障"
    },
    "gridFaultWord": {
      "0": "正常",
      "1": "故障"
    },
    "GridFaultWord": {
      "0": "正常",
      "1": "故障"
    },
    "aphaseOverVoltage": {
      "0": "正常",
      "1": "故障"
    },
    "AphaseOverVoltage": {
      "0": "正常",
      "1": "故障"
    },
    "bphaseOverVoltage": {
      "0": "正常",
      "1": "故障"
    },
    "BphaseOverVoltage": {
      "0": "正常",
      "1": "故障"
    },
    "cphaseOverVoltage": {
      "0": "正常",
      "1": "故障"
    },
    "CphaseOverVoltage": {
      "0": "正常",
      "1": "故障"
    },
    "aphaseUnderVoltage": {
      "0": "正常",
      "1": "故障"
    },
    "AphaseUnderVoltage": {
      "0": "正常",
      "1": "故障"
    },
    "bphaseUnderVoltage": {
      "0": "正常",
      "1": "故障"
    },
    "BphaseUnderVoltage": {
      "0": "正常",
      "1": "故障"
    },
    "cphaseUnderVoltage": {
      "0": "正常",
      "1": "故障"
    },
    "CphaseUnderVoltage": {
      "0": "正常",
      "1": "故障"
    },
    "gridOverFrequency": {
      "0": "正常",
      "1": "故障"
    },
    "GridOverFrequency": {
      "0": "正常",
      "1": "故障"
    },
    "gridUnderFrequency": {
      "0": "正常",
      "1": "故障"
    },
    "GridUnderFrequency": {
      "0": "正常",
      "1": "故障"
    },
    "gridPhaseError": {
      "0": "正常",
      "1": "故障"
    },
    "GridPhaseError": {
      "0": "正常",
      "1": "故障"
    },
    "aphaseSoftOver": {
      "0": "正常",
      "1": "故障"
    },
    "AphaseSoftOver": {
      "0": "正常",
      "1": "故障"
    },
    "bphaseSoftOver": {
      "0": "正常",
      "1": "故障"
    },
    "BphaseSoftOver": {
      "0": "正常",
      "1": "故障"
    },
    "cphaseSoftOver": {
      "0": "正常",
      "1": "故障"
    },
    "CphaseSoftOver": {
      "0": "正常",
      "1": "故障"
    },
    "gridVoltageImbalance": {
      "0": "正常",
      "1": "故障"
    },
    "GridVoltageImbalance": {
      "0": "正常",
      "1": "故障"
    },
    "gridCurrentImbalance": {
      "0": "正常",
      "1": "故障"
    },
    "GridCurrentImbalance": {
      "0": "正常",
      "1": "故障"
    },
    "gridPhaseLack": {
      "0": "正常",
      "1": "故障"
    },
    "GridPhaseLack": {
      "0": "正常",
      "1": "故障"
    },
    "NLineOver": {
      "0": "正常",
      "1": "故障"
    },
    "busFaultWord": {
      "0": "正常",
      "1": "故障"
    },
    "BusFaultWord": {
      "0": "正常",
      "1": "故障"
    },
    "preBusOvervoltage": {
      "0": "正常",
      "1": "故障"
    },
    "PreBusOvervoltage": {
      "0": "正常",
      "1": "故障"
    },
    "preBusUndervoltage": {
      "0": "正常",
      "1": "故障"
    },
    "PreBusUndervoltage": {
      "0": "正常",
      "1": "故障"
    },
    "runBusOvervoltage": {
      "0": "正常",
      "1": "故障"
    },
    "RunBusOvervoltage": {
      "0": "正常",
      "1": "故障"
    },
    "runBusUndervoltage": {
      "0": "正常",
      "1": "故障"
    },
    "RunBusUndervoltage": {
      "0": "正常",
      "1": "故障"
    },
    "PNBusImbalance": {
      "0": "正常",
      "1": "故障"
    },
    "rackUndervoltage": {
      "0": "正常",
      "1": "故障"
    },
    "RackUndervoltage": {
      "0": "正常",
      "1": "故障"
    },
    "rackOvervoltage": {
      "0": "正常",
      "1": "故障"
    },
    "RackOvervoltage": {
      "0": "正常",
      "1": "故障"
    },
    "DCPreOvercurrent": {
      "0": "正常",
      "1": "故障"
    },
    "DCOvercurrent": {
      "0": "正常",
      "1": "故障"
    },
    "balanceSoftOver": {
      "0": "正常",
      "1": "故障"
    },
    "BalanceSoftOver": {
      "0": "正常",
      "1": "故障"
    },
    "rackReverse": {
      "0": "正常",
      "1": "故障"
    },
    "RackReverse": {
      "0": "正常",
      "1": "故障"
    },
    "ACCapacitorFaultWord": {
      "0": "正常",
      "1": "故障"
    },
    "prechargeTimeOut": {
      "0": "正常",
      "1": "故障"
    },
    "PrechargeTimeOut": {
      "0": "正常",
      "1": "故障"
    },
    "aphasePrechargeTimeOut": {
      "0": "正常",
      "1": "故障"
    },
    "AphasePrechargeTimeOut": {
      "0": "正常",
      "1": "故障"
    },
    "bphasePrechargeTimeOut": {
      "0": "正常",
      "1": "故障"
    },
    "BphasePrechargeTimeOut": {
      "0": "正常",
      "1": "故障"
    },
    "cphasePrechargeTimeOut": {
      "0": "正常",
      "1": "故障"
    },
    "CphasePrechargeTimeOut": {
      "0": "正常",
      "1": "故障"
    },
    "leakageCurrentPrecharge": {
      "0": "正常",
      "1": "故障"
    },
    "LeakageCurrentPrecharge": {
      "0": "正常",
      "1": "故障"
    },
    "systemFaultWord": {
      "0": "正常",
      "1": "故障"
    },
    "SystemFaultWord": {
      "0": "正常",
      "1": "故障"
    },
    "RAMFault": {
      "0": "正常",
      "1": "故障"
    },
    "EEPROMFault": {
      "0": "正常",
      "1": "故障"
    },
    "ADSampleZeroDrift": {
      "0": "正常",
      "1": "故障"
    },
    "backTelecomFault": {
      "0": "正常",
      "1": "故障"
    },
    "BackTelecomFault": {
      "0": "正常",
      "1": "故障"
    },
    "CANFault": {
      "0": "正常",
      "1": "故障"
    },
    "CPLDTelecomFault": {
      "0": "正常",
      "1": "故障"
    },
    "datalogFault": {
      "0": "正常",
      "1": "故障"
    },
    "DatalogFault": {
      "0": "正常",
      "1": "故障"
    },
    "insulationDetectionFault": {
      "0": "正常",
      "1": "故障"
    },
    "InsulationDetectionFault": {
      "0": "正常",
      "1": "故障"
    },
    "softwareMismatchFault": {
      "0": "正常",
      "1": "故障"
    },
    "SoftwareMismatchFault": {
      "0": "正常",
      "1": "故障"
    },
    "BMSRackSystemFault": {
      "0": "正常",
      "1": "故障"
    },
    "STSTelecomFault": {
      "0": "正常",
      "1": "故障"
    },
    "BMSTelecomFault": {
      "0": "正常",
      "1": "故障"
    },
    "CANTelecomFault": {
      "0": "正常",
      "1": "故障"
    },
    "EMSTelecomFault": {
      "0": "正常",
      "1": "故障"
    },
    "switchFaultWord": {
      "0": "正常",
      "1": "故障"
    },
    "SwitchFaultWord": {
      "0": "正常",
      "1": "故障"
    },
    "preRelayCloseFail": {
      "0": "正常",
      "1": "故障"
    },
    "PreRelayCloseFail": {
      "0": "正常",
      "1": "故障"
    },
    "preRelayBreakFail": {
      "0": "正常",
      "1": "故障"
    },
    "PreRelayBreakFail": {
      "0": "正常",
      "1": "故障"
    },
    "preRelayCloseStateErr": {
      "0": "正常",
      "1": "故障"
    },
    "PreRelayCloseStateErr": {
      "0": "正常",
      "1": "故障"
    },
    "preRelayBreakStateErr": {
      "0": "正常",
      "1": "故障"
    },
    "PreRelayBreakStateErr": {
      "0": "正常",
      "1": "故障"
    },
    "mainRelayCloseFail": {
      "0": "正常",
      "1": "故障"
    },
    "MainRelayCloseFail": {
      "0": "正常",
      "1": "故障"
    },
    "mainRelayBreakFail": {
      "0": "正常",
      "1": "故障"
    },
    "MainRelayBreakFail": {
      "0": "正常",
      "1": "故障"
    },
    "mainRelayCloseStateErr": {
      "0": "正常",
      "1": "故障"
    },
    "MainRelayCloseStateErr": {
      "0": "正常",
      "1": "故障"
    },
    "mainRelayBreakStateErr": {
      "0": "正常",
      "1": "故障"
    },
    "MainRelayBreakStateErr": {
      "0": "正常",
      "1": "故障"
    },
    "ACMainRelayStickeFault": {
      "0": "正常",
      "1": "故障"
    },
    "DCRelayOpenCircuitFault": {
      "0": "正常",
      "1": "故障"
    },
    "ACRelayOpenCircuitFault": {
      "0": "正常",
      "1": "故障"
    },
    "otherFaultWord": {
      "0": "正常",
      "1": "故障"
    },
    "OtherFaultWord": {
      "0": "正常",
      "1": "故障"
    },
    "PCSAphaseOvervoltage": {
      "0": "正常",
      "1": "故障"
    },
    "PCSBphaseOvervoltage": {
      "0": "正常",
      "1": "故障"
    },
    "PCSCphaseOvervoltage": {
      "0": "正常",
      "1": "故障"
    },
    "gridIslandFault": {
      "0": "正常",
      "1": "故障"
    },
    "GridIslandFault": {
      "0": "正常",
      "1": "故障"
    },
    "systemResonanceFault": {
      "0": "正常",
      "1": "故障"
    },
    "SystemResonanceFault": {
      "0": "正常",
      "1": "故障"
    },
    "softwareover": {
      "0": "正常",
      "1": "故障"
    },
    "Softwareover": {
      "0": "正常",
      "1": "故障"
    },
    "highVoltageThroughTimeOut": {
      "0": "正常",
      "1": "故障"
    },
    "HighVoltageThroughTimeOut": {
      "0": "正常",
      "1": "故障"
    },
    "PCSAphaseUndervoltage": {
      "0": "正常",
      "1": "故障"
    },
    "PCSBphaseUndervoltage": {
      "0": "正常",
      "1": "故障"
    },
    "PCSCphaseUndervoltage": {
      "0": "正常",
      "1": "故障"
    },
    "noSynchronousSignalOffGrid": {
      "0": "正常",
      "1": "故障"
    },
    "NoSynchronousSignalOffGrid": {
      "0": "正常",
      "1": "故障"
    },
    "offGridShortCircuit": {
      "0": "正常",
      "1": "故障"
    },
    "OffGridShortCircuit": {
      "0": "正常",
      "1": "故障"
    },
    "lowVoltageThroughTimeOut": {
      "0": "正常",
      "1": "故障"
    },
    "LowVoltageThroughTimeOut": {
      "0": "正常",
      "1": "故障"
    },
    "modeRunmodesetting": {
      "0": "直流电压源模式",
      "1": "电流源模式"
    },
    "ModeRunmodesetting": {
      "0": "直流电压源模式",
      "1": "电流源模式"
    },
    "single_phasepowersetting": {
      "0": "禁用",
      "1": "使能"
    },
    "Single_phasepowersetting": {
      "0": "禁用",
      "1": "使能"
    },
    "currentsourcesetting": {
      "0": "禁用",
      "1": "使能"
    },
    "Currentsourcesetting": {
      "0": "禁用",
      "1": "使能"
    },
    "settingofparallelmodules": {},
    "Settingofparallelmodules": {},
    "off_gridvoltagesetting": {
      "3891": "线电压380V",
      "4096": "线电压400V"
    },
    "Off_gridvoltagesetting": {
      "3891": "线电压380V",
      "4096": "线电压400V"
    },
    "off_gridfrequencysetting": {},
    "Off_gridfrequencysetting": {},
    "modeHostSetting": {
      "0": "从机",
      "1": "主机"
    },
    "ModeHostSetting": {
      "0": "从机",
      "1": "主机"
    },
    "actPowSet": {},
    "ActPowSet": {},
    "reactPowSet": {},
    "ReactPowSet": {},
    "ASplitPhaseActPowSet": {},
    "ASplitPhaseReactPowSet": {},
    "BSplitPhaseActPowSet": {},
    "BSplitPhaseReactPowSet": {},
    "CSplitPhaseActPowSet": {},
    "CSplitPhaseReactPowSet": {},
    "startStopCtr": {
      "0": "关机",
      "1": "开机"
    },
    "StartStopCtr": {
      "0": "关机",
      "1": "开机"
    },
    "faultRst": {
      "32768": "复位"
    },
    "FaultRst": {
      "32768": "复位"
    },
    "insulationdetectionenabling": {
      "1": "使能"
    },
    "Insulationdetectionenabling": {
      "1": "使能"
    },
    "DCsourcebusbarvoltagesetting": {},
    "gridoverfrequencyprotection": {},
    "Gridoverfrequencyprotection": {},
    "gridunderfrequencyprotection": {},
    "Gridunderfrequencyprotection": {},
    "islandoverfrequencyprotect": {},
    "Islandoverfrequencyprotect": {},
    "islandunderfrequencyprotect": {},
    "Islandunderfrequencyprotect": {},
    "batteryovervolprotectpoint": {},
    "Batteryovervolprotectpoint": {},
    "batteryundervolprotectpoint": {},
    "Batteryundervolprotectpoint": {},
    "gridoperationformaxmchar": {},
    "Gridoperationformaxmchar": {},
    "busovervoltageprotectionpoint": {},
    "Busovervoltageprotectionpoint": {},
    "busundervoltageprotectionpoint": {},
    "Busundervoltageprotectionpoint": {},
    "DCoverflowprotectionpoint": {},
    "AClinevolovervoleprotectpoint": {},
    "AClinevolundervolprotectpoint": {},
    "ACovercurprotectpoint": {},
    "moduleovertempprotectnpoint": {},
    "Moduleovertempprotectnpoint": {},
    "CC_CVhargingbatteryvolpoint": {},
    "batteryconstantvolchargingvol": {},
    "Batteryconstantvolchargingvol": {},
    "maximumtimelimitofCVcharging": {},
    "MaximumtimelimitofCVcharging": {},
    "CVtofloatingchargingflowpointset": {},
    "batteryfloatingCVpointsetting": {},
    "BatteryfloatingCVpointsetting": {},
    "floatingchargetoconstantcurpoint": {},
    "Floatingchargetoconstantcurpoint": {},
    "confirmingparameterinstructions": {
      "256": "固化参数"
    },
    "Confirmingparameterinstructions": {
      "256": "固化参数"
    },
    "reModbusAddress": {},
    "ReModbusAddress": {},
    "reModbusPaudrate": {
      "96": "9600"
    },
    "ReModbusPaudrate": {
      "96": "9600"
    },
    "HMIModbusAddress": {},
    "HMIModbusPaudrate": {
      "96": "9600"
    },
    "EMScomtimefaultthreshold": {},
    "batteryResetCommand": {},
    "BatteryResetCommand": {},
    "setInterfaceForSafetyRegulations": {
      "0": "中国",
      "1": "南非",
      "2": "欧洲",
      "4": "德国",
      "5": "意大利",
      "6": "英国",
      "9": "比利时",
      "10": "瑞典",
      "15": "捷克",
      "16": "匈牙利",
      "17": "泰国",
      "20": "波兰"
    },
    "SetInterfaceForSafetyRegulations": {
      "0": "中国",
      "1": "南非",
      "2": "欧洲",
      "4": "德国",
      "5": "意大利",
      "6": "英国",
      "9": "比利时",
      "10": "瑞典",
      "15": "捷克",
      "16": "匈牙利",
      "17": "泰国",
      "20": "波兰"
    },
    "heartbeatSingle": {},
    "HeartbeatSingle": {}
  },
  "EMS": {
    "reportId": {},
    "controlMode": {
      "0": "手动",
      "1": "自动策略"
    },
    "ControlMode": {
      "0": "手动",
      "1": "自动策略"
    },
    "stratagyType": {
      "0": "计划模式",
      "1": "动态增容"
    },
    "StratagyType": {
      "0": "计划模式",
      "1": "动态增容"
    },
    "onOff": {
      "0": "关机",
      "1": "开机"
    },
    "OnOff": {
      "0": "关机",
      "1": "开机"
    },
    "iec104Heartbeat": {},
    "Iec104Heartbeat": {},
    "modbusTcpHeartbeat": {},
    "ModbusTcpHeartbeat": {},
    "setPower": {},
    "SetPower": {},
    "setRePower": {},
    "SetRePower": {},
    "s1StHour": {},
    "S1StHour": {},
    "s1StMin": {},
    "S1StMin": {},
    "s1EnHour": {},
    "S1EnHour": {},
    "s1EnMin": {},
    "S1EnMin": {},
    "s1Power": {},
    "S1Power": {},
    "s1RePower": {},
    "S1RePower": {},
    "s1SOCUpperLimit": {},
    "S1SOCUpperLimit": {},
    "s1SOCLowerLimit": {},
    "S1SOCLowerLimit": {},
    "s2StHour": {},
    "S2StHour": {},
    "s2StMin": {},
    "S2StMin": {},
    "s2EnHour": {},
    "S2EnHour": {},
    "s2EnMin": {},
    "S2EnMin": {},
    "s2Power": {},
    "S2Power": {},
    "s2RePower": {},
    "S2RePower": {},
    "s2SOCUpperLimit": {},
    "S2SOCUpperLimit": {},
    "s2SOCLowerLimit": {},
    "S2SOCLowerLimit": {},
    "s3StHour": {},
    "S3StHour": {},
    "s3StMin": {},
    "S3StMin": {},
    "s3EnHour": {},
    "S3EnHour": {},
    "s3EnMin": {},
    "S3EnMin": {},
    "s3Power": {},
    "S3Power": {},
    "s3RePower": {},
    "S3RePower": {},
    "s3SOCUpperLimit": {},
    "S3SOCUpperLimit": {},
    "s3SOCLowerLimit": {},
    "S3SOCLowerLimit": {},
    "s4StHour": {},
    "S4StHour": {},
    "s4StMin": {},
    "S4StMin": {},
    "s4EnHour": {},
    "S4EnHour": {},
    "s4EnMin": {},
    "S4EnMin": {},
    "s4Power": {},
    "S4Power": {},
    "s4RePower": {},
    "S4RePower": {},
    "s4SOCUpperLimit": {},
    "S4SOCUpperLimit": {},
    "s4SOCLowerLimit": {},
    "S4SOCLowerLimit": {},
    "s5StHour": {},
    "S5StHour": {},
    "s5StMin": {},
    "S5StMin": {},
    "s5EnHour": {},
    "S5EnHour": {},
    "s5EnMin": {},
    "S5EnMin": {},
    "s5Power": {},
    "S5Power": {},
    "s5RePower": {},
    "S5RePower": {},
    "s5SOCUpperLimit": {},
    "S5SOCUpperLimit": {},
    "s5SOCLowerLimit": {},
    "S5SOCLowerLimit": {},
    "s6StHour": {},
    "S6StHour": {},
    "s6StMin": {},
    "S6StMin": {},
    "s6EnHour": {},
    "S6EnHour": {},
    "s6EnMin": {},
    "S6EnMin": {},
    "s6Power": {},
    "S6Power": {},
    "s6RePower": {},
    "S6RePower": {},
    "s6SOCUpperLimit": {},
    "S6SOCUpperLimit": {},
    "s6SOCLowerLimit": {},
    "S6SOCLowerLimit": {},
    "s7StHour": {},
    "S7StHour": {},
    "s7StMin": {},
    "S7StMin": {},
    "s7EnHour": {},
    "S7EnHour": {},
    "s7EnMin": {},
    "S7EnMin": {},
    "s7Power": {},
    "S7Power": {},
    "s7RePower": {},
    "S7RePower": {},
    "s7SOCUpperLimit": {},
    "S7SOCUpperLimit": {},
    "s7SOCLowerLimit": {},
    "S7SOCLowerLimit": {},
    "s8StHour": {},
    "S8StHour": {},
    "s8StMin": {},
    "S8StMin": {},
    "s8EnHour": {},
    "S8EnHour": {},
    "s8EnMin": {},
    "S8EnMin": {},
    "s8Power": {},
    "S8Power": {},
    "s8RePower": {},
    "S8RePower": {},
    "s8SOCUpperLimit": {},
    "S8SOCUpperLimit": {},
    "s8SOCLowerLimit": {},
    "S8SOCLowerLimit": {},
    "s9StHour": {},
    "S9StHour": {},
    "s9StMin": {},
    "S9StMin": {},
    "s9EnHour": {},
    "S9EnHour": {},
    "s9EnMin": {},
    "S9EnMin": {},
    "s9Power": {},
    "S9Power": {},
    "s9RePower": {},
    "S9RePower": {},
    "s9SOCUpperLimit": {},
    "S9SOCUpperLimit": {},
    "s9SOCLowerLimit": {},
    "S9SOCLowerLimit": {},
    "s10StHour": {},
    "S10StHour": {},
    "s10StMin": {},
    "S10StMin": {},
    "s10EnHour": {},
    "S10EnHour": {},
    "s10EnMin": {},
    "S10EnMin": {},
    "s10Power": {},
    "S10Power": {},
    "s10RePower": {},
    "S10RePower": {},
    "s10SOCUpperLimit": {},
    "S10SOCUpperLimit": {},
    "s10SOCLowerLimit": {},
    "S10SOCLowerLimit": {},
    "s11StHour": {},
    "S11StHour": {},
    "s11StMin": {},
    "S11StMin": {},
    "s11EnHour": {},
    "S11EnHour": {},
    "s11EnMin": {},
    "S11EnMin": {},
    "s11Power": {},
    "S11Power": {},
    "s11RePower": {},
    "S11RePower": {},
    "s11SOCUpperLimit": {},
    "S11SOCUpperLimit": {},
    "s11SOCLowerLimit": {},
    "S11SOCLowerLimit": {},
    "s12StHour": {},
    "S12StHour": {},
    "s12StMin": {},
    "S12StMin": {},
    "s12EnHour": {},
    "S12EnHour": {},
    "s12EnMin": {},
    "S12EnMin": {},
    "s12Power": {},
    "S12Power": {},
    "s12RePower": {},
    "S12RePower": {},
    "s12SOCUpperLimit": {},
    "S12SOCUpperLimit": {},
    "s12SOCLowerLimit": {},
    "S12SOCLowerLimit": {},
    "s13StHour": {},
    "S13StHour": {},
    "s13StMin": {},
    "S13StMin": {},
    "s13EnHour": {},
    "S13EnHour": {},
    "s13EnMin": {},
    "S13EnMin": {},
    "s13Power": {},
    "S13Power": {},
    "s13RePower": {},
    "S13RePower": {},
    "s13SOCUpperLimit": {},
    "S13SOCUpperLimit": {},
    "s13SOCLowerLimit": {},
    "S13SOCLowerLimit": {},
    "s14StHour": {},
    "S14StHour": {},
    "s14StMin": {},
    "S14StMin": {},
    "s14EnHour": {},
    "S14EnHour": {},
    "s14EnMin": {},
    "S14EnMin": {},
    "s14Power": {},
    "S14Power": {},
    "s14RePower": {},
    "S14RePower": {},
    "s14SOCUpperLimit": {},
    "S14SOCUpperLimit": {},
    "s14SOCLowerLimit": {},
    "S14SOCLowerLimit": {},
    "s15StHour": {},
    "S15StHour": {},
    "s15StMin": {},
    "S15StMin": {},
    "s15EnHour": {},
    "S15EnHour": {},
    "s15EnMin": {},
    "S15EnMin": {},
    "s15Power": {},
    "S15Power": {},
    "s15RePower": {},
    "S15RePower": {},
    "s15SOCUpperLimit": {},
    "S15SOCUpperLimit": {},
    "s15SOCLowerLimit": {},
    "S15SOCLowerLimit": {},
    "s16StHour": {},
    "S16StHour": {},
    "s16StMin": {},
    "S16StMin": {},
    "s16EnHour": {},
    "S16EnHour": {},
    "s16EnMin": {},
    "S16EnMin": {},
    "s16Power": {},
    "S16Power": {},
    "s16RePower": {},
    "S16RePower": {},
    "s16SOCUpperLimit": {},
    "S16SOCUpperLimit": {},
    "s16SOCLowerLimit": {},
    "S16SOCLowerLimit": {},
    "s17StHour": {},
    "S17StHour": {},
    "s17StMin": {},
    "S17StMin": {},
    "s17EnHour": {},
    "S17EnHour": {},
    "s17EnMin": {},
    "S17EnMin": {},
    "s17Power": {},
    "S17Power": {},
    "s17RePower": {},
    "S17RePower": {},
    "s17SOCUpperLimit": {},
    "S17SOCUpperLimit": {},
    "s17SOCLowerLimit": {},
    "S17SOCLowerLimit": {},
    "s18StHour": {},
    "S18StHour": {},
    "s18StMin": {},
    "S18StMin": {},
    "s18EnHour": {},
    "S18EnHour": {},
    "s18EnMin": {},
    "S18EnMin": {},
    "s18Power": {},
    "S18Power": {},
    "s18RePower": {},
    "S18RePower": {},
    "s18SOCUpperLimit": {},
    "S18SOCUpperLimit": {},
    "s18SOCLowerLimit": {},
    "S18SOCLowerLimit": {},
    "s19StHour": {},
    "S19StHour": {},
    "s19StMin": {},
    "S19StMin": {},
    "s19EnHour": {},
    "S19EnHour": {},
    "s19EnMin": {},
    "S19EnMin": {},
    "s19Power": {},
    "S19Power": {},
    "s19RePower": {},
    "S19RePower": {},
    "s19SOCUpperLimit": {},
    "S19SOCUpperLimit": {},
    "s19SOCLowerLimit": {},
    "S19SOCLowerLimit": {},
    "s20StHour": {},
    "S20StHour": {},
    "s20StMin": {},
    "S20StMin": {},
    "s20EnHour": {},
    "S20EnHour": {},
    "s20EnMin": {},
    "S20EnMin": {},
    "s20Power": {},
    "S20Power": {},
    "s20RePower": {},
    "S20RePower": {},
    "s20SOCUpperLimit": {},
    "S20SOCUpperLimit": {},
    "s20SOCLowerLimit": {},
    "S20SOCLowerLimit": {},
    "s21StHour": {},
    "S21StHour": {},
    "s21StMin": {},
    "S21StMin": {},
    "s21EnHour": {},
    "S21EnHour": {},
    "s21EnMin": {},
    "S21EnMin": {},
    "s21Power": {},
    "S21Power": {},
    "s21RePower": {},
    "S21RePower": {},
    "s21SOCUpperLimit": {},
    "S21SOCUpperLimit": {},
    "s21SOCLowerLimit": {},
    "S21SOCLowerLimit": {},
    "s22StHour": {},
    "S22StHour": {},
    "s22StMin": {},
    "S22StMin": {},
    "s22EnHour": {},
    "S22EnHour": {},
    "s22EnMin": {},
    "S22EnMin": {},
    "s22Power": {},
    "S22Power": {},
    "s22RePower": {},
    "S22RePower": {},
    "s22SOCUpperLimit": {},
    "S22SOCUpperLimit": {},
    "s22SOCLowerLimit": {},
    "S22SOCLowerLimit": {},
    "s23StHour": {},
    "S23StHour": {},
    "s23StMin": {},
    "S23StMin": {},
    "s23EnHour": {},
    "S23EnHour": {},
    "s23EnMin": {},
    "S23EnMin": {},
    "s23Power": {},
    "S23Power": {},
    "s23RePower": {},
    "S23RePower": {},
    "s23SOCUpperLimit": {},
    "S23SOCUpperLimit": {},
    "s23SOCLowerLimit": {},
    "S23SOCLowerLimit": {},
    "s24StHour": {},
    "S24StHour": {},
    "s24StMin": {},
    "S24StMin": {},
    "s24EnHour": {},
    "S24EnHour": {},
    "s24EnMin": {},
    "S24EnMin": {},
    "s24Power": {},
    "S24Power": {},
    "s24RePower": {},
    "S24RePower": {},
    "s24SOCUpperLimit": {},
    "S24SOCUpperLimit": {},
    "s24SOCLowerLimit": {},
    "S24SOCLowerLimit": {},
    "s25StHour": {},
    "S25StHour": {},
    "s25StMin": {},
    "S25StMin": {},
    "s25EnHour": {},
    "S25EnHour": {},
    "s25EnMin": {},
    "S25EnMin": {},
    "s25Power": {},
    "S25Power": {},
    "s25RePower": {},
    "S25RePower": {},
    "s25SOCUpperLimit": {},
    "S25SOCUpperLimit": {},
    "s25SOCLowerLimit": {},
    "S25SOCLowerLimit": {},
    "s26StHour": {},
    "S26StHour": {},
    "s26StMin": {},
    "S26StMin": {},
    "s26EnHour": {},
    "S26EnHour": {},
    "s26EnMin": {},
    "S26EnMin": {},
    "s26Power": {},
    "S26Power": {},
    "s26RePower": {},
    "S26RePower": {},
    "s26SOCUpperLimit": {},
    "S26SOCUpperLimit": {},
    "s26SOCLowerLimit": {},
    "S26SOCLowerLimit": {},
    "s27StHour": {},
    "S27StHour": {},
    "s27StMin": {},
    "S27StMin": {},
    "s27EnHour": {},
    "S27EnHour": {},
    "s27EnMin": {},
    "S27EnMin": {},
    "s27Power": {},
    "S27Power": {},
    "s27RePower": {},
    "S27RePower": {},
    "s27SOCUpperLimit": {},
    "S27SOCUpperLimit": {},
    "s27SOCLowerLimit": {},
    "S27SOCLowerLimit": {},
    "s28StHour": {},
    "S28StHour": {},
    "s28StMin": {},
    "S28StMin": {},
    "s28EnHour": {},
    "S28EnHour": {},
    "s28EnMin": {},
    "S28EnMin": {},
    "s28Power": {},
    "S28Power": {},
    "s28RePower": {},
    "S28RePower": {},
    "s28SOCUpperLimit": {},
    "S28SOCUpperLimit": {},
    "s28SOCLowerLimit": {},
    "S28SOCLowerLimit": {},
    "s29StHour": {},
    "S29StHour": {},
    "s29StMin": {},
    "S29StMin": {},
    "s29EnHour": {},
    "S29EnHour": {},
    "s29EnMin": {},
    "S29EnMin": {},
    "s29Power": {},
    "S29Power": {},
    "s29RePower": {},
    "S29RePower": {},
    "s29SOCUpperLimit": {},
    "S29SOCUpperLimit": {},
    "s29SOCLowerLimit": {},
    "S29SOCLowerLimit": {},
    "s30StHour": {},
    "S30StHour": {},
    "s30StMin": {},
    "S30StMin": {},
    "s30EnHour": {},
    "S30EnHour": {},
    "s30EnMin": {},
    "S30EnMin": {},
    "s30Power": {},
    "S30Power": {},
    "s30RePower": {},
    "S30RePower": {},
    "s30SOCUpperLimit": {},
    "S30SOCUpperLimit": {},
    "s30SOCLowerLimit": {},
    "S30SOCLowerLimit": {},
    "s31StHour": {},
    "S31StHour": {},
    "s31StMin": {},
    "S31StMin": {},
    "s31EnHour": {},
    "S31EnHour": {},
    "s31EnMin": {},
    "S31EnMin": {},
    "s31Power": {},
    "S31Power": {},
    "s31RePower": {},
    "S31RePower": {},
    "s31SOCUpperLimit": {},
    "S31SOCUpperLimit": {},
    "s31SOCLowerLimit": {},
    "S31SOCLowerLimit": {},
    "s32StHour": {},
    "S32StHour": {},
    "s32StMin": {},
    "S32StMin": {},
    "s32EnHour": {},
    "S32EnHour": {},
    "s32EnMin": {},
    "S32EnMin": {},
    "s32Power": {},
    "S32Power": {},
    "s32RePower": {},
    "S32RePower": {},
    "s32SOCUpperLimit": {},
    "S32SOCUpperLimit": {},
    "s32SOCLowerLimit": {},
    "S32SOCLowerLimit": {},
    "s33StHour": {},
    "S33StHour": {},
    "s33StMin": {},
    "S33StMin": {},
    "s33EnHour": {},
    "S33EnHour": {},
    "s33EnMin": {},
    "S33EnMin": {},
    "s33Power": {},
    "S33Power": {},
    "s33RePower": {},
    "S33RePower": {},
    "s33SOCUpperLimit": {},
    "S33SOCUpperLimit": {},
    "s33SOCLowerLimit": {},
    "S33SOCLowerLimit": {},
    "s34StHour": {},
    "S34StHour": {},
    "s34StMin": {},
    "S34StMin": {},
    "s34EnHour": {},
    "S34EnHour": {},
    "s34EnMin": {},
    "S34EnMin": {},
    "s34Power": {},
    "S34Power": {},
    "s34RePower": {},
    "S34RePower": {},
    "s34SOCUpperLimit": {},
    "S34SOCUpperLimit": {},
    "s34SOCLowerLimit": {},
    "S34SOCLowerLimit": {},
    "s35StHour": {},
    "S35StHour": {},
    "s35StMin": {},
    "S35StMin": {},
    "s35EnHour": {},
    "S35EnHour": {},
    "s35EnMin": {},
    "S35EnMin": {},
    "s35Power": {},
    "S35Power": {},
    "s35RePower": {},
    "S35RePower": {},
    "s35SOCUpperLimit": {},
    "S35SOCUpperLimit": {},
    "s35SOCLowerLimit": {},
    "S35SOCLowerLimit": {},
    "s36StHour": {},
    "S36StHour": {},
    "s36StMin": {},
    "S36StMin": {},
    "s36EnHour": {},
    "S36EnHour": {},
    "s36EnMin": {},
    "S36EnMin": {},
    "s36Power": {},
    "S36Power": {},
    "s36RePower": {},
    "S36RePower": {},
    "s36SOCUpperLimit": {},
    "S36SOCUpperLimit": {},
    "s36SOCLowerLimit": {},
    "S36SOCLowerLimit": {},
    "s37StHour": {},
    "S37StHour": {},
    "s37StMin": {},
    "S37StMin": {},
    "s37EnHour": {},
    "S37EnHour": {},
    "s37EnMin": {},
    "S37EnMin": {},
    "s37Power": {},
    "S37Power": {},
    "s37RePower": {},
    "S37RePower": {},
    "s37SOCUpperLimit": {},
    "S37SOCUpperLimit": {},
    "s37SOCLowerLimit": {},
    "S37SOCLowerLimit": {},
    "s38StHour": {},
    "S38StHour": {},
    "s38StMin": {},
    "S38StMin": {},
    "s38EnHour": {},
    "S38EnHour": {},
    "s38EnMin": {},
    "S38EnMin": {},
    "s38Power": {},
    "S38Power": {},
    "s38RePower": {},
    "S38RePower": {},
    "s38SOCUpperLimit": {},
    "S38SOCUpperLimit": {},
    "s38SOCLowerLimit": {},
    "S38SOCLowerLimit": {},
    "s39StHour": {},
    "S39StHour": {},
    "s39StMin": {},
    "S39StMin": {},
    "s39EnHour": {},
    "S39EnHour": {},
    "s39EnMin": {},
    "S39EnMin": {},
    "s39Power": {},
    "S39Power": {},
    "s39RePower": {},
    "S39RePower": {},
    "s39SOCUpperLimit": {},
    "S39SOCUpperLimit": {},
    "s39SOCLowerLimit": {},
    "S39SOCLowerLimit": {},
    "s40StHour": {},
    "S40StHour": {},
    "s40StMin": {},
    "S40StMin": {},
    "s40EnHour": {},
    "S40EnHour": {},
    "s40EnMin": {},
    "S40EnMin": {},
    "s40Power": {},
    "S40Power": {},
    "s40RePower": {},
    "S40RePower": {},
    "s40SOCUpperLimit": {},
    "S40SOCUpperLimit": {},
    "s40SOCLowerLimit": {},
    "S40SOCLowerLimit": {},
    "s41StHour": {},
    "S41StHour": {},
    "s41StMin": {},
    "S41StMin": {},
    "s41EnHour": {},
    "S41EnHour": {},
    "s41EnMin": {},
    "S41EnMin": {},
    "s41Power": {},
    "S41Power": {},
    "s41RePower": {},
    "S41RePower": {},
    "s41SOCUpperLimit": {},
    "S41SOCUpperLimit": {},
    "s41SOCLowerLimit": {},
    "S41SOCLowerLimit": {},
    "s42StHour": {},
    "S42StHour": {},
    "s42StMin": {},
    "S42StMin": {},
    "s42EnHour": {},
    "S42EnHour": {},
    "s42EnMin": {},
    "S42EnMin": {},
    "s42Power": {},
    "S42Power": {},
    "s42RePower": {},
    "S42RePower": {},
    "s42SOCUpperLimit": {},
    "S42SOCUpperLimit": {},
    "s42SOCLowerLimit": {},
    "S42SOCLowerLimit": {},
    "s43StHour": {},
    "S43StHour": {},
    "s43StMin": {},
    "S43StMin": {},
    "s43EnHour": {},
    "S43EnHour": {},
    "s43EnMin": {},
    "S43EnMin": {},
    "s43Power": {},
    "S43Power": {},
    "s43RePower": {},
    "S43RePower": {},
    "s43SOCUpperLimit": {},
    "S43SOCUpperLimit": {},
    "s43SOCLowerLimit": {},
    "S43SOCLowerLimit": {},
    "s44StHour": {},
    "S44StHour": {},
    "s44StMin": {},
    "S44StMin": {},
    "s44EnHour": {},
    "S44EnHour": {},
    "s44EnMin": {},
    "S44EnMin": {},
    "s44Power": {},
    "S44Power": {},
    "s44RePower": {},
    "S44RePower": {},
    "s44SOCUpperLimit": {},
    "S44SOCUpperLimit": {},
    "s44SOCLowerLimit": {},
    "S44SOCLowerLimit": {},
    "s45StHour": {},
    "S45StHour": {},
    "s45StMin": {},
    "S45StMin": {},
    "s45EnHour": {},
    "S45EnHour": {},
    "s45EnMin": {},
    "S45EnMin": {},
    "s45Power": {},
    "S45Power": {},
    "s45RePower": {},
    "S45RePower": {},
    "s45SOCUpperLimit": {},
    "S45SOCUpperLimit": {},
    "s45SOCLowerLimit": {},
    "S45SOCLowerLimit": {},
    "s46StHour": {},
    "S46StHour": {},
    "s46StMin": {},
    "S46StMin": {},
    "s46EnHour": {},
    "S46EnHour": {},
    "s46EnMin": {},
    "S46EnMin": {},
    "s46Power": {},
    "S46Power": {},
    "s46RePower": {},
    "S46RePower": {},
    "s46SOCUpperLimit": {},
    "S46SOCUpperLimit": {},
    "s46SOCLowerLimit": {},
    "S46SOCLowerLimit": {},
    "s47StHour": {},
    "S47StHour": {},
    "s47StMin": {},
    "S47StMin": {},
    "s47EnHour": {},
    "S47EnHour": {},
    "s47EnMin": {},
    "S47EnMin": {},
    "s47Power": {},
    "S47Power": {},
    "s47RePower": {},
    "S47RePower": {},
    "s47SOCUpperLimit": {},
    "S47SOCUpperLimit": {},
    "s47SOCLowerLimit": {},
    "S47SOCLowerLimit": {},
    "s48StHour": {},
    "S48StHour": {},
    "s48StMin": {},
    "S48StMin": {},
    "s48EnHour": {},
    "S48EnHour": {},
    "s48EnMin": {},
    "S48EnMin": {},
    "s48Power": {},
    "S48Power": {},
    "s48RePower": {},
    "S48RePower": {},
    "s48SOCUpperLimit": {},
    "S48SOCUpperLimit": {},
    "s48SOCLowerLimit": {},
    "S48SOCLowerLimit": {},
    "s49StHour": {},
    "S49StHour": {},
    "s49StMin": {},
    "S49StMin": {},
    "s49EnHour": {},
    "S49EnHour": {},
    "s49EnMin": {},
    "S49EnMin": {},
    "s49Power": {},
    "S49Power": {},
    "s49RePower": {},
    "S49RePower": {},
    "s49SOCUpperLimit": {},
    "S49SOCUpperLimit": {},
    "s49SOCLowerLimit": {},
    "S49SOCLowerLimit": {},
    "s50StHour": {},
    "S50StHour": {},
    "s50StMin": {},
    "S50StMin": {},
    "s50EnHour": {},
    "S50EnHour": {},
    "s50EnMin": {},
    "S50EnMin": {},
    "s50Power": {},
    "S50Power": {},
    "s50RePower": {},
    "S50RePower": {},
    "s50SOCUpperLimit": {},
    "S50SOCUpperLimit": {},
    "s50SOCLowerLimit": {},
    "S50SOCLowerLimit": {},
    "s51StHour": {},
    "S51StHour": {},
    "s51StMin": {},
    "S51StMin": {},
    "s51EnHour": {},
    "S51EnHour": {},
    "s51EnMin": {},
    "S51EnMin": {},
    "s51Power": {},
    "S51Power": {},
    "s51RePower": {},
    "S51RePower": {},
    "s51SOCUpperLimit": {},
    "S51SOCUpperLimit": {},
    "s51SOCLowerLimit": {},
    "S51SOCLowerLimit": {},
    "s52StHour": {},
    "S52StHour": {},
    "s52StMin": {},
    "S52StMin": {},
    "s52EnHour": {},
    "S52EnHour": {},
    "s52EnMin": {},
    "S52EnMin": {},
    "s52Power": {},
    "S52Power": {},
    "s52RePower": {},
    "S52RePower": {},
    "s52SOCUpperLimit": {},
    "S52SOCUpperLimit": {},
    "s52SOCLowerLimit": {},
    "S52SOCLowerLimit": {},
    "s53StHour": {},
    "S53StHour": {},
    "s53StMin": {},
    "S53StMin": {},
    "s53EnHour": {},
    "S53EnHour": {},
    "s53EnMin": {},
    "S53EnMin": {},
    "s53Power": {},
    "S53Power": {},
    "s53RePower": {},
    "S53RePower": {},
    "s53SOCUpperLimit": {},
    "S53SOCUpperLimit": {},
    "s53SOCLowerLimit": {},
    "S53SOCLowerLimit": {},
    "s54StHour": {},
    "S54StHour": {},
    "s54StMin": {},
    "S54StMin": {},
    "s54EnHour": {},
    "S54EnHour": {},
    "s54EnMin": {},
    "S54EnMin": {},
    "s54Power": {},
    "S54Power": {},
    "s54RePower": {},
    "S54RePower": {},
    "s54SOCUpperLimit": {},
    "S54SOCUpperLimit": {},
    "s54SOCLowerLimit": {},
    "S54SOCLowerLimit": {},
    "s55StHour": {},
    "S55StHour": {},
    "s55StMin": {},
    "S55StMin": {},
    "s55EnHour": {},
    "S55EnHour": {},
    "s55EnMin": {},
    "S55EnMin": {},
    "s55Power": {},
    "S55Power": {},
    "s55RePower": {},
    "S55RePower": {},
    "s55SOCUpperLimit": {},
    "S55SOCUpperLimit": {},
    "s55SOCLowerLimit": {},
    "S55SOCLowerLimit": {},
    "s56StHour": {},
    "S56StHour": {},
    "s56StMin": {},
    "S56StMin": {},
    "s56EnHour": {},
    "S56EnHour": {},
    "s56EnMin": {},
    "S56EnMin": {},
    "s56Power": {},
    "S56Power": {},
    "s56RePower": {},
    "S56RePower": {},
    "s56SOCUpperLimit": {},
    "S56SOCUpperLimit": {},
    "s56SOCLowerLimit": {},
    "S56SOCLowerLimit": {},
    "s57StHour": {},
    "S57StHour": {},
    "s57StMin": {},
    "S57StMin": {},
    "s57EnHour": {},
    "S57EnHour": {},
    "s57EnMin": {},
    "S57EnMin": {},
    "s57Power": {},
    "S57Power": {},
    "s57RePower": {},
    "S57RePower": {},
    "s57SOCUpperLimit": {},
    "S57SOCUpperLimit": {},
    "s57SOCLowerLimit": {},
    "S57SOCLowerLimit": {},
    "s58StHour": {},
    "S58StHour": {},
    "s58StMin": {},
    "S58StMin": {},
    "s58EnHour": {},
    "S58EnHour": {},
    "s58EnMin": {},
    "S58EnMin": {},
    "s58Power": {},
    "S58Power": {},
    "s58RePower": {},
    "S58RePower": {},
    "s58SOCUpperLimit": {},
    "S58SOCUpperLimit": {},
    "s58SOCLowerLimit": {},
    "S58SOCLowerLimit": {},
    "s59StHour": {},
    "S59StHour": {},
    "s59StMin": {},
    "S59StMin": {},
    "s59EnHour": {},
    "S59EnHour": {},
    "s59EnMin": {},
    "S59EnMin": {},
    "s59Power": {},
    "S59Power": {},
    "s59RePower": {},
    "S59RePower": {},
    "s59SOCUpperLimit": {},
    "S59SOCUpperLimit": {},
    "s59SOCLowerLimit": {},
    "S59SOCLowerLimit": {},
    "s60StHour": {},
    "S60StHour": {},
    "s60StMin": {},
    "S60StMin": {},
    "s60EnHour": {},
    "S60EnHour": {},
    "s60EnMin": {},
    "S60EnMin": {},
    "s60Power": {},
    "S60Power": {},
    "s60RePower": {},
    "S60RePower": {},
    "s60SOCUpperLimit": {},
    "S60SOCUpperLimit": {},
    "s60SOCLowerLimit": {},
    "S60SOCLowerLimit": {},
    "s61StHour": {},
    "S61StHour": {},
    "s61StMin": {},
    "S61StMin": {},
    "s61EnHour": {},
    "S61EnHour": {},
    "s61EnMin": {},
    "S61EnMin": {},
    "s61Power": {},
    "S61Power": {},
    "s61RePower": {},
    "S61RePower": {},
    "s61SOCUpperLimit": {},
    "S61SOCUpperLimit": {},
    "s61SOCLowerLimit": {},
    "S61SOCLowerLimit": {},
    "s62StHour": {},
    "S62StHour": {},
    "s62StMin": {},
    "S62StMin": {},
    "s62EnHour": {},
    "S62EnHour": {},
    "s62EnMin": {},
    "S62EnMin": {},
    "s62Power": {},
    "S62Power": {},
    "s62RePower": {},
    "S62RePower": {},
    "s62SOCUpperLimit": {},
    "S62SOCUpperLimit": {},
    "s62SOCLowerLimit": {},
    "S62SOCLowerLimit": {},
    "s63StHour": {},
    "S63StHour": {},
    "s63StMin": {},
    "S63StMin": {},
    "s63EnHour": {},
    "S63EnHour": {},
    "s63EnMin": {},
    "S63EnMin": {},
    "s63Power": {},
    "S63Power": {},
    "s63RePower": {},
    "S63RePower": {},
    "s63SOCUpperLimit": {},
    "S63SOCUpperLimit": {},
    "s63SOCLowerLimit": {},
    "S63SOCLowerLimit": {},
    "s64StHour": {},
    "S64StHour": {},
    "s64StMin": {},
    "S64StMin": {},
    "s64EnHour": {},
    "S64EnHour": {},
    "s64EnMin": {},
    "S64EnMin": {},
    "s64Power": {},
    "S64Power": {},
    "s64RePower": {},
    "S64RePower": {},
    "s64SOCUpperLimit": {},
    "S64SOCUpperLimit": {},
    "s64SOCLowerLimit": {},
    "S64SOCLowerLimit": {},
    "s65StHour": {},
    "S65StHour": {},
    "s65StMin": {},
    "S65StMin": {},
    "s65EnHour": {},
    "S65EnHour": {},
    "s65EnMin": {},
    "S65EnMin": {},
    "s65Power": {},
    "S65Power": {},
    "s65RePower": {},
    "S65RePower": {},
    "s65SOCUpperLimit": {},
    "S65SOCUpperLimit": {},
    "s65SOCLowerLimit": {},
    "S65SOCLowerLimit": {},
    "s66StHour": {},
    "S66StHour": {},
    "s66StMin": {},
    "S66StMin": {},
    "s66EnHour": {},
    "S66EnHour": {},
    "s66EnMin": {},
    "S66EnMin": {},
    "s66Power": {},
    "S66Power": {},
    "s66RePower": {},
    "S66RePower": {},
    "s66SOCUpperLimit": {},
    "S66SOCUpperLimit": {},
    "s66SOCLowerLimit": {},
    "S66SOCLowerLimit": {},
    "s67StHour": {},
    "S67StHour": {},
    "s67StMin": {},
    "S67StMin": {},
    "s67EnHour": {},
    "S67EnHour": {},
    "s67EnMin": {},
    "S67EnMin": {},
    "s67Power": {},
    "S67Power": {},
    "s67RePower": {},
    "S67RePower": {},
    "s67SOCUpperLimit": {},
    "S67SOCUpperLimit": {},
    "s67SOCLowerLimit": {},
    "S67SOCLowerLimit": {},
    "s68StHour": {},
    "S68StHour": {},
    "s68StMin": {},
    "S68StMin": {},
    "s68EnHour": {},
    "S68EnHour": {},
    "s68EnMin": {},
    "S68EnMin": {},
    "s68Power": {},
    "S68Power": {},
    "s68RePower": {},
    "S68RePower": {},
    "s68SOCUpperLimit": {},
    "S68SOCUpperLimit": {},
    "s68SOCLowerLimit": {},
    "S68SOCLowerLimit": {},
    "s69StHour": {},
    "S69StHour": {},
    "s69StMin": {},
    "S69StMin": {},
    "s69EnHour": {},
    "S69EnHour": {},
    "s69EnMin": {},
    "S69EnMin": {},
    "s69Power": {},
    "S69Power": {},
    "s69RePower": {},
    "S69RePower": {},
    "s69SOCUpperLimit": {},
    "S69SOCUpperLimit": {},
    "s69SOCLowerLimit": {},
    "S69SOCLowerLimit": {},
    "s70StHour": {},
    "S70StHour": {},
    "s70StMin": {},
    "S70StMin": {},
    "s70EnHour": {},
    "S70EnHour": {},
    "s70EnMin": {},
    "S70EnMin": {},
    "s70Power": {},
    "S70Power": {},
    "s70RePower": {},
    "S70RePower": {},
    "s70SOCUpperLimit": {},
    "S70SOCUpperLimit": {},
    "s70SOCLowerLimit": {},
    "S70SOCLowerLimit": {},
    "s71StHour": {},
    "S71StHour": {},
    "s71StMin": {},
    "S71StMin": {},
    "s71EnHour": {},
    "S71EnHour": {},
    "s71EnMin": {},
    "S71EnMin": {},
    "s71Power": {},
    "S71Power": {},
    "s71RePower": {},
    "S71RePower": {},
    "s71SOCUpperLimit": {},
    "S71SOCUpperLimit": {},
    "s71SOCLowerLimit": {},
    "S71SOCLowerLimit": {},
    "s72StHour": {},
    "S72StHour": {},
    "s72StMin": {},
    "S72StMin": {},
    "s72EnHour": {},
    "S72EnHour": {},
    "s72EnMin": {},
    "S72EnMin": {},
    "s72Power": {},
    "S72Power": {},
    "s72RePower": {},
    "S72RePower": {},
    "s72SOCUpperLimit": {},
    "S72SOCUpperLimit": {},
    "s72SOCLowerLimit": {},
    "S72SOCLowerLimit": {},
    "s73StHour": {},
    "S73StHour": {},
    "s73StMin": {},
    "S73StMin": {},
    "s73EnHour": {},
    "S73EnHour": {},
    "s73EnMin": {},
    "S73EnMin": {},
    "s73Power": {},
    "S73Power": {},
    "s73RePower": {},
    "S73RePower": {},
    "s73SOCUpperLimit": {},
    "S73SOCUpperLimit": {},
    "s73SOCLowerLimit": {},
    "S73SOCLowerLimit": {},
    "s74StHour": {},
    "S74StHour": {},
    "s74StMin": {},
    "S74StMin": {},
    "s74EnHour": {},
    "S74EnHour": {},
    "s74EnMin": {},
    "S74EnMin": {},
    "s74Power": {},
    "S74Power": {},
    "s74RePower": {},
    "S74RePower": {},
    "s74SOCUpperLimit": {},
    "S74SOCUpperLimit": {},
    "s74SOCLowerLimit": {},
    "S74SOCLowerLimit": {},
    "s75StHour": {},
    "S75StHour": {},
    "s75StMin": {},
    "S75StMin": {},
    "s75EnHour": {},
    "S75EnHour": {},
    "s75EnMin": {},
    "S75EnMin": {},
    "s75Power": {},
    "S75Power": {},
    "s75RePower": {},
    "S75RePower": {},
    "s75SOCUpperLimit": {},
    "S75SOCUpperLimit": {},
    "s75SOCLowerLimit": {},
    "S75SOCLowerLimit": {},
    "s76StHour": {},
    "S76StHour": {},
    "s76StMin": {},
    "S76StMin": {},
    "s76EnHour": {},
    "S76EnHour": {},
    "s76EnMin": {},
    "S76EnMin": {},
    "s76Power": {},
    "S76Power": {},
    "s76RePower": {},
    "S76RePower": {},
    "s76SOCUpperLimit": {},
    "S76SOCUpperLimit": {},
    "s76SOCLowerLimit": {},
    "S76SOCLowerLimit": {},
    "s77StHour": {},
    "S77StHour": {},
    "s77StMin": {},
    "S77StMin": {},
    "s77EnHour": {},
    "S77EnHour": {},
    "s77EnMin": {},
    "S77EnMin": {},
    "s77Power": {},
    "S77Power": {},
    "s77RePower": {},
    "S77RePower": {},
    "s77SOCUpperLimit": {},
    "S77SOCUpperLimit": {},
    "s77SOCLowerLimit": {},
    "S77SOCLowerLimit": {},
    "s78StHour": {},
    "S78StHour": {},
    "s78StMin": {},
    "S78StMin": {},
    "s78EnHour": {},
    "S78EnHour": {},
    "s78EnMin": {},
    "S78EnMin": {},
    "s78Power": {},
    "S78Power": {},
    "s78RePower": {},
    "S78RePower": {},
    "s78SOCUpperLimit": {},
    "S78SOCUpperLimit": {},
    "s78SOCLowerLimit": {},
    "S78SOCLowerLimit": {},
    "s79StHour": {},
    "S79StHour": {},
    "s79StMin": {},
    "S79StMin": {},
    "s79EnHour": {},
    "S79EnHour": {},
    "s79EnMin": {},
    "S79EnMin": {},
    "s79Power": {},
    "S79Power": {},
    "s79RePower": {},
    "S79RePower": {},
    "s79SOCUpperLimit": {},
    "S79SOCUpperLimit": {},
    "s79SOCLowerLimit": {},
    "S79SOCLowerLimit": {},
    "s80StHour": {},
    "S80StHour": {},
    "s80StMin": {},
    "S80StMin": {},
    "s80EnHour": {},
    "S80EnHour": {},
    "s80EnMin": {},
    "S80EnMin": {},
    "s80Power": {},
    "S80Power": {},
    "s80RePower": {},
    "S80RePower": {},
    "s80SOCUpperLimit": {},
    "S80SOCUpperLimit": {},
    "s80SOCLowerLimit": {},
    "S80SOCLowerLimit": {},
    "s81StHour": {},
    "S81StHour": {},
    "s81StMin": {},
    "S81StMin": {},
    "s81EnHour": {},
    "S81EnHour": {},
    "s81EnMin": {},
    "S81EnMin": {},
    "s81Power": {},
    "S81Power": {},
    "s81RePower": {},
    "S81RePower": {},
    "s81SOCUpperLimit": {},
    "S81SOCUpperLimit": {},
    "s81SOCLowerLimit": {},
    "S81SOCLowerLimit": {},
    "s82StHour": {},
    "S82StHour": {},
    "s82StMin": {},
    "S82StMin": {},
    "s82EnHour": {},
    "S82EnHour": {},
    "s82EnMin": {},
    "S82EnMin": {},
    "s82Power": {},
    "S82Power": {},
    "s82RePower": {},
    "S82RePower": {},
    "s82SOCUpperLimit": {},
    "S82SOCUpperLimit": {},
    "s82SOCLowerLimit": {},
    "S82SOCLowerLimit": {},
    "s83StHour": {},
    "S83StHour": {},
    "s83StMin": {},
    "S83StMin": {},
    "s83EnHour": {},
    "S83EnHour": {},
    "s83EnMin": {},
    "S83EnMin": {},
    "s83Power": {},
    "S83Power": {},
    "s83RePower": {},
    "S83RePower": {},
    "s83SOCUpperLimit": {},
    "S83SOCUpperLimit": {},
    "s83SOCLowerLimit": {},
    "S83SOCLowerLimit": {},
    "s84StHour": {},
    "S84StHour": {},
    "s84StMin": {},
    "S84StMin": {},
    "s84EnHour": {},
    "S84EnHour": {},
    "s84EnMin": {},
    "S84EnMin": {},
    "s84Power": {},
    "S84Power": {},
    "s84RePower": {},
    "S84RePower": {},
    "s84SOCUpperLimit": {},
    "S84SOCUpperLimit": {},
    "s84SOCLowerLimit": {},
    "S84SOCLowerLimit": {},
    "s85StHour": {},
    "S85StHour": {},
    "s85StMin": {},
    "S85StMin": {},
    "s85EnHour": {},
    "S85EnHour": {},
    "s85EnMin": {},
    "S85EnMin": {},
    "s85Power": {},
    "S85Power": {},
    "s85RePower": {},
    "S85RePower": {},
    "s85SOCUpperLimit": {},
    "S85SOCUpperLimit": {},
    "s85SOCLowerLimit": {},
    "S85SOCLowerLimit": {},
    "s86StHour": {},
    "S86StHour": {},
    "s86StMin": {},
    "S86StMin": {},
    "s86EnHour": {},
    "S86EnHour": {},
    "s86EnMin": {},
    "S86EnMin": {},
    "s86Power": {},
    "S86Power": {},
    "s86RePower": {},
    "S86RePower": {},
    "s86SOCUpperLimit": {},
    "S86SOCUpperLimit": {},
    "s86SOCLowerLimit": {},
    "S86SOCLowerLimit": {},
    "s87StHour": {},
    "S87StHour": {},
    "s87StMin": {},
    "S87StMin": {},
    "s87EnHour": {},
    "S87EnHour": {},
    "s87EnMin": {},
    "S87EnMin": {},
    "s87Power": {},
    "S87Power": {},
    "s87RePower": {},
    "S87RePower": {},
    "s87SOCUpperLimit": {},
    "S87SOCUpperLimit": {},
    "s87SOCLowerLimit": {},
    "S87SOCLowerLimit": {},
    "s88StHour": {},
    "S88StHour": {},
    "s88StMin": {},
    "S88StMin": {},
    "s88EnHour": {},
    "S88EnHour": {},
    "s88EnMin": {},
    "S88EnMin": {},
    "s88Power": {},
    "S88Power": {},
    "s88RePower": {},
    "S88RePower": {},
    "s88SOCUpperLimit": {},
    "S88SOCUpperLimit": {},
    "s88SOCLowerLimit": {},
    "S88SOCLowerLimit": {},
    "s89StHour": {},
    "S89StHour": {},
    "s89StMin": {},
    "S89StMin": {},
    "s89EnHour": {},
    "S89EnHour": {},
    "s89EnMin": {},
    "S89EnMin": {},
    "s89Power": {},
    "S89Power": {},
    "s89RePower": {},
    "S89RePower": {},
    "s89SOCUpperLimit": {},
    "S89SOCUpperLimit": {},
    "s89SOCLowerLimit": {},
    "S89SOCLowerLimit": {},
    "s90StHour": {},
    "S90StHour": {},
    "s90StMin": {},
    "S90StMin": {},
    "s90EnHour": {},
    "S90EnHour": {},
    "s90EnMin": {},
    "S90EnMin": {},
    "s90Power": {},
    "S90Power": {},
    "s90RePower": {},
    "S90RePower": {},
    "s90SOCUpperLimit": {},
    "S90SOCUpperLimit": {},
    "s90SOCLowerLimit": {},
    "S90SOCLowerLimit": {},
    "s91StHour": {},
    "S91StHour": {},
    "s91StMin": {},
    "S91StMin": {},
    "s91EnHour": {},
    "S91EnHour": {},
    "s91EnMin": {},
    "S91EnMin": {},
    "s91Power": {},
    "S91Power": {},
    "s91RePower": {},
    "S91RePower": {},
    "s91SOCUpperLimit": {},
    "S91SOCUpperLimit": {},
    "s91SOCLowerLimit": {},
    "S91SOCLowerLimit": {},
    "s92StHour": {},
    "S92StHour": {},
    "s92StMin": {},
    "S92StMin": {},
    "s92EnHour": {},
    "S92EnHour": {},
    "s92EnMin": {},
    "S92EnMin": {},
    "s92Power": {},
    "S92Power": {},
    "s92RePower": {},
    "S92RePower": {},
    "s92SOCUpperLimit": {},
    "S92SOCUpperLimit": {},
    "s92SOCLowerLimit": {},
    "S92SOCLowerLimit": {},
    "s93StHour": {},
    "S93StHour": {},
    "s93StMin": {},
    "S93StMin": {},
    "s93EnHour": {},
    "S93EnHour": {},
    "s93EnMin": {},
    "S93EnMin": {},
    "s93Power": {},
    "S93Power": {},
    "s93RePower": {},
    "S93RePower": {},
    "s93SOCUpperLimit": {},
    "S93SOCUpperLimit": {},
    "s93SOCLowerLimit": {},
    "S93SOCLowerLimit": {},
    "s94StHour": {},
    "S94StHour": {},
    "s94StMin": {},
    "S94StMin": {},
    "s94EnHour": {},
    "S94EnHour": {},
    "s94EnMin": {},
    "S94EnMin": {},
    "s94Power": {},
    "S94Power": {},
    "s94RePower": {},
    "S94RePower": {},
    "s94SOCUpperLimit": {},
    "S94SOCUpperLimit": {},
    "s94SOCLowerLimit": {},
    "S94SOCLowerLimit": {},
    "s95StHour": {},
    "S95StHour": {},
    "s95StMin": {},
    "S95StMin": {},
    "s95EnHour": {},
    "S95EnHour": {},
    "s95EnMin": {},
    "S95EnMin": {},
    "s95Power": {},
    "S95Power": {},
    "s95RePower": {},
    "S95RePower": {},
    "s95SOCUpperLimit": {},
    "S95SOCUpperLimit": {},
    "s95SOCLowerLimit": {},
    "S95SOCLowerLimit": {},
    "s96StHour": {},
    "S96StHour": {},
    "s96StMin": {},
    "S96StMin": {},
    "s96EnHour": {},
    "S96EnHour": {},
    "s96EnMin": {},
    "S96EnMin": {},
    "s96Power": {},
    "S96Power": {},
    "s96RePower": {},
    "S96RePower": {},
    "s96SOCUpperLimit": {},
    "S96SOCUpperLimit": {},
    "s96SOCLowerLimit": {},
    "S96SOCLowerLimit": {},
    "demandThreshold1": {},
    "DemandThreshold1": {},
    "demandThreshold2": {},
    "DemandThreshold2": {},
    "demandThreshold3": {},
    "DemandThreshold3": {},
    "demandThreshold4": {},
    "DemandThreshold4": {},
    "demandThreshold5": {},
    "DemandThreshold5": {},
    "demandThreshold6": {},
    "DemandThreshold6": {},
    "demandThreshold7": {},
    "DemandThreshold7": {},
    "demandThreshold8": {},
    "DemandThreshold8": {},
    "demandThreshold9": {},
    "DemandThreshold9": {},
    "demandThreshold10": {},
    "DemandThreshold10": {},
    "demandThreshold11": {},
    "DemandThreshold11": {},
    "demandThreshold12": {},
    "DemandThreshold12": {},
    "demandStartHour": {},
    "DemandStartHour": {},
    "demandStartMin": {},
    "DemandStartMin": {},
    "demandEndHour": {},
    "DemandEndHour": {},
    "demandEndMin": {},
    "DemandEndMin": {},
    "chargeStartPower": {},
    "dischargeThreshold": {},
    "sysStatus": {
      "0": "正常",
      "1": "异常"
    },
    "SysStatus": {
      "0": "正常",
      "1": "异常"
    },
    "avgSOC": {},
    "AvgSOC": {},
    "totalActivePower": {},
    "TotalActivePower": {},
    "totalReactivePower": {},
    "TotalReactivePower": {},
    "upAdjustPower": {},
    "UpAdjustPower": {},
    "downAdjustPower": {},
    "DownAdjustPower": {},
    "rechargeableEnergy": {},
    "RechargeableEnergy": {},
    "dischargeableEnergy": {},
    "DischargeableEnergy": {},
    "meterError": {
      "0": "正常",
      "1": "异常"
    },
    "MeterError": {
      "0": "正常",
      "1": "异常"
    },
    "ioProtect": {
      "0": "未保护",
      "1": "已保护"
    },
    "IoProtect": {
      "0": "未保护",
      "1": "已保护"
    },
    "allFire": {
      "0": "正常",
      "1": "异常"
    },
    "AllFire": {
      "0": "正常",
      "1": "异常"
    },
    "exFire": {
      "0": "正常",
      "1": "异常"
    },
    "ExFire": {
      "0": "正常",
      "1": "异常"
    },
    "fire": {
      "0": "正常",
      "1": "异常"
    },
    "Fire": {
      "0": "正常",
      "1": "异常"
    },
    "socParameterAlarm": {
      "0": "正常",
      "1": "异常"
    },
    "SocParameterAlarm": {
      "0": "正常",
      "1": "异常"
    },
    "chDischStatus": {
      "0": "静置",
      "1": "充电",
      "2": "放电"
    },
    "ChDischStatus": {
      "0": "静置",
      "1": "充电",
      "2": "放电"
    },
    "lcSysStatus": {
      "0": "正常",
      "1": "异常"
    },
    "LcSysStatus": {
      "0": "正常",
      "1": "异常"
    },
    "whitelistAlarm": {
      "0": "正常",
      "1": "异常"
    },
    "WhitelistAlarm": {
      "0": "正常",
      "1": "异常"
    },
    "iec104ConnAlarm": {
      "0": "正常",
      "1": "异常"
    },
    "Iec104ConnAlarm": {
      "0": "正常",
      "1": "异常"
    },
    "modbusTcpConnAlarm": {
      "0": "正常",
      "1": "异常"
    },
    "ModbusTcpConnAlarm": {
      "0": "正常",
      "1": "异常"
    },
    "ssdNotExist": {
      "0": "正常",
      "1": "异常"
    },
    "SsdNotExist": {
      "0": "正常",
      "1": "异常"
    },
    "maxDemand": {},
    "MaxDemand": {},
    "cabPower": {},
    "CabPower": {},
    "cabCapacity": {},
    "CabCapacity": {},
    "alarmHisCnt": {},
    "AlarmHisCnt": {},
    "prohibiteCha": {
      "0": "未保护",
      "1": "已保护"
    },
    "ProhibiteCha": {
      "0": "未保护",
      "1": "已保护"
    },
    "prohibiteDisc": {
      "0": "未保护",
      "1": "已保护"
    },
    "ProhibiteDisc": {
      "0": "未保护",
      "1": "已保护"
    },
    "bmsLimited": {
      "0": "未保护",
      "1": "已保护"
    },
    "BmsLimited": {
      "0": "未保护",
      "1": "已保护"
    },
    "sysStatusWord": {},
    "SysStatusWord": {},
    "totalForwardEnergy": {},
    "TotalForwardEnergy": {},
    "totalReverseEnergy": {},
    "TotalReverseEnergy": {},
    "SOC": {},
    "onOffStatus": {
      "0": "关机",
      "1": "开机"
    },
    "OnOffStatus": {
      "0": "关机",
      "1": "开机"
    },
    "activePower": {},
    "ActivePower": {},
    "reactivePower": {},
    "ReactivePower": {},
    "bmsLimitedCh": {
      "0": "未保护",
      "1": "已保护"
    },
    "BmsLimitedCh": {
      "0": "未保护",
      "1": "已保护"
    },
    "bmsLimitedDc": {
      "0": "未保护",
      "1": "已保护"
    },
    "BmsLimitedDc": {
      "0": "未保护",
      "1": "已保护"
    },
    "manualProtect": {
      "0": "未保护",
      "1": "已保护"
    },
    "ManualProtect": {
      "0": "未保护",
      "1": "已保护"
    },
    "g100LockState": {
      "0": "正常",
      "1": "锁定",
      "2": "系统锁定"
    },
    "G100LockState": {
      "0": "正常",
      "1": "锁定",
      "2": "系统锁定"
    },
    "g100AbnormalState": {
      "0": "正常",
      "1": "逆流",
      "2": "过载"
    },
    "G100AbnormalState": {
      "0": "正常",
      "1": "逆流",
      "2": "过载"
    },
    "g100ResetCount": {},
    "G100ResetCount": {},
    "g100AbnornalCount10Min": {},
    "G100AbnornalCount10Min": {},
    "g100AbnornalCountDay": {},
    "G100AbnornalCountDay": {},
    "connectStatus": {
      "0": "离网",
      "1": "并网"
    },
    "ConnectStatus": {
      "0": "离网",
      "1": "并网"
    },
    "airCondStartStopCtrl": {
      "0": "关机",
      "1": "开机"
    },
    "AirCondStartStopCtrl": {
      "0": "关机",
      "1": "开机"
    },
    "enTraceLoad": {
      "0": "禁用",
      "1": "使能"
    },
    "EnTraceLoad": {
      "0": "禁用",
      "1": "使能"
    },
    "enProtectReverse": {
      "0": "禁用",
      "1": "使能"
    },
    "EnProtectReverse": {
      "0": "禁用",
      "1": "使能"
    },
    "enProtectTransf": {
      "0": "禁用",
      "1": "变压器需量",
      "2": "最大需量"
    },
    "EnProtectTransf": {
      "0": "禁用",
      "1": "变压器需量",
      "2": "最大需量"
    },
    "k1": {},
    "K1": {},
    "k2": {},
    "K2": {},
    "k3": {},
    "K3": {},
    "SOCmax": {},
    "SOCmin": {},
    "pset": {},
    "Pset": {},
    "adjpreriod": {},
    "Adjpreriod": {},
    "tempThreshold": {},
    "TempThreshold": {},
    "loadTrackingLimit": {
      "0": "禁用",
      "1": "使能"
    },
    "LoadTrackingLimit": {
      "0": "禁用",
      "1": "使能"
    },
    "enProtectDOD": {
      "0": "禁用",
      "1": "使能"
    },
    "EnProtectDOD": {
      "0": "禁用",
      "1": "使能"
    },
    "enDraughtFanPower": {
      "0": "禁用",
      "1": "使能"
    },
    "EnDraughtFanPower": {
      "0": "禁用",
      "1": "使能"
    },
    "DFanPowerThreShold": {},
    "enDraughtFanTem": {
      "0": "禁用",
      "1": "使能"
    },
    "EnDraughtFanTem": {
      "0": "禁用",
      "1": "使能"
    },
    "DFanTemThreShold": {},
    "deadTime": {},
    "DeadTime": {},
    "pcsAutoTurn": {
      "0": "禁用",
      "1": "使能"
    },
    "PcsAutoTurn": {
      "0": "禁用",
      "1": "使能"
    },
    "pcsAutoTurnOffTime": {},
    "PcsAutoTurnOffTime": {},
    "workSamplePeriod": {},
    "WorkSamplePeriod": {},
    "idleSamplePeriod": {},
    "IdleSamplePeriod": {},
    "enableAutoCool": {
      "0": "禁用",
      "1": "使能"
    },
    "EnableAutoCool": {
      "0": "禁用",
      "1": "使能"
    },
    "enSelfLoopDiff": {
      "0": "禁用",
      "1": "使能"
    },
    "EnSelfLoopDiff": {
      "0": "禁用",
      "1": "使能"
    },
    "WStartHot": {},
    "WEndHot": {},
    "WStartCool": {},
    "WEndCool": {},
    "WDistHot": {},
    "WDistCool": {},
    "enableAirCond": {
      "0": "禁用",
      "1": "使能"
    },
    "EnableAirCond": {
      "0": "禁用",
      "1": "使能"
    },
    "airCondAheadTime": {},
    "AirCondAheadTime": {},
    "protectReverseWin": {},
    "ProtectReverseWin": {},
    "pvMaxPower": {},
    "PvMaxPower": {},
    "demandWin": {},
    "DemandWin": {},
    "bmsPowerLimit": {
      "0": "禁用",
      "1": "使能"
    },
    "BmsPowerLimit": {
      "0": "禁用",
      "1": "使能"
    },
    "enProtectTrasLV": {
      "0": "禁用",
      "1": "使能"
    },
    "EnProtectTrasLV": {
      "0": "禁用",
      "1": "使能"
    },
    "PLVmlmax": {},
    "k4": {},
    "K4": {},
    "airCondDelayTime": {},
    "AirCondDelayTime": {},
    "startSelfLoopDiff": {},
    "StartSelfLoopDiff": {},
    "singleMaxVoltage": {},
    "singleMinVoltage": {},
    "enSingleVoltage": {
      "0": "禁用",
      "1": "使能"
    },
    "singleMaxVoltageErr": {},
    "singleMinVoltageErr": {},
    "SOCminErr": {},
    "SOCmaxErr": {},
    "dischargeMaxPower": {},
    "chargeMaxPower": {},
    "demandMargin": {},
    "DemandMargin": {},
    "dynamicAugmentation": {},
    "DynamicAugmentation": {},
    "accident_tgi": {},
    "Accident_tgi": {},
    "accident_en": {},
    "Accident_en": {},
    "installedcab_coeff": {},
    "Installedcab_coeff": {},
    "singleVoltageTime": {},
    "SingleVoltageTime": {},
    "isDisableByMaster": {
      "0": "否",
      "1": "是"
    },
    "IsDisableByMaster": {
      "0": "否",
      "1": "是"
    },
    "clrAlarm": {},
    "ClrAlarm": {},
    "enIoProtect": {
      "0": "禁用",
      "1": "使能"
    },
    "EnIoProtect": {
      "0": "禁用",
      "1": "使能"
    },
    "TMSCtrlState": {
      "0": "待机",
      "1": "制冷",
      "2": "制热",
      "3": "泵循环",
      "4": "全自动"
    },
    "fan": {},
    "Fan": {},
    "TMSCtrlTempCold": {},
    "TMSCtrlTempHot": {},
    "bmsUpper": {
      "0": "下高压",
      "1": "上高压"
    },
    "BmsUpper": {
      "0": "下高压",
      "1": "上高压"
    },
    "ENRPComp": {
      "0": "禁用",
      "1": "使能"
    },
    "setPowerFactor": {},
    "SetPowerFactor": {},
    "enDataCollect": {
      "0": "禁用",
      "1": "使能"
    },
    "EnDataCollect": {
      "0": "禁用",
      "1": "使能"
    },
    "g100Enable": {
      "0": "禁用",
      "1": "使能"
    },
    "G100Enable": {
      "0": "禁用",
      "1": "使能"
    },
    "g100UnlockTime": {},
    "G100UnlockTime": {},
    "g100ResetMaxCount": {},
    "G100ResetMaxCount": {},
    "g100BabnormalCount10Min": {},
    "G100BabnormalCount10Min": {},
    "g100BabnormalCountDay": {},
    "G100BabnormalCountDay": {},
    "g100BackflowLimit": {},
    "G100BackflowLimit": {},
    "g100BackflowSec": {},
    "G100BackflowSec": {},
    "g100BackflowLockTime": {},
    "G100BackflowLockTime": {},
    "g100OverloadLimit": {},
    "G100OverloadLimit": {},
    "g100OverloadSec": {},
    "G100OverloadSec": {},
    "g100OverloadLockTime": {},
    "G100OverloadLockTime": {},
    "heatCtrCycle": {},
    "HeatCtrCycle": {},
    "enSwD2C": {
      "0": "禁用",
      "1": "使能"
    },
    "EnSwD2C": {
      "0": "禁用",
      "1": "使能"
    },
    "enSwC2D": {
      "0": "禁用",
      "1": "使能"
    },
    "EnSwC2D": {
      "0": "禁用",
      "1": "使能"
    },
    "powerLimit": {},
    "PowerLimit": {},
    "clrManualProtect": {},
    "ClrManualProtect": {},
    "SStartHot": {},
    "SEndHot": {},
    "SStartCool": {},
    "SEndCool": {},
    "SDistHot": {},
    "SDistCool": {},
    "endSelfLoopDiff": {},
    "EndSelfLoopDiff": {}
  },
  "TMS": {
    "online": {
      "0": "离线",
      "1": "在线"
    },
    "Online": {
      "0": "离线",
      "1": "在线"
    },
    "unitSta": {
      "1": "水泵循环",
      "2": "制冷模式",
      "3": "制热模式",
      "4": "自动控制"
    },
    "UnitSta": {
      "1": "水泵循环",
      "2": "制冷模式",
      "3": "制热模式",
      "4": "自动控制"
    },
    "inflowTemp": {},
    "InflowTemp": {},
    "effluentTemp": {},
    "EffluentTemp": {},
    "refPreTemp": {},
    "RefPreTemp": {},
    "refRetDiff": {},
    "RefRetDiff": {},
    "heatPreTemp": {},
    "HeatPreTemp": {},
    "heatRetDiff": {},
    "HeatRetDiff": {},
    "pumpStatue": {
      "0": "停止",
      "1": "运行"
    },
    "PumpStatue": {
      "0": "停止",
      "1": "运行"
    },
    "compressorStatue1": {
      "0": "停止",
      "1": "运行"
    },
    "CompressorStatue1": {
      "0": "停止",
      "1": "运行"
    },
    "compressorStatue2": {
      "0": "停止",
      "1": "运行"
    },
    "CompressorStatue2": {
      "0": "停止",
      "1": "运行"
    },
    "heaterState": {
      "0": "停止",
      "1": "运行"
    },
    "HeaterState": {
      "0": "停止",
      "1": "运行"
    },
    "coolFanState": {
      "0": "停止",
      "1": "运行"
    },
    "CoolFanState": {
      "0": "停止",
      "1": "运行"
    },
    "outtWaterPre": {},
    "OuttWaterPre": {},
    "retWaterPre": {},
    "RetWaterPre": {},
    "envTemp": {},
    "EnvTemp": {},
    "unrWaterPumpState": {
      "0": "关",
      "1": "开"
    },
    "UnrWaterPumpState": {
      "0": "关",
      "1": "开"
    },
    "warnFault": {},
    "WarnFault": {},
    "RTargetTemp": {},
    "controlMode": {
      "0": "自动控制",
      "1": "制冷模式",
      "2": "制热模式",
      "3": "水泵循环"
    },
    "ControlMode": {
      "0": "自动控制",
      "1": "制冷模式",
      "2": "制热模式",
      "3": "水泵循环"
    },
    "onOff": {
      "0": "关机",
      "1": "开机"
    },
    "OnOff": {
      "0": "关机",
      "1": "开机"
    },
    "targetTemp": {},
    "TargetTemp": {}
  },
  "STS": {
    "online": {
      "0": "离线",
      "1": "在线"
    },
    "Online": {
      "0": "离线",
      "1": "在线"
    },
    "read_1": {},
    "Read_1": {},
    "read_2": {},
    "Read_2": {},
    "read_3": {},
    "Read_3": {},
    "read_4": {},
    "Read_4": {},
    "read_5": {},
    "Read_5": {},
    "read_6": {},
    "Read_6": {},
    "read_7": {
      "0": "SCR关断",
      "1": "SCR导通"
    },
    "Read_7": {
      "0": "SCR关断",
      "1": "SCR导通"
    },
    "read_8": {
      "0": "断开",
      "1": "闭合"
    },
    "Read_8": {
      "0": "断开",
      "1": "闭合"
    },
    "read_9": {
      "0": "正常",
      "40": "STS故障"
    },
    "Read_9": {
      "0": "正常",
      "40": "STS故障"
    },
    "read_10": {},
    "Read_10": {},
    "read_11": {},
    "Read_11": {},
    "read_12": {},
    "Read_12": {},
    "read_13": {},
    "Read_13": {},
    "read_14": {},
    "Read_14": {},
    "read_15": {},
    "Read_15": {},
    "read_16": {},
    "Read_16": {},
    "read_17": {},
    "Read_17": {},
    "read_18": {},
    "Read_18": {},
    "read_19": {},
    "Read_19": {},
    "read_20": {},
    "Read_20": {},
    "read_21": {},
    "Read_21": {},
    "read_22": {},
    "Read_22": {},
    "read_23": {},
    "Read_23": {},
    "read_24": {},
    "Read_24": {},
    "read_25": {},
    "Read_25": {},
    "read_26": {},
    "Read_26": {},
    "read_27": {},
    "Read_27": {},
    "read_28": {},
    "Read_28": {},
    "read_29": {},
    "Read_29": {},
    "read_30": {},
    "Read_30": {},
    "read_31": {},
    "Read_31": {},
    "read_32": {},
    "Read_32": {},
    "read_33": {},
    "Read_33": {},
    "read_34": {},
    "Read_34": {},
    "read_35": {},
    "Read_35": {},
    "read_36": {},
    "Read_36": {},
    "read_37": {},
    "Read_37": {},
    "read_38": {},
    "Read_38": {},
    "read_39": {},
    "Read_39": {},
    "read_40": {},
    "Read_40": {},
    "read_41": {},
    "Read_41": {},
    "read_42": {},
    "Read_42": {},
    "read_43": {},
    "Read_43": {}
  },
  "DIDO": {
    "online": {
      "0": "离线",
      "1": "在线"
    },
    "Online": {
      "0": "离线",
      "1": "在线"
    },
    "di": {},
    "doField": {},
    "dout": {},
    "NC1": {},
    "NC2": {}
  }
};



// WEBPACK FOOTER //
// ./src/views/BMS/deviceManagement/fieldLabels.js